import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  Interval: `${`[${number | number}` | `(${number | number}` | '('},${`${number | number}]` | `${number | number})` | ')'}`;
  JSON: any;
  UserID: string;
};

export type AcknowledgementItem = {
  completedAt?: Maybe<Scalars['Date']>;
  completedByUser?: Maybe<User>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  policyDocument?: Maybe<PolicyDocument>;
  roadmapStep: RoadmapStep;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  vendorOrganization?: Maybe<VendorOrganization>;
};


export type AcknowledgementItemRoadmapStepArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum AcknowledgementItemStatus {
  Completed = 'Completed',
  Deleted = 'Deleted',
  Pending = 'Pending'
}

export type ActionItem = {
  data?: Maybe<ActionItemMetaData>;
  message: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<ActionItemType>;
};

export type ActionItemMetaData = {
  executiveReport?: Maybe<ExecutiveReport>;
  policyDocument?: Maybe<PolicyDocument>;
  riskAssessment?: Maybe<RiskAssessmentDocument>;
  templateType?: Maybe<PolicyDocumentTemplateType>;
  vendor?: Maybe<Vendor>;
  vendorOrganization?: Maybe<VendorOrganization>;
  vendorRequest?: Maybe<VendorRequest>;
};

export enum ActionItemType {
  ConductPenTest = 'ConductPenTest',
  ConductRiskAssessment = 'ConductRiskAssessment',
  ConductVulnerabilityScan = 'ConductVulnerabilityScan',
  CreateExecutiveReport = 'CreateExecutiveReport',
  HighNumberOfBouncedEmails = 'HighNumberOfBouncedEmails',
  HighPhishPronePercentage = 'HighPhishPronePercentage',
  InfectedDevices = 'InfectedDevices',
  ManageVendorRisks = 'ManageVendorRisks',
  NoPendingTasks = 'NoPendingTasks',
  PendingTasksDue = 'PendingTasksDue',
  PolicyNeedsReview = 'PolicyNeedsReview',
  PolicyNotCreated = 'PolicyNotCreated',
  ResponsePlanNeedsReview = 'ResponsePlanNeedsReview',
  ResponsePlanNotCreated = 'ResponsePlanNotCreated',
  UnresolvedSecurityEvents = 'UnresolvedSecurityEvents',
  UnsupportedOperatingSystems = 'UnsupportedOperatingSystems',
  VendorRequestDenied = 'VendorRequestDenied',
  VendorResponseExpired = 'VendorResponseExpired',
  VendorResponseExpiring = 'VendorResponseExpiring',
  VendorResponseReviewable = 'VendorResponseReviewable',
  PendingTasksNoDate = 'pendingTasksNoDate'
}

export enum ActionTag {
  AddUserToOrganization = 'AddUserToOrganization',
  ArchiveDocument = 'ArchiveDocument',
  ChangeTaskAssignee = 'ChangeTaskAssignee',
  CompleteAcknowledgementItem = 'CompleteAcknowledgementItem',
  CompleteTask = 'CompleteTask',
  CreateDealership = 'CreateDealership',
  CreateDocument = 'CreateDocument',
  CreateDraftEditPolicyDocument = 'CreateDraftEditPolicyDocument',
  CreateDraftExecutiveReport = 'CreateDraftExecutiveReport',
  CreateDraftPolicyDocument = 'CreateDraftPolicyDocument',
  CreateDraftRiskAssessmentDocument = 'CreateDraftRiskAssessmentDocument',
  CreateExecutiveReport = 'CreateExecutiveReport',
  CreatePolicyDocument = 'CreatePolicyDocument',
  CreateRiskAssessmentDocument = 'CreateRiskAssessmentDocument',
  CreateTask = 'CreateTask',
  CreateTaskComment = 'CreateTaskComment',
  CreateVendorRequest = 'CreateVendorRequest',
  DeleteExecutiveReport = 'DeleteExecutiveReport',
  DeleteTaskComment = 'DeleteTaskComment',
  DeleteVendorOrganization = 'DeleteVendorOrganization',
  EditPolicyDocument = 'EditPolicyDocument',
  GenerateDeviceManagementReport = 'GenerateDeviceManagementReport',
  GeneratePhishingSimulationReport = 'GeneratePhishingSimulationReport',
  GenerateRiskAssessmentReport = 'GenerateRiskAssessmentReport',
  GenerateSecurityResponseReport = 'GenerateSecurityResponseReport',
  GenerateSecurityTrainingReport = 'GenerateSecurityTrainingReport',
  Login = 'Login',
  MarkAllRiskTasksComplete = 'MarkAllRiskTasksComplete',
  RemoveDocument = 'RemoveDocument',
  RemoveMember = 'RemoveMember',
  RemovePolicyDocument = 'RemovePolicyDocument',
  RemoveRiskAssessmentDocument = 'RemoveRiskAssessmentDocument',
  RemoveTask = 'RemoveTask',
  ReviewVendorRequest = 'ReviewVendorRequest',
  RevokeTaskCompletion = 'RevokeTaskCompletion',
  RevokeVendorRequestReview = 'RevokeVendorRequestReview',
  SendVendorRequestReminder = 'SendVendorRequestReminder',
  UnassignTask = 'UnassignTask',
  UpdateDealership = 'UpdateDealership',
  UpdateDealershipKeyPersonnel = 'UpdateDealershipKeyPersonnel',
  UpdateDealershipNotificationSettings = 'UpdateDealershipNotificationSettings',
  UpdateDocumentDescription = 'UpdateDocumentDescription',
  UpdateDocumentTitle = 'UpdateDocumentTitle',
  UpdateSelf = 'UpdateSelf',
  UpdateTaskDescription = 'UpdateTaskDescription',
  UpdateTaskDueDate = 'UpdateTaskDueDate',
  UpdateTaskTitle = 'UpdateTaskTitle',
  UpdateVendorOrganization = 'UpdateVendorOrganization'
}

export type AddUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  /** Whether the invited user should become an owner of the organization. Default is false. */
  owner?: InputMaybe<Scalars['Boolean']>;
};

/** Affiliate groups are objects which represent a way for multiple organizations to be associated under an umbrella group. */
export type AffiliateGroup = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** Unique internal database identifier for a single AffiliateGroup. */
  id: Scalars['ID'];
  /** User provided name used to identify the AffiliateGroup. Max 255 characters. Does not need to be unique. */
  name: Scalars['String'];
  /** Organizations that are associated with the affiliate group through AffiliateOrganization */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  updatedAt: Scalars['Date'];
};

/** Paginated Return type for the AffiliateGroup type */
export type AffiliateGroupConnection = {
  nodes?: Maybe<Array<Maybe<AffiliateGroup>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** AffiliateGroups Filters supported */
export type AffiliateGroupFilters = {
  /** IDs of the affiliate_group record(s) to query from the database */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name of the affiliate_group record(s) to query from the database. Searches by a substring anywhere within the name attribute based on the input name string. */
  name?: InputMaybe<Scalars['String']>;
};

/** Supported fields to on Affiliate Group queries */
export enum AffiliateGroupSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type AffiliateOrganization = {
  affiliateGroup: AffiliateGroup;
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  updatedAt: Scalars['Date'];
};

export type AffiliateOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<AffiliateOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum AffiliateOrganizationSortField {
  AffiliateGroupName = 'affiliateGroupName',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrgCif = 'orgCif',
  OrgName = 'orgName'
}

export type AffiliateOrganizationsFilters = {
  /** Name of an associated Affiliate Group is the only filter that is supported by the back-end. */
  affiliateGroupFilters?: InputMaybe<AffiliateGroupFilters>;
  /** Organization CIF and Name are the only filters that are currently supported by the back-end. */
  organizationFilters?: InputMaybe<OrganizationFilters>;
};

export type Answer = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type AnswerInput = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type ApiResponse = {
  apiType: ApiType;
  createdAt?: Maybe<Scalars['Date']>;
  dailyRequestLimitHitAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastUpdatedAt?: Maybe<Scalars['Date']>;
  organization: Organization;
  response?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ApiResponseConnection = {
  nodes?: Maybe<Array<Maybe<ApiResponse>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ApiResponseData = KnowBe4Response | SentinelOneResponse;

export type ApiResponseFilters = {
  apiTypes?: InputMaybe<Array<InputMaybe<ApiType>>>;
  hasHitDailyLimit?: InputMaybe<Scalars['Boolean']>;
};

export enum ApiResponseSortEnum {
  DailyRequestLimitHitAt = 'dailyRequestLimitHitAt',
  LastUpdatedAt = 'lastUpdatedAt',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName'
}

export type ApiResponses = {
  knowBe4?: Maybe<ApiResponse>;
  sentinelOne?: Maybe<ApiResponse>;
};

export enum ApiType {
  KnowBe4 = 'KnowBe4',
  SentinelOne = 'SentinelOne'
}

export enum AppContextType {
  Admin = 'Admin',
  NoUser = 'NoUser',
  OrganizationShadow = 'OrganizationShadow',
  User = 'User',
  UserShadow = 'UserShadow'
}

export enum AutomationReminderCadence {
  Annual = 'Annual',
  None = 'None',
  Quarterly = 'Quarterly',
  Semi = 'Semi'
}

export type CheckRiskRegistryAnswerInput = {
  organizationId: Scalars['ID'];
  type: QuestionType;
};

export type CheckRiskRegistryAnswerOutput = {
  answers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  hasNoAnswers: Scalars['Boolean'];
  isSilenced: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};

export enum CognitoScope {
  AdminRead = 'adminRead',
  AdminWrite = 'adminWrite',
  Fallback = 'fallback'
}

export type ConsumerFinancialData = {
  creditData: Scalars['Boolean'];
  employeeHistory: Scalars['Boolean'];
  financialAccountNumbers: Scalars['Boolean'];
  income: Scalars['Boolean'];
  paymentData: Scalars['Boolean'];
};

export type ConsumerFinancialDataInput = {
  creditData: Scalars['Boolean'];
  employeeHistory: Scalars['Boolean'];
  financialAccountNumbers: Scalars['Boolean'];
  income: Scalars['Boolean'];
  paymentData: Scalars['Boolean'];
};

export type ConsumerIdentityData = {
  emailAddress: Scalars['Boolean'];
  homeAddress: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type ConsumerIdentityDataInput = {
  emailAddress: Scalars['Boolean'];
  homeAddress: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type CreateAllRegisteredRisksInput = {
  organizationId: Scalars['ID'];
};

export type CreateCustomNotificationDraftInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  organizationIds: Array<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type CreateDocumentByGuidInput = {
  expiresAt: Scalars['Date'];
  fileExtension: DocumentFileExtension;
  s3ObjectKey: Scalars['String'];
  title: Scalars['String'];
};

export type CreateDocumentInput = {
  category: DocumentCategory;
  conductedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl: Scalars['String'];
  expiresAt: Scalars['Date'];
  organizationIds: Array<Scalars['ID']>;
  title: Scalars['String'];
  vendorParams?: InputMaybe<VendorRiskDocumentInput>;
};

export type CreateEditedPolicyDocumentInput = {
  colorHex?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  footer?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  sections?: InputMaybe<Array<SectionInput>>;
  sourcePolicyDocumentId: Scalars['ID'];
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateExecutiveReportInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: Array<InputMaybe<ExecutiveReportSectionInput>>;
  title: Scalars['String'];
};

export type CreateNavigationEventInput = {
  fromPathname?: InputMaybe<Scalars['String']>;
  toPathname: Scalars['String'];
};

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreatePolicyDocumentInput = {
  colorHex?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  footer?: InputMaybe<Scalars['String']>;
  iconImageUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: Array<SectionInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  templateTitle: Scalars['String'];
  templateType: PolicyDocumentTemplateType;
  title: Scalars['String'];
};

export type CreateRegisteredRiskInput = {
  description: Scalars['String'];
  functionCategory: Scalars['String'];
  organizationId: Scalars['ID'];
  rating: Scalars['String'];
  title: Scalars['String'];
};

export type CreateRiskAssessmentInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: RiskAssessmentSectionsInput;
};

export type CreateRiskCommentInput = {
  registeredRiskId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateTaskCommentInput = {
  taskId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateVendorRequestInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  sharedData?: InputMaybe<SharedDataInput>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type CreateVendorRiskByGuidInput = {
  data?: InputMaybe<VendorRiskResponseDataInput>;
};

export type CustomNotification = {
  createdAt: Scalars['Date'];
  createdBy: User;
  dealerships: Array<Organization>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recipients: CustomNotificationRecipientConnection;
  sentAt?: Maybe<Scalars['Date']>;
  sentBy?: Maybe<User>;
  status: CustomNotificationStatus;
  updatedAt: Scalars['Date'];
  vendor?: Maybe<Vendor>;
};


export type CustomNotificationRecipientsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
};

export type CustomNotificationConnection = {
  nodes?: Maybe<Array<Maybe<CustomNotification>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomNotificationRecipient = {
  createdAt: Scalars['Date'];
  customNotification: CustomNotification;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  organization: Organization;
  user?: Maybe<User>;
};

export type CustomNotificationRecipientConnection = {
  nodes?: Maybe<Array<Maybe<CustomNotificationRecipient>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum CustomNotificationStatus {
  Draft = 'Draft',
  Sent = 'Sent'
}

export type DateFilter = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type DateRange = {
  max?: InputMaybe<Scalars['Date']>;
  min?: InputMaybe<Scalars['Date']>;
};

export type DealershipRequestMeta = {
  shareAll?: Maybe<Scalars['Boolean']>;
  shareList?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shareOne?: Maybe<Scalars['Boolean']>;
};

export type DealershipRequestMetaInput = {
  shareAll?: InputMaybe<Scalars['Boolean']>;
  shareList?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shareOne?: InputMaybe<Scalars['Boolean']>;
};

export type Document = {
  archivedAt?: Maybe<Scalars['Date']>;
  category: DocumentCategory;
  conductedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  expiresAt: Scalars['Date'];
  fileExtension?: Maybe<DocumentFileExtension>;
  id: Scalars['ID'];
  organizations?: Maybe<Array<Maybe<Organization>>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  uploadedByUser?: Maybe<User>;
};


export type DocumentOrganizationsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum DocumentCategory {
  Other = 'OTHER',
  PenetrationTest = 'PENETRATION_TEST',
  PolicyDocument = 'POLICY_DOCUMENT',
  RiskAssessment = 'RISK_ASSESSMENT',
  RiskReport = 'RISK_REPORT',
  VendorRisk = 'VENDOR_RISK',
  VulnerabilityScan = 'VULNERABILITY_SCAN'
}

export type DocumentConnection = {
  nodes?: Maybe<Array<Maybe<Document>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum DocumentFieldSortFieldEnum {
  ConductedAt = 'conductedAt',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  Title = 'title'
}

export enum DocumentFileExtension {
  Csv = 'csv',
  Doc = 'doc',
  Docx = 'docx',
  Pdf = 'pdf'
}

export type DocumentFilters = {
  categories?: InputMaybe<Array<InputMaybe<DocumentCategory>>>;
  conductedAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type DocumentOrganization = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  document?: Maybe<Document>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type DocumentOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<DocumentOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum DocumentOrganizationSortFieldEnum {
  Cif = 'cif',
  Id = 'id',
  Name = 'name'
}

export type DocumentUser = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  document: Document;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
  uploadedByUser?: Maybe<User>;
};

export type Endpoint = {
  deviceType: SentinelOneDeviceType;
  infected: Scalars['Boolean'];
  ipAddress: Scalars['String'];
  name: Scalars['String'];
  osStatus: OsSupportStatus;
  osVersion: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
};

export type EnrolledUser = {
  email: Scalars['String'];
  enrolledAt: Scalars['Date'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  status: EnrolledUserStatus;
};

/**
 * Enrolled User status as defined by the KnowBe4 API documentation with spaces
 * in the values replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a KnowBe4 schema change.
 */
export enum EnrolledUserStatus {
  Completed = 'COMPLETED',
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Passed = 'PASSED',
  PastDue = 'PAST_DUE'
}

export type ExecutiveReport = {
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUser?: Maybe<User>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  organization: Organization;
  pdfUrl?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<ExecutiveReportSection>>>;
  sourceExecutiveReportId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};


export type ExecutiveReportOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ExecutiveReportConnection = {
  nodes?: Maybe<Array<Maybe<ExecutiveReport>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ExecutiveReportFieldSortField {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName'
}

export type ExecutiveReportFilters = {
  isDraft?: InputMaybe<Scalars['Boolean']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ExecutiveReportMetricsSectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metricsSections?: Maybe<Array<Maybe<MetricsSection>>>;
  templateHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ExecutiveReportSection = {
  createdAt?: Maybe<Scalars['Date']>;
  data?: Maybe<Scalars['JSON']>;
  executiveReport?: Maybe<ExecutiveReport>;
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ExecutiveReportSectionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  isComplete: Scalars['Boolean'];
};

export type ExecutiveReportSectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  templateHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ExecutiveReportSections = {
  additionalIssues?: Maybe<ExecutiveReportSectionTemplate>;
  customSections?: Maybe<Array<Maybe<ExecutiveReportSectionTemplate>>>;
  ftcComplianceOverview?: Maybe<ExecutiveReportSectionTemplate>;
  introduction?: Maybe<ExecutiveReportSectionTemplate>;
  keyRiskManagementActivities?: Maybe<ExecutiveReportSectionTemplate>;
  riskAssessmentResults?: Maybe<ExecutiveReportSectionTemplate>;
  securityMetrics?: Maybe<ExecutiveReportMetricsSectionTemplate>;
  vendorOversightStatus?: Maybe<ExecutiveReportSectionTemplate>;
};

export type ExecutiveReportTemplate = {
  sections?: Maybe<ExecutiveReportSections>;
};

export enum FunctionCategory {
  Analysis = 'Analysis',
  AnomaliesAndEvents = 'AnomaliesAndEvents',
  AssetManagement = 'AssetManagement',
  AwarenessAndTraining = 'AwarenessAndTraining',
  BusinessEnvironment = 'BusinessEnvironment',
  DataSecurity = 'DataSecurity',
  DetectionProcess = 'DetectionProcess',
  Governance = 'Governance',
  IdentityManagement = 'IdentityManagement',
  InformationProtection = 'InformationProtection',
  Maintenance = 'Maintenance',
  Mitigation = 'Mitigation',
  ProtectiveTechnology = 'ProtectiveTechnology',
  RecoveryCommunications = 'RecoveryCommunications',
  RecoveryImprovements = 'RecoveryImprovements',
  RecoveryPlanning = 'RecoveryPlanning',
  ResponseCommunications = 'ResponseCommunications',
  ResponseImprovements = 'ResponseImprovements',
  ResponsePlanning = 'ResponsePlanning',
  RiskAssessment = 'RiskAssessment',
  RiskManagementStrategy = 'RiskManagementStrategy',
  SecurityContinuousMonitoring = 'SecurityContinuousMonitoring',
  SupplyChainRiskManagement = 'SupplyChainRiskManagement'
}

export type GetCompletedSectionMapOutput = {
  AccessManagement: Scalars['Boolean'];
  BusinessAndCompliance: Scalars['Boolean'];
  DeviceManagement: Scalars['Boolean'];
  EmailSecurity: Scalars['Boolean'];
  EndpointSecurity: Scalars['Boolean'];
  NetworkManagement: Scalars['Boolean'];
};

export type KeyPersonnel = {
  name: Scalars['String'];
  title: Scalars['String'];
};

export type KeyPersonnelInput = {
  name: Scalars['String'];
  title: Scalars['String'];
};

export type KnowBe4Response = {
  phishing: Array<Maybe<PhishingCampaign>>;
  training: Array<Maybe<TrainingCampaign>>;
  users: Array<Maybe<KnowBe4User>>;
};

export type KnowBe4User = {
  archivedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  joinedAt: Scalars['Date'];
  lastName: Scalars['String'];
};

export type LastVendorRequest = {
  request?: Maybe<VendorOrganization>;
  vendorId: Scalars['ID'];
};

export type Location = {
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export enum MailingRecipientSortField {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type Metric = {
  code: Scalars['String'];
  format?: Maybe<MetricFormat>;
  ratings: Array<Maybe<MetricRatingScale>>;
  title: Scalars['String'];
};

export enum MetricFormat {
  Number = 'Number',
  Percent = 'Percent'
}

export enum MetricRating {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type MetricRatingScale = {
  range: Scalars['Interval'];
  rating: MetricRating;
};

export type MetricsSection = {
  code: Scalars['String'];
  metrics?: Maybe<Array<Maybe<Metric>>>;
  title: Scalars['String'];
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']>;
  /** Adds a user to a given organization */
  addUserToOrganization?: Maybe<User>;
  /** Assign a task to a user with id assigneeId */
  assignTask: Task;
  /** Creates the risks based on the action items from the roadmap when a user logs in. */
  createActionItemRisks?: Maybe<Organization>;
  /** Creates all registered risks based on the answers of an organization when this mutation is called. */
  createAllRegisteredRisks: Array<Maybe<RegisteredRisk>>;
  /** Creates a document */
  createDocument?: Maybe<Document>;
  /** Creates a document using a GUID for verification */
  createDocumentByGuid?: Maybe<Document>;
  /** Creates an edited policy document */
  createEditedPolicyDocument?: Maybe<PolicyDocument>;
  /** Create an executive report for the given organization */
  createExecutiveReport?: Maybe<ExecutiveReport>;
  /** Creates a navigation event given the from and to pathname for the given navigation event */
  createNavigationEvent?: Maybe<NavigationEvent>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /** Creates a policy document */
  createPolicyDocument?: Maybe<PolicyDocument>;
  /** Create a new risk registry record with the information sent. */
  createRegisteredRisk: RegisteredRisk;
  /** Create a new risk with the information sent. */
  createRisk?: Maybe<Risk>;
  /** Creates a risk assessment document */
  createRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Create a new risk comment with the information sent. */
  createRiskComment: RiskComment;
  createRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Create a new task */
  createTask: Task;
  /** Add a new comment to a given task */
  createTaskComment?: Maybe<TaskComment>;
  /** Creates a vendorRequest */
  createVendorRequest?: Maybe<VendorRequest>;
  /** Create a new vendor risk with the information sent. Verification is provided via guid. */
  createVendorRiskByGuid?: Maybe<VendorRisk>;
  /** Delete a registeredRisk */
  deleteRegisteredRisk: RegisteredRisk;
  /** Deletes a risk comment record. */
  deleteRiskComment: RiskComment;
  /** Remove a comment from a given task */
  deleteTaskComment?: Maybe<TaskComment>;
  /** Deletes a vendor organization and places it in the deleted status. */
  deleteVendorOrganization?: Maybe<VendorOrganization>;
  /** Edits an existing policy document */
  editPolicyDocument?: Maybe<PolicyDocument>;
  /** Remove an uploaded document given its ID. */
  removeDocument?: Maybe<Document>;
  /** Deletes an executive report for the given organization */
  removeExecutiveReport?: Maybe<ExecutiveReport>;
  /** Removes the connection between the user with *userId* from the organization with *organizationId* */
  removeMember?: Maybe<UserOrganization>;
  /** Deletes a policy documents */
  removePolicyDocument?: Maybe<PolicyDocument>;
  /** Deletes a risk assessment document */
  removeRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  removeRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Delete a task, associated to a risk. */
  removeTask?: Maybe<Task>;
  /** Send vendor request reminder email */
  sendVendorRequestReminderEmail?: Maybe<VendorRequest>;
  /** Set an acknowledgement item pending or complete given the acknowledgement item id and new status. */
  setAcknowledgementItemStatus?: Maybe<AcknowledgementItem>;
  /** Set the description of a task */
  setDescriptionTask: Task;
  /** Sets the archivedAt of a document. Will overwrite previous archivedAt. */
  setDocumentArchivedAt?: Maybe<Document>;
  /** Sets the description of a document. Will overwrite previous description. */
  setDocumentDescription?: Maybe<Document>;
  /** Sets the title of a document. Will overwrite previous title. */
  setDocumentTitle?: Maybe<Document>;
  /** Set the due date of a task */
  setDueDateTask: Task;
  /** Set the completion status of a task */
  setTaskCompletionStatus: Task;
  /** Set the completion status of all the Risk's tasks */
  setTasksCompletionStatus?: Maybe<Risk>;
  /** Set the title of a task */
  setTitleTask: Task;
  /** Set the status of a vendor request */
  setVendorRequestReviewStatus?: Maybe<VendorRequest>;
  /** System-level mutation to create a new AffiliateOrganization record. Only works with user tokens that include the admin:write scope. */
  systemAddAffiliateOrganization?: Maybe<AffiliateOrganization>;
  /** Adds a user to a given organization. Only works with API tokens with the admin:write scope. */
  systemAddUserToOrganization?: Maybe<User>;
  /** System-level mutation to create a new Affiliate Group. Only works with user tokens that include the admin:write scope. */
  systemCreateAffiliateGroup?: Maybe<AffiliateGroup>;
  /** Create a new custom notification draft. Requires admin:write scope. */
  systemCreateCustomNotificationDraft: CustomNotification;
  /** Creates a document. Only works with admin:write scope */
  systemCreateDocument?: Maybe<Document>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates organization_mailing_recipient records when given a recipient and an organizationId. Requires a jwt with admin:write scope. */
  systemCreateOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Create a new risk registry record with the information sent. Only works with API tokens with admin:write scope */
  systemCreateRegisteredRisk: RegisteredRisk;
  /** Create a new risk with the information sent. Only works with API tokens with the admin:write scope */
  systemCreateRisk?: Maybe<Risk>;
  /** Creates a risk assessment document. Only works with admin:write scope */
  systemCreateRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Create a new task from global. Only works with  with API tokens with the system:write scope */
  systemCreateTask?: Maybe<Task>;
  /** Creates a new vendor in the system. Only works with tokens containing the admin:write scope. */
  systemCreateVendor?: Maybe<Vendor>;
  /** Deactivates the organization by setting arhivedAt date to the organization and associations. Requires a jwt with admin:write scope. */
  systemDeactivateOrganization?: Maybe<Organization>;
  /** Delete a custom notification draft. Requires admin:write scope. */
  systemDeleteCustomNotificationDraft: Scalars['Boolean'];
  /** Deletes the organization with *id* from the system. Requires a jwt with admin:write scope. */
  systemDeleteOrganization?: Maybe<Organization>;
  /** Delete a risk registry record. Only works with API tokens with admin:write scope */
  systemDeleteRegisteredRisk: RegisteredRisk;
  /** Deletes the user with the provided id */
  systemDeleteUser?: Maybe<User>;
  /** Reactivates the organization by setting arhivedAt to null on the organization and associations. Requires a jwt with admin:write scope. */
  systemReactivateOrganization?: Maybe<Organization>;
  /** System-level mutation to remove an Affiliate Group given the ID of the affiliate_groups record. Only works with user tokens that include the admin:write scope. */
  systemRemoveAffiliateGroup?: Maybe<AffiliateGroup>;
  /** System-level mutation to remove a AffiliateOrganization record. Only works with user tokens that include the admin:write scope. */
  systemRemoveAffiliateOrganization?: Maybe<AffiliateOrganization>;
  /** Removes the connection between the user with *userId* from the organization with *organizationId*, works with a jwt with admin:write scope */
  systemRemoveMember?: Maybe<UserOrganization>;
  /** Removes organization_mailing_recipient records when given the ID of the mailingRecipient. Requires a jwt with admin:write scope. */
  systemRemoveOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Remove a risk with the global scope. Only works with admin:write scope */
  systemRemoveRisk?: Maybe<Risk>;
  /** Deletes a risk assessment document. Only works with API tokens with the admin:write scope */
  systemRemoveRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** This mutation will be responsible for removing any shadow entity record associated with the called user. Requires a jwt with admin:write scope. */
  systemRemoveShadowEntity?: Maybe<UserShadowEntity>;
  /** Delete a task from global. Only works with  with API tokens with the system:write scope. */
  systemRemoveTask?: Maybe<Task>;
  /** Removes a vendor risk from the system and the associated vendor risk organizations. Only works with tokens containing the admin:write scope */
  systemRemoveVendorRisk?: Maybe<VendorRisk>;
  /** Send a custom notification to all recipients in the selected dealerships. Requires admin:write scope. */
  systemSendCustomNotification: CustomNotification;
  /** Update support status of an OperatingSystem. Only works with tokens containing the adminScopes.adminWrite scope. */
  systemSetOperatingSystemSupportStatus?: Maybe<OperatingSystem>;
  /** Set the sections on a risk assessment document. Only works with API tokens with the admin:write scope */
  systemSetRiskAssessmentAnswers?: Maybe<RiskAssessmentDocument>;
  /** Set document completion status. Only works with API tokens with the admin:write scope */
  systemSetRiskAssessmentDocumentCompletionStatus?: Maybe<RiskAssessmentDocument>;
  /**
   * This mutation will update the user_shadow_entities record associated with
   * the calling user by setting the shadowType to Organization and shadowEntityId
   * to the provided organization ID.
   */
  systemSetShadowOrganization?: Maybe<UserShadowEntity>;
  /** This mutation will update the user_shadow_entities record associated with the calling user by setting the shadowType to User and shadowEntityId to the provided user ID. */
  systemSetShadowUser?: Maybe<UserShadowEntity>;
  /** Set the vendor risk assessment url authenticated as an admin */
  systemSetVendorRiskAssessmentUrl?: Maybe<VendorRisk>;
  /** Set the expiration timestamp for a vendor risk given the ID. Only works with tokens containing the admin:write scope */
  systemSetVendorRiskExpiredAt?: Maybe<VendorRisk>;
  /** System-level mutation to update an Affiliate Group given the ID of the affiliate_groups record and update input. Only works with user tokens that include the admin:write scope. */
  systemUpdateAffiliateGroup?: Maybe<AffiliateGroup>;
  /** Update an existing custom notification draft. Requires admin:write scope. */
  systemUpdateCustomNotificationDraft: CustomNotification;
  /** Updates the document. Only works with admin:write scope */
  systemUpdateDocument?: Maybe<Document>;
  /** Updates the organization knowBe4ApiKey with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateKnowBe4ApiKey?: Maybe<Organization>;
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates the organization by setting the accountType value on the organization. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationAccountType?: Maybe<Organization>;
  /** Updates the organization billingStartedAt with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationBillingStartedAt?: Maybe<Organization>;
  /** Updates an OrganizationMailingRecipient. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Updates the organization modalsMutedAt with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationModalsMutedAt?: Maybe<Organization>;
  /** Updates the notification_settings records for the provided organizationId. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationNotificationSettings?: Maybe<Organization>;
  /** Update an existing risk registry record with the information sent. Only works with API tokens with admin:write scope */
  systemUpdateRegisteredRisk: RegisteredRisk;
  /** Update a risk with the information sent. Only works with API tokens with the admin:write scope */
  systemUpdateRisk?: Maybe<Risk>;
  /** Updates a riskTemplate record with given input */
  systemUpdateRiskTemplate: RiskTemplate;
  /** Updates the organization sentinelOneSiteId with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateSentinelOneSiteId?: Maybe<Organization>;
  /** Update a new task from global. Only works with with API tokens with the system:write scope */
  systemUpdateTask?: Maybe<Task>;
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  /** Updates the role of a user-organization by taking in a userOrganizationId and a role to update the role of the user organization. */
  systemUpdateUserOrganizationRole?: Maybe<UserOrganization>;
  /** Updates a user's cognito scopes. Only works with API tokens with the admin:write scope. */
  systemUpdateUserPortalAccessRole?: Maybe<User>;
  /** Updates the vendor businessAddress given an ID and businessAddress. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorAddress?: Maybe<Vendor>;
  /** Updates the vendor defaultContact given an ID and contactEmail. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorDefaultContact?: Maybe<Vendor>;
  /** Updates the vendor name given an ID and name. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorName?: Maybe<Vendor>;
  /** Updates the organization's settings regarding risk automation and reminder cadence. */
  updateAutomationSettings?: Maybe<Organization>;
  /** Updates the keyPersonnel of the organization. */
  updateKeyPersonnel?: Maybe<Organization>;
  updateMe?: Maybe<User>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /** Updates the notification_settings records for the provided organizationId */
  updateOrganizationNotificationSettings?: Maybe<Organization>;
  /** Update an existing risk registry record with the information sent. */
  updateRegisteredRisk: RegisteredRisk;
  /** Set the acceptedAt timestamp of a registeredRisk */
  updateRegisteredRiskAcceptedAt: RegisteredRisk;
  /** Set the resolvedAt timestamp of a registeredRisk */
  updateRegisteredRiskResolvedAt: RegisteredRisk;
  /**
   * Sends a heartbeat to the API with the organization and the time that the heartbeat was sent. Since this is fire-and-forget,
   * we won't check for a return but could with a simple boolean of whether it was recieved or not.
   */
  updateRiskHeartbeatRecords: Scalars['Boolean'];
  updateRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Updates the vendor organization with *id* using the passed params */
  updateVendorOrganization?: Maybe<VendorOrganization>;
  /** Update an existing vendor risk with the information sent. Verification is provided via guid. */
  updateVendorRiskByGuid?: Maybe<VendorRisk>;
};


export type MutationAddUserToOrganizationArgs = {
  userParams: AddUserInput;
};


export type MutationAssignTaskArgs = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  taskId: Scalars['ID'];
};


export type MutationCreateActionItemRisksArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAllRegisteredRisksArgs = {
  input?: InputMaybe<CreateAllRegisteredRisksInput>;
};


export type MutationCreateDocumentArgs = {
  documentParams?: InputMaybe<CreateDocumentInput>;
};


export type MutationCreateDocumentByGuidArgs = {
  documentParams: CreateDocumentByGuidInput;
  guid: Scalars['String'];
};


export type MutationCreateEditedPolicyDocumentArgs = {
  editPolicyDocumentParams?: InputMaybe<CreateEditedPolicyDocumentInput>;
};


export type MutationCreateExecutiveReportArgs = {
  executiveReportParams?: InputMaybe<CreateExecutiveReportInput>;
};


export type MutationCreateNavigationEventArgs = {
  input?: InputMaybe<CreateNavigationEventInput>;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreatePolicyDocumentArgs = {
  policyDocumentParams?: InputMaybe<CreatePolicyDocumentInput>;
};


export type MutationCreateRegisteredRiskArgs = {
  input?: InputMaybe<CreateRegisteredRiskInput>;
};


export type MutationCreateRiskArgs = {
  input?: InputMaybe<RiskInput>;
};


export type MutationCreateRiskAssessmentDocumentArgs = {
  riskAssessmentParams?: InputMaybe<CreateRiskAssessmentInput>;
};


export type MutationCreateRiskCommentArgs = {
  input?: InputMaybe<CreateRiskCommentInput>;
};


export type MutationCreateRiskRegistryAnswersArgs = {
  answers: Array<InputMaybe<RiskRegistryAnswerInput>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type MutationCreateTaskArgs = {
  task?: InputMaybe<TaskInput>;
};


export type MutationCreateTaskCommentArgs = {
  taskCommentParams?: InputMaybe<CreateTaskCommentInput>;
};


export type MutationCreateVendorRequestArgs = {
  vendorRequestParams?: InputMaybe<CreateVendorRequestInput>;
};


export type MutationCreateVendorRiskByGuidArgs = {
  guid: Scalars['String'];
  vendorRisk?: InputMaybe<CreateVendorRiskByGuidInput>;
};


export type MutationDeleteRegisteredRiskArgs = {
  registeredRiskId: Scalars['ID'];
};


export type MutationDeleteRiskCommentArgs = {
  riskCommentId: Scalars['ID'];
};


export type MutationDeleteTaskCommentArgs = {
  taskCommentRemovalParams?: InputMaybe<RemoveTaskCommentInput>;
};


export type MutationDeleteVendorOrganizationArgs = {
  vendorOrganizationId: Scalars['ID'];
};


export type MutationEditPolicyDocumentArgs = {
  policyDocumentParams?: InputMaybe<UpdatePolicyDocumentInput>;
};


export type MutationRemoveDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveExecutiveReportArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveMemberArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
};


export type MutationRemovePolicyDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRiskRegistryAnswersArgs = {
  answerIds: Array<InputMaybe<Scalars['ID']>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveTaskArgs = {
  id: Scalars['ID'];
  riskId: Scalars['ID'];
};


export type MutationSendVendorRequestReminderEmailArgs = {
  vendorRequestId: Scalars['ID'];
};


export type MutationSetAcknowledgementItemStatusArgs = {
  id: Scalars['ID'];
  status?: InputMaybe<AcknowledgementItemStatus>;
};


export type MutationSetDescriptionTaskArgs = {
  description?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationSetDocumentArchivedAtArgs = {
  archivedAt: Scalars['Date'];
  id: Scalars['ID'];
};


export type MutationSetDocumentDescriptionArgs = {
  description: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationSetDocumentTitleArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationSetDueDateTaskArgs = {
  date?: InputMaybe<Scalars['Date']>;
  taskId: Scalars['ID'];
};


export type MutationSetTaskCompletionStatusArgs = {
  isComplete: Scalars['Boolean'];
  taskId: Scalars['ID'];
};


export type MutationSetTasksCompletionStatusArgs = {
  isComplete: Scalars['Boolean'];
  riskId: Scalars['ID'];
};


export type MutationSetTitleTaskArgs = {
  taskId: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationSetVendorRequestReviewStatusArgs = {
  isReviewed: Scalars['Boolean'];
  vendorRequestId: Scalars['ID'];
};


export type MutationSystemAddAffiliateOrganizationArgs = {
  input?: InputMaybe<SystemAffiliateOrganizationInput>;
};


export type MutationSystemAddUserToOrganizationArgs = {
  userParams: AddUserInput;
};


export type MutationSystemCreateAffiliateGroupArgs = {
  input: SystemAffiliateGroupInput;
};


export type MutationSystemCreateCustomNotificationDraftArgs = {
  input: CreateCustomNotificationDraftInput;
};


export type MutationSystemCreateDocumentArgs = {
  documentParams?: InputMaybe<CreateDocumentInput>;
};


export type MutationSystemCreateOrganizationArgs = {
  organization?: InputMaybe<SystemOrganizationInput>;
};


export type MutationSystemCreateOrganizationMailingRecipientArgs = {
  organizationId: Scalars['ID'];
  recipient: SystemOrganizationMailingRecipient;
};


export type MutationSystemCreateRegisteredRiskArgs = {
  input?: InputMaybe<CreateRegisteredRiskInput>;
};


export type MutationSystemCreateRiskArgs = {
  input?: InputMaybe<RiskInput>;
};


export type MutationSystemCreateRiskAssessmentDocumentArgs = {
  riskAssessmentParams?: InputMaybe<CreateRiskAssessmentInput>;
};


export type MutationSystemCreateTaskArgs = {
  task: TaskInput;
};


export type MutationSystemCreateVendorArgs = {
  vendorParams?: InputMaybe<SystemCreateVendorInput>;
};


export type MutationSystemDeactivateOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteCustomNotificationDraftArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteRegisteredRiskArgs = {
  registeredRiskId: Scalars['ID'];
};


export type MutationSystemDeleteUserArgs = {
  id: Scalars['UserID'];
};


export type MutationSystemReactivateOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveAffiliateGroupArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveAffiliateOrganizationArgs = {
  affiliateOrganizationId: Scalars['ID'];
};


export type MutationSystemRemoveMemberArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
};


export type MutationSystemRemoveOrganizationMailingRecipientArgs = {
  mailingRecipientId: Scalars['ID'];
};


export type MutationSystemRemoveRiskArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveShadowEntityArgs = {
  userId: Scalars['UserID'];
};


export type MutationSystemRemoveTaskArgs = {
  id: Scalars['ID'];
  riskId: Scalars['ID'];
};


export type MutationSystemRemoveVendorRiskArgs = {
  id: Scalars['ID'];
};


export type MutationSystemSendCustomNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemSetOperatingSystemSupportStatusArgs = {
  id: Scalars['ID'];
  status: OsSupportStatus;
};


export type MutationSystemSetRiskAssessmentAnswersArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  sections: RiskAssessmentSectionsInput;
};


export type MutationSystemSetRiskAssessmentDocumentCompletionStatusArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  status: RiskAssessmentStatus;
};


export type MutationSystemSetShadowOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemSetShadowUserArgs = {
  userId: Scalars['UserID'];
};


export type MutationSystemSetVendorRiskAssessmentUrlArgs = {
  assessmentUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationSystemSetVendorRiskExpiredAtArgs = {
  expiredAt?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};


export type MutationSystemUpdateAffiliateGroupArgs = {
  id: Scalars['ID'];
  input: UpdateAffiliateGroupInput;
};


export type MutationSystemUpdateCustomNotificationDraftArgs = {
  id: Scalars['ID'];
  input: UpdateCustomNotificationDraftInput;
};


export type MutationSystemUpdateDocumentArgs = {
  input: UpdateSystemDocumentInput;
};


export type MutationSystemUpdateKnowBe4ApiKeyArgs = {
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdateOrganizationAccountTypeArgs = {
  accountType: OrganizationAccountType;
  id: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationBillingStartedAtArgs = {
  billingStartedAt?: InputMaybe<Scalars['Date']>;
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationMailingRecipientArgs = {
  input: UpdateSystemOrganizationMailingRecipientInput;
};


export type MutationSystemUpdateOrganizationModalsMutedAtArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
};


export type MutationSystemUpdateRegisteredRiskArgs = {
  input?: InputMaybe<UpdateRegisteredRiskInput>;
};


export type MutationSystemUpdateRiskArgs = {
  input?: InputMaybe<UpdateSystemRiskInput>;
};


export type MutationSystemUpdateRiskTemplateArgs = {
  input?: InputMaybe<UpdateRiskTemplateInput>;
};


export type MutationSystemUpdateSentinelOneSiteIdArgs = {
  organizationId: Scalars['ID'];
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
};


export type MutationSystemUpdateTaskArgs = {
  task: UpdateSystemTaskInput;
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationSystemUpdateUserOrganizationRoleArgs = {
  role: UserOrganizationRole;
  userOrganizationId: Scalars['ID'];
};


export type MutationSystemUpdateUserPortalAccessRoleArgs = {
  accessRoles?: InputMaybe<Array<InputMaybe<CognitoScope>>>;
  id: Scalars['UserID'];
};


export type MutationSystemUpdateVendorAddressArgs = {
  businessAddress?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type MutationSystemUpdateVendorDefaultContactArgs = {
  contactEmail?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type MutationSystemUpdateVendorNameArgs = {
  businessName: Scalars['String'];
  vendorId: Scalars['ID'];
};


export type MutationUpdateAutomationSettingsArgs = {
  automationSettings: UpdateAutomationSettingsInput;
  id: Scalars['ID'];
};


export type MutationUpdateKeyPersonnelArgs = {
  input: UpdateKeyPersonnelInput;
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdateOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
};


export type MutationUpdateRegisteredRiskArgs = {
  input?: InputMaybe<UpdateRegisteredRiskInput>;
};


export type MutationUpdateRegisteredRiskAcceptedAtArgs = {
  date?: InputMaybe<Scalars['Date']>;
  registeredRiskId: Scalars['ID'];
};


export type MutationUpdateRegisteredRiskResolvedAtArgs = {
  date?: InputMaybe<Scalars['Date']>;
  registeredRiskId: Scalars['ID'];
};


export type MutationUpdateRiskHeartbeatRecordsArgs = {
  organizationIds: Array<InputMaybe<Scalars['ID']>>;
  sentAt: Scalars['Date'];
};


export type MutationUpdateRiskRegistryAnswersArgs = {
  answers: Array<InputMaybe<UpdateRiskRegistryAnswerInput>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type MutationUpdateVendorOrganizationArgs = {
  updateVendorOrganizationParams: UpdateVendorOrganizationInput;
};


export type MutationUpdateVendorRiskByGuidArgs = {
  guid: Scalars['String'];
  vendorRisk?: InputMaybe<UpdateVendorRiskByGuidInput>;
};

export type NdaMeta = {
  acceptedAt?: Maybe<Scalars['Date']>;
};

export type NdaMetaInput = {
  acceptedAt?: InputMaybe<Scalars['Date']>;
};

export type NavigationEvent = {
  contextType: AppContextType;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  fromPathname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  toPathname: Scalars['String'];
  user: User;
};

export type NavigationEventConnection = {
  nodes?: Maybe<Array<Maybe<NavigationEvent>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NavigationEventFilters = {
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  createdAt?: InputMaybe<DateRange>;
  fromPathname?: InputMaybe<Scalars['String']>;
  toPathname?: InputMaybe<Scalars['String']>;
};

export enum NavigationEventSortField {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export enum NotificationFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Realtime = 'Realtime',
  Weekly = 'Weekly'
}

export type NotificationSetting = {
  createdAt: Scalars['Date'];
  enabled: Scalars['Boolean'];
  frequency: NotificationFrequency;
  id: Scalars['ID'];
  notificationType: NotificationType;
  organization: Organization;
  sendTo: Array<Maybe<SendTo>>;
  updatedAt: Scalars['Date'];
};

export type NotificationSettingInput = {
  enabled: Scalars['Boolean'];
  frequency: NotificationFrequency;
  notificationType: NotificationType;
  sendTo: Array<InputMaybe<SendTo>>;
};

export type NotificationSettings = {
  deviceManagementReport?: Maybe<NotificationSetting>;
  documentUpload?: Maybe<NotificationSetting>;
  pendingActionItemsReport?: Maybe<NotificationSetting>;
  securityResponseReport?: Maybe<NotificationSetting>;
  trainingAndPhishingReport?: Maybe<NotificationSetting>;
};

export type NotificationSettingsInput = {
  deviceManagementReport?: InputMaybe<NotificationSettingInput>;
  documentUpload?: InputMaybe<NotificationSettingInput>;
  pendingActionItemsReport?: InputMaybe<NotificationSettingInput>;
  securityResponseReport?: InputMaybe<NotificationSettingInput>;
  trainingAndPhishingReport?: InputMaybe<NotificationSettingInput>;
};

export enum NotificationType {
  DeviceManagementReport = 'DeviceManagementReport',
  DocumentUpload = 'DocumentUpload',
  PendingActionItemsReport = 'PendingActionItemsReport',
  SecurityResponseReport = 'SecurityResponseReport',
  TrainingAndPhishingReport = 'TrainingAndPhishingReport'
}

export type OperatingSystem = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  revision?: Maybe<Scalars['String']>;
  status: OsSupportStatus;
  updatedAt: Scalars['Date'];
};

export type OperatingSystemConnection = {
  nodes?: Maybe<Array<Maybe<OperatingSystem>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OperatingSystemFilters = {
  name?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<OsSupportStatus>>>;
};

export enum OperatingSystemSortField {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type Organization = {
  accountType?: Maybe<OrganizationAccountType>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  apiResponses?: Maybe<ApiResponses>;
  archivedAt?: Maybe<Scalars['Date']>;
  billingStartedAt?: Maybe<Scalars['Date']>;
  cif?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  executiveReports?: Maybe<Array<Maybe<ExecutiveReport>>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  incidentResponsePolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  infoSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  keyPersonnel?: Maybe<Array<Maybe<KeyPersonnel>>>;
  knowBe4Key?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  mailingRecipients?: Maybe<Array<Maybe<OrganizationMailingRecipient>>>;
  modalsMutedAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<NotificationSettings>;
  onboardingUntil?: Maybe<Scalars['Date']>;
  owned?: Maybe<Scalars['Boolean']>;
  paidSubscription?: Maybe<Scalars['Boolean']>;
  penetrationTests?: Maybe<Array<Maybe<Document>>>;
  phone?: Maybe<Scalars['String']>;
  policyDocuments?: Maybe<Array<Maybe<PolicyDocument>>>;
  riskAssessments?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  roadmap?: Maybe<RoadmapSteps>;
  sentinelOneSiteId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  technologySecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  useIncidentResponseLastReminded?: Maybe<Scalars['Date']>;
  useIncidentResponsePlanAutomation?: Maybe<Scalars['Boolean']>;
  useIncidentResponsePlanCadence?: Maybe<AutomationReminderCadence>;
  usePolicyCreatorAutomation?: Maybe<Scalars['Boolean']>;
  usePolicyLastReminded?: Maybe<Scalars['Date']>;
  usePolicyReminderCadence?: Maybe<AutomationReminderCadence>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  userSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  vendorOrganizations?: Maybe<Array<Maybe<VendorOrganization>>>;
  vulnerabilityScans?: Maybe<Array<Maybe<Document>>>;
  zip?: Maybe<Scalars['String']>;
};


export type OrganizationExecutiveReportsArgs = {
  executiveReportFilters?: InputMaybe<OrganizationExecutiveReportSubqueryFilters>;
};


export type OrganizationIncidentResponsePoliciesArgs = {
  incidentResponseFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationInfoSecurityPoliciesArgs = {
  infoSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationPenetrationTestsArgs = {
  penetrationTestFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
};


export type OrganizationRiskAssessmentsArgs = {
  riskAssessmentFilters?: InputMaybe<OrganizationRiskAssessmentSubqueryFilters>;
};


export type OrganizationTechnologySecurityPoliciesArgs = {
  technologySecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationUserSecurityPoliciesArgs = {
  userSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationVulnerabilityScansArgs = {
  vulnerabilityScanFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
};

export enum OrganizationAccountType {
  Compliance = 'Compliance',
  Security = 'Security',
  Unassigned = 'Unassigned'
}

export type OrganizationConnection = {
  nodes?: Maybe<Array<Maybe<Organization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationDocumentSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type OrganizationExecutiveReportSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ExecutiveReportFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Filters to  apply when using an organizations query. *hasCif* will only be applied when *cif* is falsy. */
export type OrganizationFilters = {
  accountTypes?: InputMaybe<Array<InputMaybe<OrganizationAccountType>>>;
  cif?: InputMaybe<Scalars['String']>;
  hasCif?: InputMaybe<Scalars['Boolean']>;
  hasKnowBe4Key?: InputMaybe<Scalars['Boolean']>;
  hasSentinelOneSiteId?: InputMaybe<Scalars['Boolean']>;
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sentinelOneSiteID?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrganizationStatus>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  useIncidentResponseLastReminded?: InputMaybe<Scalars['Date']>;
  usePolicyLastReminded?: InputMaybe<Scalars['Date']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationMailingRecipient = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type OrganizationMailingRecipientConnection = {
  nodes?: Maybe<Array<Maybe<OrganizationMailingRecipient>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationMailingRecipientFilters = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OrganizationRiskAssessmentSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum OrganizationSortFieldEnum {
  Cif = 'cif',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type OrganizationSorting = {
  sortField: Scalars['String'];
  sortOrder: SortOrder;
};

export enum OrganizationStatus {
  Active = 'active',
  Archived = 'archived'
}

export enum OsSupportStatus {
  SupportRisk = 'SupportRisk',
  Supported = 'Supported',
  Tbd = 'TBD',
  Unsupported = 'Unsupported'
}

export type OtherConsumerData = {
  assets: Scalars['Boolean'];
  education: Scalars['Boolean'];
  familialData: Scalars['Boolean'];
  insuranceData: Scalars['Boolean'];
};

export type OtherConsumerDataInput = {
  assets: Scalars['Boolean'];
  education: Scalars['Boolean'];
  familialData: Scalars['Boolean'];
  insuranceData: Scalars['Boolean'];
};

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PhishingCampaign = {
  createdAt: Scalars['Date'];
  frequency: Scalars['String'];
  name: Scalars['String'];
  pstCount: Scalars['Int'];
  securityTests: Array<Maybe<PhishingSecurityTest>>;
  status: Scalars['String'];
};

export type PhishingSecurityTest = {
  bouncedCount: Scalars['Int'];
  clickedCount: Scalars['Int'];
  deliveredCount: Scalars['Int'];
  duration: Scalars['Int'];
  name: Scalars['String'];
  phishPronePercentage: Scalars['Float'];
  pstId: Scalars['Int'];
  recipients: Array<Maybe<Recipient>>;
  scheduledCount: Scalars['Int'];
  startedAt: Scalars['Date'];
};

export type PolicyDocument = {
  archivedAt?: Maybe<Scalars['Date']>;
  colorHex: Scalars['String'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['ID']>;
  expiredAt?: Maybe<Scalars['Date']>;
  footer?: Maybe<Scalars['String']>;
  iconImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isDraft: Scalars['Boolean'];
  organization: Organization;
  sections?: Maybe<Array<Maybe<Section>>>;
  sourcePolicyDocumentId?: Maybe<Scalars['ID']>;
  subtitle?: Maybe<Scalars['String']>;
  templateTitle?: Maybe<Scalars['String']>;
  templateType?: Maybe<PolicyDocumentTemplateType>;
  title: Scalars['String'];
};


export type PolicyDocumentOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type PolicyDocumentConnection = {
  nodes?: Maybe<Array<Maybe<PolicyDocument>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum PolicyDocumentFieldSortField {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id'
}

export type PolicyDocumentTemplate = {
  id: Scalars['String'];
  sections?: Maybe<Array<Maybe<SectionTemplate>>>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<PolicyDocumentTemplateType>;
};

export enum PolicyDocumentTemplateType {
  IncidentResponsePlan = 'IncidentResponsePlan',
  InformationSecurityPolicies = 'InformationSecurityPolicies',
  TechnologySecurityPolicies = 'TechnologySecurityPolicies',
  UserDefined = 'UserDefined',
  UserSecurityPolicies = 'UserSecurityPolicies'
}

export type Query = {
  _?: Maybe<Scalars['Boolean']>;
  /**
   * Given an array of organizationIds, it will only return organizations that have answers that are expired
   * or missing in the first place
   */
  checkRiskRegistryAnswers?: Maybe<Array<Maybe<CheckRiskRegistryAnswerOutput>>>;
  /** Get a document given its ID */
  document?: Maybe<Document>;
  /** Get organization documents */
  documents?: Maybe<DocumentConnection>;
  /** Get an executive report by ID */
  executiveReport?: Maybe<ExecutiveReport>;
  /** Get the lineage of an executive report based on ID */
  executiveReportLineage?: Maybe<Array<Maybe<ExecutiveReport>>>;
  /** Get executive report templates. */
  executiveReportTemplates: Array<Maybe<ExecutiveReportTemplate>>;
  /** Get organization executive reports. */
  executiveReports?: Maybe<ExecutiveReportConnection>;
  getCompletedSectionMap?: Maybe<GetCompletedSectionMapOutput>;
  /** Given a filter by set of questions and an organization ID, returns the answers for that organization if any exist. */
  getFilteredAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  /** Get the record for an organization's heartbeat. */
  getRiskHeartbeatRecord?: Maybe<RiskRegistryQuestionsHeartbeat>;
  /** Retrieves a knowBe4Response from the backend. */
  knowBe4Response?: Maybe<ApiResponse>;
  /** Gets the last vendor organization record for a given organization and each of a set of vendors */
  lastVendorRequests: Array<LastVendorRequest>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /** Get organizations information. */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  /** Get policy document information. */
  policyDocument?: Maybe<PolicyDocument>;
  /** Get the lineage of a policy document based on ID */
  policyDocumentLineage?: Maybe<Array<Maybe<PolicyDocument>>>;
  /** Get all sections associated with a given policy document */
  policyDocumentSections?: Maybe<Array<Maybe<Section>>>;
  /** Get policyDocumentTemplate by type. */
  policyDocumentTemplate?: Maybe<PolicyDocumentTemplate>;
  /** Get policyDocumentTemplates. */
  policyDocumentTemplates?: Maybe<Array<Maybe<PolicyDocumentTemplate>>>;
  /** Get organization policy documents. */
  policyDocuments?: Maybe<PolicyDocumentConnection>;
  registeredRisk?: Maybe<RegisteredRisk>;
  /** Fetch task by its Id */
  registeredRiskTask: Task;
  /** Given a registeredRisk ID, retrieve all of its tasks */
  registeredRiskTasks: Array<Maybe<Task>>;
  /** Return riskTemplates */
  registeredRiskTemplates?: Maybe<Array<RiskTemplate>>;
  registeredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  /** Get risk assessment document information. */
  riskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Get organization risk assessment documents. */
  riskAssessmentDocuments?: Maybe<RiskAssessmentDocumentConnection>;
  /** Get riskAssessmentTemplate. */
  riskAssessmentTemplates: Array<Maybe<RiskAssessmentTemplate>>;
  riskComments?: Maybe<Array<Maybe<RiskComment>>>;
  /** Given an answerId, retrieves the riskRegistryAnswer record */
  riskRegistryAnswer?: Maybe<RiskRegistryAnswer>;
  /** Given an organizationId, retrieves all risk registry answers associated with that org if you are a member */
  riskRegistryAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  /** Retrieves a roadmap for an organization by organization id. */
  roadmap?: Maybe<Roadmap>;
  /**
   * Retrieves the roadmaps for a a list of organizations by organization id if
   * provided or the roadmap for the current users organizations if not.
   */
  roadmaps?: Maybe<Array<Maybe<Roadmap>>>;
  /** Get all vendors in the system */
  searchVendorRisks?: Maybe<Array<Maybe<VendorRisk>>>;
  /** Get all vendors in the system using businessName. Returns every vendor if no businessName is provided */
  searchVendors?: Maybe<Array<Maybe<Vendor>>>;
  /** Get section information. */
  section?: Maybe<Section>;
  /** Retrieves a sentinelOneResponse from the backend. */
  sentinelOneResponse?: Maybe<ApiResponse>;
  /** System-level query to retrieve an Affiliate Group given the ID of the affiliate_groups record. Only works with user tokens that include the admin:read scope. */
  systemAffiliateGroup?: Maybe<AffiliateGroup>;
  /** System-level query to retrieve all affiliate groups paginated and with filters. Only works with user tokens that include the admin:read scope. */
  systemAffiliateGroups?: Maybe<AffiliateGroupConnection>;
  /** System-level query to retrieve all affiliate organizations paginated and with filters. Only works with users tokens that include the admin:read scope. */
  systemAffiliateOrganizations?: Maybe<AffiliateOrganizationConnection>;
  /** Retrieves a apiResponse from the backend. */
  systemApiResponses?: Maybe<ApiResponseConnection>;
  /** Get a single custom notification by id. Requires admin:read scope. */
  systemCustomNotification?: Maybe<CustomNotification>;
  /** Get all custom notifications (sent and drafts). Requires admin:read scope. */
  systemCustomNotifications: CustomNotificationConnection;
  /** Get a document given its ID. Requires admin:read scope. */
  systemDocument?: Maybe<Document>;
  /** Get documentOrganization information given the documentId */
  systemDocumentOrganizations?: Maybe<DocumentOrganizationConnection>;
  /** Get all documents in the system. Requires admin:read scope. */
  systemDocuments?: Maybe<DocumentConnection>;
  /** Get organization executive reports. only works with jwt admin:read */
  systemExecutiveReports?: Maybe<ExecutiveReportConnection>;
  /** List all the navigation events in the system. Only works with API tokens with the system:read scope. */
  systemNavigationEvents?: Maybe<NavigationEventConnection>;
  /** Get Operating Systems. Only works with the scope adminScopes.adminRead */
  systemOperatingSystems?: Maybe<OperatingSystemConnection>;
  /** Get organization information. Only works with API tokens with the admin:read scope. */
  systemOrganization?: Maybe<Organization>;
  /** Get all custom notifications sent to a specific dealership. Requires admin:read scope. */
  systemOrganizationCustomNotifications: Array<CustomNotification>;
  systemOrganizationMailingRecipients?: Maybe<OrganizationMailingRecipientConnection>;
  /** Get all organizations. Only works with API tokens with the admin:read scope. */
  systemOrganizations?: Maybe<OrganizationConnection>;
  /** Get organization policy documents. Only works with admin:read scope */
  systemPolicyDocuments?: Maybe<PolicyDocumentConnection>;
  systemRegisteredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  systemRisk?: Maybe<Risk>;
  /** Get risk assessment document information. Only works with API tokens with the admin:read scope */
  systemRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Get all system risk assessment documents, optionally filtering on organizationId */
  systemRiskAssessmentDocuments?: Maybe<RiskAssessmentDocumentConnection>;
  systemRiskComments?: Maybe<Array<Maybe<RiskComment>>>;
  /** Given an organizationId, retrieves all risk registry answers regardless of if you are member of the organizations */
  systemRiskRegistryAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  systemRiskTemplates?: Maybe<RiskTemplateConnection>;
  systemRisks?: Maybe<RiskConnection>;
  /** Get a task information by id. Only works with  with API tokens with the system:read scope */
  systemTask?: Maybe<Task>;
  /** Get all task comments in the system. Only works with API tokens with the admin:read scope. */
  systemTaskComments?: Maybe<TaskCommentConnection>;
  systemTasks?: Maybe<TaskConnection>;
  /** Get user information. Only works with API tokens with the system:read scope. */
  systemUser?: Maybe<User>;
  systemUserActions?: Maybe<UserActionConnection>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganizations?: Maybe<UserOrganizationConnection>;
  /** List all the users in the system. Only works with API tokens with the system:read scope. */
  systemUsers?: Maybe<UserConnection>;
  /** Get vendor in the system based on id. Only works with tokens containing the admin:read scope. */
  systemVendor?: Maybe<Vendor>;
  /** Gets a vendor organization in the system by id. Only works with tokens containing admin:read. */
  systemVendorOrganization?: Maybe<VendorOrganization>;
  /** Gets all of the vendor organizations in the system. Only works with tokens containing admin:read. */
  systemVendorOrganizations?: Maybe<VendorOrganizationConnection>;
  /** Get a vendor request with the provided id. Only works with tokens containing the admin:read scope. */
  systemVendorRequest?: Maybe<VendorRequest>;
  /** Get all vendor requests in the system using pagination. Only works with tokens containing the admin:read scope. */
  systemVendorRequests?: Maybe<VendorRequestConnection>;
  /** Get vendor information provided the id. Only works with the scope admin:read */
  systemVendorRisk?: Maybe<VendorRisk>;
  /** Get all vendors in the system. It only works if the jwt has the scope admin:read */
  systemVendorRisks?: Maybe<VendorRiskConnection>;
  /** Get all vendors in the system using pagination. Only works with tokens containing the admin:read scope. */
  systemVendors?: Maybe<VendorConnection>;
  /** Given a task ID, retrieve all of its comments */
  taskComments: Array<Maybe<TaskComment>>;
  /** Get vendor based on id. */
  vendor?: Maybe<Vendor>;
  /** Gets a vendor organization in the system by id. */
  vendorOrganization?: Maybe<VendorOrganization>;
  /** Gets all of the vendor organizations in the system using pagination. Only returns vendor organizations visible to the token. */
  vendorOrganizations?: Maybe<VendorOrganizationConnection>;
  /** Get a vendor request with the provided id */
  vendorRequest?: Maybe<VendorRequest>;
  /** Get vendor risk information provided the id. */
  vendorRisk?: Maybe<VendorRisk>;
  /** Get vendorRiskTemplates. */
  vendorRiskTemplates: Array<Maybe<VendorRiskTemplate>>;
  /** Get all vendors in the system. */
  vendorRisks?: Maybe<VendorRiskConnection>;
  /** Get all vendors in the system using pagination. */
  vendors?: Maybe<VendorConnection>;
};


export type QueryCheckRiskRegistryAnswersArgs = {
  organizationInputs: Array<InputMaybe<CheckRiskRegistryAnswerInput>>;
};


export type QueryDocumentArgs = {
  documentId: Scalars['ID'];
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  documentFilters?: InputMaybe<DocumentFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentFieldSortFieldEnum>;
};


export type QueryExecutiveReportArgs = {
  id: Scalars['ID'];
};


export type QueryExecutiveReportLineageArgs = {
  executiveReportId: Scalars['ID'];
};


export type QueryExecutiveReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompletedSectionMapArgs = {
  isOnboarding?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type QueryGetFilteredAnswersArgs = {
  organizationId: Scalars['ID'];
  questionSet: QuestionSet;
};


export type QueryGetRiskHeartbeatRecordArgs = {
  organizationId: Scalars['ID'];
};


export type QueryKnowBe4ResponseArgs = {
  organizationId: Scalars['ID'];
};


export type QueryLastVendorRequestsArgs = {
  organizationId: Scalars['ID'];
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationsArgs = {
  organizationIds: Array<Scalars['ID']>;
};


export type QueryPolicyDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryPolicyDocumentLineageArgs = {
  policyDocumentId: Scalars['ID'];
};


export type QueryPolicyDocumentSectionsArgs = {
  policyDocumentId: Scalars['ID'];
};


export type QueryPolicyDocumentTemplateArgs = {
  type: PolicyDocumentTemplateType;
};


export type QueryPolicyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRegisteredRiskArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryRegisteredRiskTaskArgs = {
  id: Scalars['ID'];
};


export type QueryRegisteredRiskTasksArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QueryRegisteredRisksArgs = {
  filters?: InputMaybe<RegisteredRiskFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RegisteredRiskSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryRiskAssessmentDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
};


export type QueryRiskCommentsArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QueryRiskRegistryAnswerArgs = {
  answerId: Scalars['ID'];
};


export type QueryRiskRegistryAnswersArgs = {
  organizationId: Scalars['ID'];
};


export type QueryRisksArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  riskFilters?: InputMaybe<RiskFilters>;
  taskFilters?: InputMaybe<TaskFilters>;
};


export type QueryRoadmapArgs = {
  organizationId: Scalars['ID'];
};


export type QueryRoadmapsArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySearchVendorRisksArgs = {
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QuerySearchVendorsArgs = {
  businessName?: InputMaybe<Scalars['String']>;
};


export type QuerySectionArgs = {
  id: Scalars['ID'];
};


export type QuerySentinelOneResponseArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemAffiliateGroupArgs = {
  id: Scalars['ID'];
};


export type QuerySystemAffiliateGroupsArgs = {
  affiliateGroupFilters?: InputMaybe<AffiliateGroupFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<AffiliateGroupSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemAffiliateOrganizationsArgs = {
  filters?: InputMaybe<AffiliateOrganizationsFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<AffiliateOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemApiResponsesArgs = {
  apiResponseFilters?: InputMaybe<ApiResponseFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ApiResponseSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemCustomNotificationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemCustomNotificationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CustomNotificationStatus>;
};


export type QuerySystemDocumentArgs = {
  documentId: Scalars['ID'];
};


export type QuerySystemDocumentOrganizationsArgs = {
  documentFilters?: InputMaybe<DocumentFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemDocumentsArgs = {
  documentFilters?: InputMaybe<SystemDocumentFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<DocumentFieldSortFieldEnum>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemExecutiveReportsArgs = {
  executiveReportFilters?: InputMaybe<ExecutiveReportFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ExecutiveReportFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemNavigationEventsArgs = {
  filters?: InputMaybe<NavigationEventFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<NavigationEventSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
};


export type QuerySystemOperatingSystemsArgs = {
  operatingSystemFilters?: InputMaybe<OperatingSystemFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Array<InputMaybe<OperatingSystemSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemOrganizationCustomNotificationsArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemOrganizationMailingRecipientsArgs = {
  mailingRecipientFilters?: InputMaybe<OrganizationMailingRecipientFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<MailingRecipientSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemOrganizationsArgs = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<OrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemPolicyDocumentsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<PolicyDocumentFieldSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  systemPolicyDocumentFilters?: InputMaybe<SystemPolicyDocumentFilters>;
};


export type QuerySystemRegisteredRisksArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemRiskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type QuerySystemRiskAssessmentDocumentsArgs = {
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemRiskCommentsArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QuerySystemRiskRegistryAnswersArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemRiskTemplatesArgs = {
  filters?: InputMaybe<RiskTemplateFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskTemplateSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemRisksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  riskFilters?: InputMaybe<SystemRiskFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<RiskSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemTaskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemTaskCommentsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskCommentSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  taskCommentFilters?: InputMaybe<TaskCommentFilters>;
};


export type QuerySystemTasksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  taskFilters?: InputMaybe<TaskFilters>;
};


export type QuerySystemUserArgs = {
  id: Scalars['UserID'];
};


export type QuerySystemUserActionsArgs = {
  filters?: InputMaybe<UserActionsFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserActionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserOrganizationsArgs = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
};


export type QuerySystemUsersArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
};


export type QuerySystemVendorArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorOrganizationArgs = {
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationId: Scalars['ID'];
};


export type QuerySystemVendorOrganizationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  systemVendorOrganizationFilters?: InputMaybe<SystemVendorOrganizationFilters>;
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
};


export type QuerySystemVendorRequestArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorRequestsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRequestSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorRequestFilters?: InputMaybe<VendorRequestFilters>;
};


export type QuerySystemVendorRiskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorRisksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRiskFieldSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QuerySystemVendorsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
};


export type QueryTaskCommentsArgs = {
  taskId: Scalars['ID'];
};


export type QueryVendorArgs = {
  id: Scalars['ID'];
};


export type QueryVendorOrganizationArgs = {
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationId: Scalars['ID'];
};


export type QueryVendorOrganizationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<VendorOrganizationSortFields>;
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationFilters?: InputMaybe<VendorOrganizationFilters>;
};


export type QueryVendorRequestArgs = {
  id: Scalars['ID'];
};


export type QueryVendorRiskArgs = {
  id: Scalars['ID'];
};


export type QueryVendorRiskTemplatesArgs = {
  guid: Scalars['String'];
};


export type QueryVendorRisksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRiskFieldSortEnum>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QueryVendorsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
};

export enum QuestionPrefix {
  AssetInventory = 'AssetInventory',
  ByodPractices = 'BYODPractices',
  CloudBasedIdentityProtection = 'CloudBasedIdentityProtection',
  CorporateEmailDomain = 'CorporateEmailDomain',
  CriticalData = 'CriticalData',
  CriticalSystemList = 'CriticalSystemList',
  DataStorage = 'DataStorage',
  EmailConfigurations = 'EmailConfigurations',
  EmailFilter = 'EmailFilter',
  EndpointProtection = 'EndpointProtection',
  InboxSecurity = 'InboxSecurity',
  IncidentResponsePlan = 'IncidentResponsePlan',
  InfrastructureProjects = 'InfrastructureProjects',
  LocalAdminPermissions = 'LocalAdminPermissions',
  MfaForCloud = 'MFAForCloud',
  MfaForEmail = 'MFAForEmail',
  PasswordManagement = 'PasswordManagement',
  PatchManagement = 'PatchManagement',
  PenTestingAndVulnerabilityScans = 'PenTestingAndVulnerabilityScans',
  PhishingSimulation = 'PhishingSimulation',
  PrimaryIdentityManagement = 'PrimaryIdentityManagement',
  PriorSecurityBreach = 'PriorSecurityBreach',
  QualifiedIndividual = 'QualifiedIndividual',
  RemoteAccess = 'RemoteAccess',
  SecurityAwarenessTraining = 'SecurityAwarenessTraining',
  SecurityPersonnel = 'SecurityPersonnel',
  SystemPatching = 'SystemPatching',
  TechnologySecurityPolicies = 'TechnologySecurityPolicies',
  UnusedUserAccounts = 'UnusedUserAccounts',
  UserSecurityPolicies = 'UserSecurityPolicies',
  VendorEndpointAccess = 'VendorEndpointAccess',
  VendorRisk = 'VendorRisk',
  VulnerabilityTracking = 'VulnerabilityTracking',
  WrittenIsp = 'WrittenISP'
}

export enum QuestionSet {
  AccessManagement = 'AccessManagement',
  BusinessAndCompliance = 'BusinessAndCompliance',
  DeviceManagement = 'DeviceManagement',
  EmailSecurity = 'EmailSecurity',
  EndpointSecurity = 'EndpointSecurity',
  NetworkManagement = 'NetworkManagement'
}

export enum QuestionShorthand {
  AssetInventoryReviewedDate = 'AssetInventory_ReviewedDate',
  AssetInventoryReviewedPastYear = 'AssetInventory_ReviewedPastYear',
  ByodPracticesAllowed = 'BYODPractices_Allowed',
  ByodPracticesCriticalInfo = 'BYODPractices_CriticalInfo',
  CloudBasedIdentityProtectionPresent = 'CloudBasedIdentityProtection_Present',
  CloudBasedIdentityProtectionProvider = 'CloudBasedIdentityProtection_Provider',
  CorporateEmailDomainPresent = 'CorporateEmailDomain_Present',
  CriticalDataDataType = 'CriticalData_DataType',
  CriticalDataStorageLocation = 'CriticalData_StorageLocation',
  CriticalDataStoredOutside = 'CriticalData_StoredOutside',
  CriticalSystemListDocumented = 'CriticalSystemList_Documented',
  DataStorageStorageLocation = 'DataStorage_StorageLocation',
  EmailConfigurationsDkim = 'EmailConfigurations_DKIM',
  EmailConfigurationsDmarc = 'EmailConfigurations_DMARC',
  EmailConfigurationsEnforced = 'EmailConfigurations_Enforced',
  EmailConfigurationsSpf = 'EmailConfigurations_SPF',
  EmailFilterPresent = 'EmailFilter_Present',
  EmailFilterTool = 'EmailFilter_Tool',
  EndpointProtectionIsAllDevices = 'EndpointProtection_IsAllDevices',
  EndpointProtectionLogging = 'EndpointProtection_Logging',
  EndpointProtectionPresent = 'EndpointProtection_Present',
  EndpointProtectionWasAllDevices = 'EndpointProtection_WasAllDevices',
  InboxSecurityInactiveMailboxRemoved = 'InboxSecurity_InactiveMailboxRemoved',
  InboxSecuritySharedMailboxReviewed = 'InboxSecurity_SharedMailboxReviewed',
  IncidentResponsePlanReviewedDate = 'IncidentResponsePlan_ReviewedDate',
  IncidentResponsePlanReviewedPastYear = 'IncidentResponsePlan_ReviewedPastYear',
  InfrastructureProjectsDateOfOccurrence = 'InfrastructureProjects_DateOfOccurrence',
  InfrastructureProjectsPresent = 'InfrastructureProjects_Present',
  LocalAdminPermissionsGranted = 'LocalAdminPermissions_Granted',
  LocalAdminPermissionsMfaRequired = 'LocalAdminPermissions_MFARequired',
  MfaForCloudReviewedDate = 'MFAForCloud_ReviewedDate',
  MfaForCloudReviewedPastYear = 'MFAForCloud_ReviewedPastYear',
  MfaForEmailRequired = 'MFAForEmail_Required',
  PasswordManagementEnforced = 'PasswordManagement_Enforced',
  PasswordManagementManagementTool = 'PasswordManagement_ManagementTool',
  PasswordManagementRequirements = 'PasswordManagement_Requirements',
  PatchManagementPresent = 'PatchManagement_Present',
  PenTestingAndVulnerabilityScansCadence = 'PenTestingAndVulnerabilityScans_Cadence',
  PenTestingAndVulnerabilityScansExternal = 'PenTestingAndVulnerabilityScans_External',
  PhishingSimulationCadence = 'PhishingSimulation_Cadence',
  PhishingSimulationEnrollmentTimeline = 'PhishingSimulation_EnrollmentTimeline',
  PhishingSimulationPresent = 'PhishingSimulation_Present',
  PrimaryIdentityManagementPrimarySolution = 'PrimaryIdentityManagement_PrimarySolution',
  PriorSecurityBreachDateOfBreach = 'PriorSecurityBreach_DateOfBreach',
  PriorSecurityBreachKnownBreach = 'PriorSecurityBreach_KnownBreach',
  QualifiedIndividualAppointed = 'QualifiedIndividual_Appointed',
  RemoteAccessAllow = 'RemoteAccess_Allow',
  RemoteAccessCriticalDevices = 'RemoteAccess_CriticalDevices',
  RemoteAccessMfa = 'RemoteAccess_MFA',
  SecurityAwarenessTrainingCadence = 'SecurityAwarenessTraining_Cadence',
  SecurityAwarenessTrainingEnrollmentTimeline = 'SecurityAwarenessTraining_EnrollmentTimeline',
  SecurityAwarenessTrainingPresent = 'SecurityAwarenessTraining_Present',
  SecurityPersonnelPresent = 'SecurityPersonnel_Present',
  SecurityPersonnelType = 'SecurityPersonnel_Type',
  SystemPatchingPatchedRegularly = 'SystemPatching_PatchedRegularly',
  TechnologySecurityPoliciesPresent = 'TechnologySecurityPolicies_Present',
  TechnologySecurityPoliciesReviewed = 'TechnologySecurityPolicies_Reviewed',
  TechnologySecurityPoliciesReviewedDate = 'TechnologySecurityPolicies_ReviewedDate',
  UnusedUserAccountsReviewedDate = 'UnusedUserAccounts_ReviewedDate',
  UnusedUserAccountsReviewedPastYear = 'UnusedUserAccounts_ReviewedPastYear',
  UserSecurityPoliciesPresent = 'UserSecurityPolicies_Present',
  UserSecurityPoliciesReviewed = 'UserSecurityPolicies_Reviewed',
  UserSecurityPoliciesReviewedDate = 'UserSecurityPolicies_ReviewedDate',
  VendorEndpointAccessAllowed = 'VendorEndpointAccess_Allowed',
  VendorEndpointAccessMfa = 'VendorEndpointAccess_MFA',
  VendorRiskReviewedDate = 'VendorRisk_ReviewedDate',
  VendorRiskReviewedPastYear = 'VendorRisk_ReviewedPastYear',
  VulnerabilityTrackingPresent = 'VulnerabilityTracking_Present',
  WrittenIspReviewedDate = 'WrittenISP_ReviewedDate',
  WrittenIspReviewedPastYear = 'WrittenISP_ReviewedPastYear'
}

export enum QuestionType {
  Both = 'Both',
  Onboarding = 'Onboarding',
  Standard = 'Standard'
}

export type Recipient = {
  bouncedAt?: Maybe<Scalars['Date']>;
  clickedAt?: Maybe<Scalars['Date']>;
  deliveredAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  emailTemplate: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  scheduledAt: Scalars['Date'];
};

export type RegisteredRisk = {
  acceptedAt?: Maybe<Scalars['Date']>;
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  functionCategory: RegisteredRiskFunctionCategory;
  id: Scalars['ID'];
  isMuted?: Maybe<Scalars['Boolean']>;
  organization: Organization;
  rating: RiskRating;
  resolvedAt?: Maybe<Scalars['Date']>;
  riskComments?: Maybe<Array<Maybe<RiskComment>>>;
  riskTemplate?: Maybe<RiskTemplate>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type RegisteredRiskFilters = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  functionCategory?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rating?: InputMaybe<Scalars['String']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
};

export enum RegisteredRiskFunctionCategory {
  Access = 'Access',
  Compliance = 'Compliance',
  Device = 'Device',
  Email = 'Email',
  Endpoint = 'Endpoint',
  Network = 'Network'
}

export enum RegisteredRiskSortField {
  CreatedAt = 'createdAt'
}

export type RemoveTaskCommentInput = {
  taskCommentId: Scalars['ID'];
  taskId: Scalars['ID'];
};

export type RestVendorQuestionnaireDocumentData = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type RestVendorQuestionnaireResponseData = {
  documentData?: Maybe<RestVendorQuestionnaireDocumentData>;
  sections?: Maybe<Array<VendorRiskSectionWithAnswer>>;
  stepState: StepState;
  vendorRequests: Array<RestVendorRequestInformation>;
};

export type RestVendorRequestInformation = {
  id: Scalars['ID'];
  organizationName: Scalars['String'];
};

export type Risk = {
  coreFunction: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  functionCategory: FunctionCategory;
  id: Scalars['ID'];
  rating: Scalars['String'];
  riskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
};


export type RiskRiskAssessmentDocumentArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskTasksArgs = {
  taskFilters?: InputMaybe<TaskFilters>;
};

export type RiskAssessmentDocument = {
  archivedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  document?: Maybe<Document>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  organization: Organization;
  risks?: Maybe<Array<Maybe<Risk>>>;
  sections?: Maybe<RiskAssessmentSectionsWithAnswers>;
  status: RiskAssessmentStatus;
  updatedAt: Scalars['Date'];
  user: User;
};


export type RiskAssessmentDocumentOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type RiskAssessmentDocumentConnection = {
  nodes?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum RiskAssessmentDocumentFieldSortFieldEnum {
  ArchivedAt = 'archivedAt',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  UpdatedAt = 'updatedAt'
}

export type RiskAssessmentDocumentFilter = {
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<RiskAssessmentStatus>>>;
};

export type RiskAssessmentQuestion = {
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  options: Array<RiskAssessmentResponseOption>;
  title: Scalars['String'];
};

export type RiskAssessmentQuestionInput = {
  answer?: InputMaybe<AnswerInput>;
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  note?: InputMaybe<Scalars['String']>;
  options: Array<RiskAssessmentResponseOptionInput>;
  title: Scalars['String'];
};

export type RiskAssessmentQuestionWithAnswer = {
  answer?: Maybe<Answer>;
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  note?: Maybe<Scalars['String']>;
  options: Array<RiskAssessmentResponseOption>;
  title: Scalars['String'];
};

export type RiskAssessmentResponseOption = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type RiskAssessmentResponseOptionInput = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type RiskAssessmentSection = {
  code: Scalars['String'];
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestion>;
  title: Scalars['String'];
};

export type RiskAssessmentSectionInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestionInput>;
  title: Scalars['String'];
};

export type RiskAssessmentSectionWithAnswer = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestionWithAnswer>;
  title: Scalars['String'];
};

export type RiskAssessmentSections = {
  AccessControl: RiskAssessmentSection;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSection;
  DataProtection: RiskAssessmentSection;
  IncidentResponse: RiskAssessmentSection;
  NetworkSecurity: RiskAssessmentSection;
  OrganizationalOversight: RiskAssessmentSection;
  RiskManagementStrategy: RiskAssessmentSection;
  SecurityLoggingAndMonitoring: RiskAssessmentSection;
  SystemDeploymentAndMaintenance: RiskAssessmentSection;
};

export type RiskAssessmentSectionsInput = {
  AccessControl: RiskAssessmentSectionInput;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSectionInput;
  DataProtection: RiskAssessmentSectionInput;
  IncidentResponse: RiskAssessmentSectionInput;
  NetworkSecurity: RiskAssessmentSectionInput;
  OrganizationalOversight: RiskAssessmentSectionInput;
  RiskManagementStrategy: RiskAssessmentSectionInput;
  SecurityLoggingAndMonitoring: RiskAssessmentSectionInput;
  SystemDeploymentAndMaintenance: RiskAssessmentSectionInput;
};

export type RiskAssessmentSectionsWithAnswers = {
  AccessControl: RiskAssessmentSectionWithAnswer;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSectionWithAnswer;
  DataProtection: RiskAssessmentSectionWithAnswer;
  IncidentResponse: RiskAssessmentSectionWithAnswer;
  NetworkSecurity: RiskAssessmentSectionWithAnswer;
  OrganizationalOversight: RiskAssessmentSectionWithAnswer;
  RiskManagementStrategy: RiskAssessmentSectionWithAnswer;
  SecurityLoggingAndMonitoring: RiskAssessmentSectionWithAnswer;
  SystemDeploymentAndMaintenance: RiskAssessmentSectionWithAnswer;
};

export enum RiskAssessmentStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Pending = 'Pending',
  PendingReview = 'PendingReview'
}

export type RiskAssessmentTemplate = {
  sections: RiskAssessmentSections;
};

export type RiskComment = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  registeredRisk: RegisteredRisk;
  text: Scalars['String'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type RiskConnection = {
  nodes?: Maybe<Array<Maybe<Risk>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum RiskDropdownFilter {
  MostRecent = 'MostRecent',
  PriorityLevel = 'PriorityLevel'
}

export type RiskFilters = {
  coreFunction?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
};

export type RiskInput = {
  coreFunction: Scalars['String'];
  functionCategory: FunctionCategory;
  rating: Scalars['String'];
  riskAssessmentDocumentId: Scalars['ID'];
  title: Scalars['String'];
};

export enum RiskRating {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type RiskRegistryAnswer = {
  answer?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  question: RiskRegistryQuestion;
  updatedAt: Scalars['Date'];
  user: User;
};


export type RiskRegistryAnswerOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskRegistryAnswerUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type RiskRegistryAnswerInput = {
  answer: Scalars['String'];
  questionShorthand: Scalars['String'];
};

export type RiskRegistryQuestion = {
  answers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  questionShorthand: QuestionShorthand;
  triggerConditions?: Maybe<Array<Maybe<TriggerCondition>>>;
  type?: Maybe<QuestionType>;
  updatedAt: Scalars['Date'];
};

export type RiskRegistryQuestionsHeartbeat = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  lastHeartbeat?: Maybe<Scalars['Date']>;
  organization: Organization;
  user: User;
};


export type RiskRegistryQuestionsHeartbeatOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskRegistryQuestionsHeartbeatUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum RiskSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title'
}

export type RiskTemplate = {
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  functionCategory: RegisteredRiskFunctionCategory;
  groupName: RiskTemplateGroup;
  id: Scalars['ID'];
  rating: RiskRating;
  registeredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  templateShorthand: TemplateShorthand;
  title: Scalars['String'];
  triggerConditions?: Maybe<Array<Maybe<TriggerCondition>>>;
  updatedAt: Scalars['Date'];
};

export type RiskTemplateConnection = {
  nodes?: Maybe<Array<Maybe<RiskTemplate>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RiskTemplateFilters = {
  functionCategories?: InputMaybe<Array<InputMaybe<RegisteredRiskFunctionCategory>>>;
};

export enum RiskTemplateGroup {
  Access = 'Access',
  BusinessAndCompliance = 'BusinessAndCompliance',
  DeviceManagement = 'DeviceManagement',
  EmailSecurity = 'EmailSecurity',
  EndpointSecurity = 'EndpointSecurity',
  NetworkSecurity = 'NetworkSecurity'
}

export enum RiskTemplateSortField {
  Id = 'id'
}

export type Roadmap = {
  executiveReports?: Maybe<Array<Maybe<ExecutiveReport>>>;
  organization?: Maybe<Organization>;
  policyDocuments?: Maybe<RoadmapPolicyDocuments>;
  riskAssessmentDocuments?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  steps?: Maybe<RoadmapSteps>;
};

export type RoadmapPolicyDocuments = {
  IncidentResponsePlan?: Maybe<Array<Maybe<PolicyDocument>>>;
  InformationSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  TechnologySecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  UserSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
};

export type RoadmapStep = {
  acknowledgementItems?: Maybe<Array<Maybe<AcknowledgementItem>>>;
  actionItems?: Maybe<Array<Maybe<ActionItem>>>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: RoadmapStepName;
  organization: Organization;
  updatedAt: Scalars['Date'];
};


export type RoadmapStepOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum RoadmapStepName {
  AccessControl = 'AccessControl',
  DevelopResponsePlan = 'DevelopResponsePlan',
  ExecutiveReporting = 'ExecutiveReporting',
  OverseeServiceProviders = 'OverseeServiceProviders',
  SecurityAwarenessProgram = 'SecurityAwarenessProgram',
  SecurityTesting = 'SecurityTesting',
  TechnicalRequirements = 'TechnicalRequirements',
  WrittenInformationSecurityProgram = 'WrittenInformationSecurityProgram',
  WrittenRiskAssessment = 'WrittenRiskAssessment'
}

export type RoadmapSteps = {
  AccessControl?: Maybe<RoadmapStep>;
  DevelopResponsePlan?: Maybe<RoadmapStep>;
  ExecutiveReporting?: Maybe<RoadmapStep>;
  OverseeServiceProviders?: Maybe<RoadmapStep>;
  SecurityAwarenessProgram?: Maybe<RoadmapStep>;
  SecurityTesting?: Maybe<RoadmapStep>;
  TechnicalRequirements?: Maybe<RoadmapStep>;
  WrittenInformationSecurityProgram?: Maybe<RoadmapStep>;
  WrittenRiskAssessment?: Maybe<RoadmapStep>;
};

export type S3PutPsuData = {
  message?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  s3ObjectKey?: Maybe<Scalars['String']>;
};

export type Section = {
  hidden: Scalars['Boolean'];
  htmlBody?: Maybe<Scalars['String']>;
  htmlVars?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  isAdvancedMode: Scalars['Boolean'];
  policyDocument?: Maybe<PolicyDocument>;
  title?: Maybe<Scalars['String']>;
};

export type SectionInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  htmlBody?: InputMaybe<Scalars['String']>;
  htmlVars?: InputMaybe<Scalars['JSON']>;
  isAdvancedMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type SectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  templateHtml: Scalars['String'];
  templateVars?: Maybe<Array<Maybe<TemplateVars>>>;
  title: Scalars['String'];
};

export enum SecurityReportDateRange {
  Last3Months = 'last3Months',
  LastMonth = 'lastMonth',
  LastQuarter = 'lastQuarter',
  LastWeek = 'lastWeek',
  LastYear = 'lastYear'
}

export enum SecurityReportTemplateType {
  DeviceManagement = 'deviceManagement',
  PhishingSimulation = 'phishingSimulation',
  SecurityAwareness = 'securityAwareness',
  SecurityResponse = 'securityResponse'
}

export enum SendTo {
  Admins = 'Admins',
  MailingList = 'MailingList',
  Members = 'Members'
}

export type SensitiveConsumerData = {
  dateOfBirth: Scalars['Boolean'];
  driverLicenseNumber: Scalars['Boolean'];
  ssn: Scalars['Boolean'];
};

export type SensitiveConsumerDataInput = {
  dateOfBirth: Scalars['Boolean'];
  driverLicenseNumber: Scalars['Boolean'];
  ssn: Scalars['Boolean'];
};

/**
 * Device Types as specified by the Sentinel One Agents (machineType field) API
 * documentation with spaces replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum SentinelOneDeviceType {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  Desktop = 'DESKTOP',
  KubernetesNode = 'KUBERNETES_NODE',
  KubernetesPod = 'KUBERNETES_POD',
  Laptop = 'LAPTOP',
  Server = 'SERVER',
  Storage = 'STORAGE',
  Unknown = 'UNKNOWN'
}

export type SentinelOneResponse = {
  endpoints?: Maybe<Array<Maybe<Endpoint>>>;
  groupCount?: Maybe<Scalars['Int']>;
  threats?: Maybe<Array<Maybe<Threat>>>;
};

export type ShadowEntity = Organization | User;

export enum ShadowType {
  Organization = 'Organization',
  User = 'User'
}

export type SharedData = {
  consumerFinancialData: ConsumerFinancialData;
  consumerIdentityData: ConsumerIdentityData;
  otherConsumerData: OtherConsumerData;
  sensitiveConsumerData: SensitiveConsumerData;
};

export type SharedDataInput = {
  consumerFinancialData: ConsumerFinancialDataInput;
  consumerIdentityData: ConsumerIdentityDataInput;
  otherConsumerData: OtherConsumerDataInput;
  sensitiveConsumerData: SensitiveConsumerDataInput;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StepState = {
  dealershipRequestAnswers: DealershipRequestMeta;
  nda: NdaMeta;
  vendorAgreementAnswers: VendorAgreementMeta;
  welcome: Scalars['Boolean'];
};

export type StepStateInput = {
  dealershipRequestAnswers: DealershipRequestMetaInput;
  nda?: InputMaybe<NdaMetaInput>;
  vendorAgreementAnswers: VendorAgreementMetaInput;
  welcome: Scalars['Boolean'];
};

export type Subscription = {
  _?: Maybe<Scalars['Boolean']>;
};

/** System-level AffiliateGroup input */
export type SystemAffiliateGroupInput = {
  /** User provided name used to identify the AffiliateGroup. Max 255 characters. Does not need to be unique. Input value is automatically trimmed and validated that it is not nullish. */
  name: Scalars['String'];
};

export type SystemAffiliateOrganizationInput = {
  affiliateGroupId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type SystemCreateVendorInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
};

export type SystemDocumentFilters = {
  categories?: InputMaybe<Array<InputMaybe<DocumentCategory>>>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemOrganizationInput = {
  accountType: OrganizationAccountType;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SystemOrganizationMailingRecipient = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type SystemPolicyDocumentFilters = {
  createdByUser?: InputMaybe<Scalars['UserID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  templateTypes?: InputMaybe<Array<InputMaybe<PolicyDocumentTemplateType>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemRiskFilters = {
  coreFunctions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  functionCategories?: InputMaybe<Array<InputMaybe<FunctionCategory>>>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  riskAssessmentDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemVendorOrganizationFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  hasContactEmail?: InputMaybe<Scalars['Boolean']>;
  organizationCif?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type Task = {
  assignee?: Maybe<User>;
  comments?: Maybe<Array<Maybe<TaskComment>>>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  registeredRisk?: Maybe<RegisteredRisk>;
  risk?: Maybe<Risk>;
  status?: Maybe<TaskStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type TaskRiskArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TaskComment = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  task?: Maybe<Task>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};


export type TaskCommentTaskArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TaskCommentConnection = {
  nodes?: Maybe<Array<Maybe<TaskComment>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TaskCommentFilters = {
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum TaskCommentSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type TaskConnection = {
  nodes?: Maybe<Array<Maybe<Task>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TaskFilters = {
  dueDate?: InputMaybe<DateFilter>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']>;
  hasDueDate?: InputMaybe<Scalars['Boolean']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  riskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type TaskInput = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  isComplete: Scalars['Boolean'];
  registeredRiskId?: InputMaybe<Scalars['ID']>;
  riskId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export enum TaskSortField {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  Id = 'id',
  Title = 'title'
}

export enum TaskStatus {
  Completed = 'Completed',
  PastDue = 'PastDue',
  Pending = 'Pending'
}

export enum TemplateShorthand {
  AnnualReviewAccessToCustomerInformationNotCompleted = 'AnnualReviewAccessToCustomerInformationNotCompleted',
  AnnualReviewDealershipAssetsNotCompleted = 'AnnualReviewDealershipAssetsNotCompleted',
  AnnualReviewInformationSecurityPoliciesNotCompleted = 'AnnualReviewInformationSecurityPoliciesNotCompleted',
  AnnualReviewMfaCloudServicesNotCompleted = 'AnnualReviewMFACloudServicesNotCompleted',
  AnnualReviewOfIncidentResponseNotCompleted = 'AnnualReviewOfIncidentResponseNotCompleted',
  AnnualReviewOfTechnologySecurityNotCompleted = 'AnnualReviewOfTechnologySecurityNotCompleted',
  AnnualReviewOfUserSecurityNotCompleted = 'AnnualReviewOfUserSecurityNotCompleted',
  AnnualReviewOfVendors = 'AnnualReviewOfVendors',
  CentralizedPasswordSolutionNotImplemented = 'CentralizedPasswordSolutionNotImplemented',
  CriticalDateStoredOutside = 'CriticalDateStoredOutside',
  CriticalDeviceViaRemoteAccess = 'CriticalDeviceViaRemoteAccess',
  DkimNotImplemented = 'DKIMNotImplemented',
  DmarcNotImplemented = 'DMARCNotImplemented',
  EmailFilteringNotImplemented = 'EmailFilteringNotImplemented',
  HistoryCyberIncidents = 'HistoryCyberIncidents',
  InactiveMailboxReviewNotPerformed = 'InactiveMailboxReviewNotPerformed',
  IncidentResponseNotDocumented = 'IncidentResponseNotDocumented',
  InformationSecurityProgramNotEstablished = 'InformationSecurityProgramNotEstablished',
  InsecureUserTerminationPractices = 'InsecureUserTerminationPractices',
  MfaForCloudAccountsNotRequired = 'MFAForCloudAccountsNotRequired',
  MfaForEmailAccessNotEnforced = 'MFAForEmailAccessNotEnforced',
  MfaForPrivilegedAccounts = 'MFAForPrivilegedAccounts',
  MinimumPasswordLengthNotEnforced = 'MinimumPasswordLengthNotEnforced',
  NewHirePhishingSimulation30DayEnrollment = 'NewHirePhishingSimulation30DayEnrollment',
  NewHireSecurityTraining30DayEnrollment = 'NewHireSecurityTraining30DayEnrollment',
  NoInternalHardwareInventoryMaintained = 'NoInternalHardwareInventoryMaintained',
  NoInternalSoftwareInventoryMaintained = 'NoInternalSoftwareInventoryMaintained',
  PasswordComplexityNotEnforced = 'PasswordComplexityNotEnforced',
  PasswordRequirementsNotEnforced = 'PasswordRequirementsNotEnforced',
  PhishingSimulationConductedInfrequently = 'PhishingSimulationConductedInfrequently',
  PhishingSimulationNotImplemented = 'PhishingSimulationNotImplemented',
  ProcessForRemovingUnusedAccountNotDocumented = 'ProcessForRemovingUnusedAccountNotDocumented',
  ProcessForReviewingVendorsNotDocumented = 'ProcessForReviewingVendorsNotDocumented',
  QiNotAppointed = 'QINotAppointed',
  RemoteAccessWithoutMfa = 'RemoteAccessWithoutMFA',
  ReportSecurityProgramStatus = 'ReportSecurityProgramStatus',
  ReviewMonthlyTrainingResults = 'ReviewMonthlyTrainingResults',
  SpfNotImplemented = 'SPFNotImplemented',
  SecurityAwarenessTrainingConductedInfrequently = 'SecurityAwarenessTrainingConductedInfrequently',
  SecurityAwarenessTrainingNotImplemented = 'SecurityAwarenessTrainingNotImplemented',
  SharedMailboxReviewNotPerformed = 'SharedMailboxReviewNotPerformed',
  TechnologySecurityPolicyNotDocumented = 'TechnologySecurityPolicyNotDocumented',
  UnmanagedByodAccess = 'UnmanagedBYODAccess',
  UnsupportedOperatingSystems = 'UnsupportedOperatingSystems',
  UserSecurityPolicyNotDocumented = 'UserSecurityPolicyNotDocumented',
  VendorEndpointAccessWithoutMfa = 'VendorEndpointAccessWithoutMFA',
  VendorRequestDenied = 'VendorRequestDenied',
  VendorRiskResponseNotReviewed = 'VendorRiskResponseNotReviewed'
}

export type TemplateVars = {
  key: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  recommendedValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Threat = {
  analystVerdict: ThreatAnalystVerdict;
  classification: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  deviceName: Scalars['String'];
  deviceType: SentinelOneDeviceType;
  identifiedAt?: Maybe<Scalars['String']>;
  ipAddress: Scalars['String'];
  osVersion: Scalars['String'];
  responseStatus: ThreatResponseStatus;
  siteId?: Maybe<Scalars['String']>;
};

/**
 * Analyst Verdict as specified by the Sentinel One Threats (analystVerdict field) API
 * documentation converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum ThreatAnalystVerdict {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  FalsePositive = 'FALSE_POSITIVE',
  Suspicious = 'SUSPICIOUS',
  TruePositive = 'TRUE_POSITIVE',
  Undefined = 'UNDEFINED'
}

export type ThreatClassification = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
};

/**
 * Response Status as specified by the Sentinel One Threats (incidentResponse field)
 * API documentation.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum ThreatResponseStatus {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
  Unresolved = 'UNRESOLVED'
}

/** Training Campaign as defined by the KnowBe4 documentation [https://developer.knowbe4.com/rest/reporting#tag/Training/paths/~1v1~1training~1campaigns/get] */
export type TrainingCampaign = {
  /** The ID used by a training campaign for KnowBe4 */
  campaign_id: Scalars['Int'];
  endedAt?: Maybe<Scalars['Date']>;
  /** Derived from content field on the RawTrainingCampaign received from KnowBe4 */
  modules: Array<Maybe<TrainingModule>>;
  name: Scalars['String'];
  startedAt: Scalars['Date'];
  /** Status of the training campaign (ex. IN_PROGRESS, COMPLETED, etc.) */
  status: TrainingCampaignStatus;
};

/**
 * Training Campaign status as defined by the KnowBe4 API documentation with spaces
 * in the values replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a KnowBe4 schema change.
 */
export enum TrainingCampaignStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  Created = 'CREATED',
  Enrolling = 'ENROLLING',
  InProgress = 'IN_PROGRESS'
}

export type TrainingModule = {
  enrolledUsers: Array<Maybe<EnrolledUser>>;
  name: Scalars['String'];
};

export type TriggerCondition = {
  condition: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  question: RiskRegistryQuestion;
  riskTemplate: RiskTemplate;
  updatedAt: Scalars['Date'];
};

export type TypedPoliciesSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<PolicyDocumentFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** AffiliateGroup Update input */
export type UpdateAffiliateGroupInput = {
  /** User provided name used to the update the AffiliateGroup. Max 255 characters. Does not need to be unique. Input value is automatically trimmed and validated that it is not nullish. */
  name: Scalars['String'];
};

export type UpdateAutomationSettingsInput = {
  useIncidentResponsePlanAutomation: Scalars['Boolean'];
  useIncidentResponsePlanCadence: AutomationReminderCadence;
  usePolicyCreatorAutomation: Scalars['Boolean'];
  usePolicyReminderCadence: AutomationReminderCadence;
};

export type UpdateCustomNotificationDraftInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type UpdateKeyPersonnelInput = {
  keyPersonnel?: InputMaybe<Array<InputMaybe<KeyPersonnelInput>>>;
  organizationId: Scalars['ID'];
};

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateRegisteredRiskInput = {
  description: Scalars['String'];
  functionCategory: Scalars['String'];
  organizationId: Scalars['ID'];
  rating: Scalars['String'];
  registeredRiskId: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateRiskRegistryAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  answerId: Scalars['ID'];
};

export type UpdateSystemDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemOrganizationMailingRecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemRiskInput = {
  coreFunction?: InputMaybe<Scalars['String']>;
  functionCategory?: InputMaybe<FunctionCategory>;
  id: Scalars['ID'];
  rating?: InputMaybe<Scalars['String']>;
  riskAssessmentDocumentId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemTaskInput = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  isComplete?: InputMaybe<Scalars['Boolean']>;
  riskId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['UserID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorRiskByGuidInput = {
  data: VendorRiskResponseDataInput;
  documentId?: InputMaybe<Scalars['ID']>;
  isDraft: Scalars['Boolean'];
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  vendorRequestIds: Array<InputMaybe<Scalars['ID']>>;
};

export type User = {
  createdAt?: Maybe<Scalars['Date']>;
  disableOrgs?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UserID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  phone?: Maybe<Scalars['String']>;
  portalAccessRole?: Maybe<Array<Maybe<CognitoScope>>>;
  shadowEntity?: Maybe<UserShadowEntity>;
  updatedAt?: Maybe<Scalars['Date']>;
  userActions?: Maybe<Array<Maybe<UserAction>>>;
};


export type UserUserActionsArgs = {
  userActionFilters?: InputMaybe<UserActionSubqueryFilters>;
};

export type UserAction = {
  actionEntity?: Maybe<UserActionEntity>;
  actionTag: ActionTag;
  contextType: AppContextType;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  user: User;
};


export type UserActionActionEntityArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UserActionConnection = {
  nodes?: Maybe<Array<Maybe<UserAction>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserActionEntity = AcknowledgementItem | Document | ExecutiveReport | Organization | PolicyDocument | Risk | RiskAssessmentDocument | Task | TaskComment | UserOrganization | VendorOrganization | VendorRequest;

export enum UserActionSortField {
  CreatedAt = 'createdAt'
}

export type UserActionSubqueryFilters = {
  actionTags?: InputMaybe<Array<InputMaybe<ActionTag>>>;
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserActionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type UserActionsFilters = {
  actionTags?: InputMaybe<Array<InputMaybe<ActionTag>>>;
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  createdAt?: InputMaybe<DateRange>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  /** The only userFilters that will be supported by systemUserActions at this time will be userIds and emails */
  userFilters?: InputMaybe<UserFilters>;
};

export type UserConnection = {
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['String'];
  node?: Maybe<User>;
};

export type UserFilters = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserOrganization = {
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  owner: Scalars['Boolean'];
  user?: Maybe<User>;
};


export type UserOrganizationOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UserOrganizationUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<UserOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserOrganizationFilters = {
  role?: InputMaybe<UserOrganizationRole>;
};

export enum UserOrganizationRole {
  Admin = 'Admin',
  Member = 'Member'
}

export enum UserOrganizationSortField {
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  UserEmail = 'userEmail',
  UserFirstName = 'userFirstName',
  UserLastName = 'userLastName'
}

export type UserRole = {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserShadowEntity = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  shadowEntity?: Maybe<ShadowEntity>;
  shadowType?: Maybe<ShadowType>;
  updatedAt: Scalars['Date'];
  user: User;
};

export enum UserSortFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

export type Vendor = {
  businessAddress?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasDefaultContact?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  risks?: Maybe<Array<Maybe<VendorRisk>>>;
  updatedAt: Scalars['Date'];
};

export type VendorAgreementMeta = {
  hasNecessaryPrivacyDisclosure?: Maybe<Scalars['Boolean']>;
  isPersonAuthorizedToAnswer?: Maybe<Scalars['Boolean']>;
  maintainsSafeguardsForCustInfo?: Maybe<Scalars['Boolean']>;
  responsesCompleteAndTruthful?: Maybe<Scalars['Boolean']>;
};

export type VendorAgreementMetaInput = {
  hasNecessaryPrivacyDisclosure?: InputMaybe<Scalars['Boolean']>;
  isPersonAuthorizedToAnswer?: InputMaybe<Scalars['Boolean']>;
  maintainsSafeguardsForCustInfo?: InputMaybe<Scalars['Boolean']>;
  responsesCompleteAndTruthful?: InputMaybe<Scalars['Boolean']>;
};

export type VendorConnection = {
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  hasDefaultContact?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganization = {
  contactEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastVendorRequest?: Maybe<VendorRequest>;
  organization: Organization;
  sharedData?: Maybe<SharedData>;
  updatedAt: Scalars['Date'];
  vendor: Vendor;
  vendorRequests?: Maybe<Array<Maybe<VendorRequest>>>;
};


export type VendorOrganizationOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<VendorOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorOrganizationContactFilters = {
  includeContactIfDefault?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganizationFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  requestStatuses?: InputMaybe<Array<InputMaybe<VendorRequestStatus>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum VendorOrganizationSortFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrgName = 'orgName',
  UpdatedAt = 'updatedAt',
  VendorName = 'vendorName'
}

export type VendorOrganizationSortFields = {
  fields?: InputMaybe<Array<InputMaybe<VendorOrganizationSortFieldEnum>>>;
  order?: InputMaybe<SortOrder>;
};

export type VendorQuestionnaireResponse = {
  data?: Maybe<RestVendorQuestionnaireResponseData>;
  status: VendorQuestionnaireStatus;
};

export enum VendorQuestionnaireStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  LinkExpired = 'LinkExpired',
  LinkInvalid = 'LinkInvalid',
  Unopened = 'Unopened'
}

export type VendorRequest = {
  archivedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  deniedAt?: Maybe<Scalars['Date']>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkExpiredAt?: Maybe<Scalars['Date']>;
  openedAt?: Maybe<Scalars['Date']>;
  organization: Organization;
  reviewedAt?: Maybe<Scalars['Date']>;
  sentAt?: Maybe<Scalars['Date']>;
  startedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<VendorRequestStatus>;
  updatedAt: Scalars['Date'];
  vendor: Vendor;
  vendorOrganization?: Maybe<VendorOrganization>;
  vendorRisk?: Maybe<VendorRisk>;
};


export type VendorRequestOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type VendorRequestConnection = {
  nodes?: Maybe<Array<Maybe<VendorRequest>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorRequestFilters = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<VendorRequestStatus>>>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendorRiskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum VendorRequestSortFieldEnum {
  CompletedAt = 'completedAt',
  DeniedAt = 'deniedAt',
  Id = 'id',
  LinkExpiredAt = 'linkExpiredAt',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  SentAt = 'sentAt',
  VendorName = 'vendorName'
}

export enum VendorRequestStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Denied = 'Denied',
  LinkExpired = 'LinkExpired',
  Opened = 'Opened',
  Reviewed = 'Reviewed',
  Sent = 'Sent',
  Started = 'Started'
}

export type VendorRisk = {
  archivedAt?: Maybe<Scalars['Date']>;
  assessmentUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  data?: Maybe<VendorRiskResponseData>;
  deletedAt?: Maybe<Scalars['Date']>;
  document?: Maybe<Document>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isGlobal?: Maybe<Scalars['Boolean']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  status?: Maybe<VendorRiskStatus>;
  updatedAt: Scalars['Date'];
  vendor?: Maybe<Vendor>;
  vendorRequests?: Maybe<Array<Maybe<VendorRequest>>>;
};


export type VendorRiskOrganizationsArgs = {
  organizationSorting?: InputMaybe<OrganizationSorting>;
};

export type VendorRiskAnswer = {
  code: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VendorRiskAnswerInput = {
  code: Scalars['String'];
  otherText?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VendorRiskConnection = {
  nodes?: Maybe<Array<Maybe<VendorRisk>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorRiskDocumentInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorRiskId?: InputMaybe<Scalars['ID']>;
};

export enum VendorRiskFieldSortEnum {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  VendorName = 'vendorName'
}

export type VendorRiskFilters = {
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  responseTypes?: InputMaybe<Array<InputMaybe<VendorRiskResponseType>>>;
  status?: InputMaybe<Array<InputMaybe<VendorRiskStatus>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type VendorRiskQuestion = {
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOption>;
  title: Scalars['String'];
};

export type VendorRiskQuestionInput = {
  answer?: InputMaybe<VendorRiskAnswerInput>;
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOptionInput>;
  title: Scalars['String'];
};

export type VendorRiskQuestionWithAnswer = {
  answer?: Maybe<VendorRiskAnswer>;
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOption>;
  title: Scalars['String'];
};

export type VendorRiskResponseData = {
  sections?: Maybe<Array<VendorRiskSectionWithAnswer>>;
  stepState?: Maybe<StepState>;
};

export type VendorRiskResponseDataInput = {
  sections?: InputMaybe<Array<VendorRiskSectionInput>>;
  stepState?: InputMaybe<StepStateInput>;
};

export type VendorRiskResponseOption = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type VendorRiskResponseOptionInput = {
  code: Scalars['String'];
  otherText?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum VendorRiskResponseType {
  DealershipUpload = 'DealershipUpload',
  VendorUpload = 'VendorUpload'
}

export type VendorRiskSection = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<VendorRiskQuestion>;
  title: Scalars['String'];
};

export type VendorRiskSectionInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<VendorRiskQuestionInput>;
  title: Scalars['String'];
};

export type VendorRiskSectionWithAnswer = {
  code: Scalars['String'];
  id: Scalars['ID'];
  questions: Array<VendorRiskQuestionWithAnswer>;
  title: Scalars['String'];
};

export enum VendorRiskStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Started = 'Started'
}

export type VendorRiskTemplate = {
  sections: Array<VendorRiskSection>;
};

export enum VendorSortFieldEnum {
  BusinessName = 'businessName',
  ContactEmail = 'contactEmail',
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type UpdateRiskTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  functionCategory?: InputMaybe<RegisteredRiskFunctionCategory>;
  rating?: InputMaybe<RiskRating>;
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorOrganizationInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  sharedData?: InputMaybe<SharedDataInput>;
  vendorOrganizationId: Scalars['ID'];
};

export type LastVendorRequestsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type LastVendorRequestsQuery = { lastVendorRequests: Array<{ vendorId: string, request?: { id: string, contactEmail?: string | null, lastVendorRequest?: { status?: VendorRequestStatus | null, vendorRisk?: { status?: VendorRiskStatus | null } | null } | null, sharedData?: { consumerFinancialData: { creditData: boolean, employeeHistory: boolean, financialAccountNumbers: boolean, income: boolean, paymentData: boolean }, consumerIdentityData: { emailAddress: boolean, homeAddress: boolean, name: boolean, phone: boolean }, otherConsumerData: { assets: boolean, education: boolean, familialData: boolean, insuranceData: boolean }, sensitiveConsumerData: { dateOfBirth: boolean, driverLicenseNumber: boolean, ssn: boolean } } | null } | null }> };

export type RisksQueryVariables = Exact<{
  riskFilters?: InputMaybe<RiskFilters>;
  taskFilters?: InputMaybe<TaskFilters>;
  riskAssessmentDocumentId: Scalars['ID'];
}>;


export type RisksQuery = { risks?: Array<{ coreFunction: string, createdAt: string, updatedAt: string, functionCategory: FunctionCategory, id: string, rating: string, title: string, riskAssessmentDocument?: { organization: { id: string } } | null, tasks?: Array<{ createdAt?: string | null, description?: string | null, dueDate?: string | null, isComplete?: boolean | null, title?: string | null, updatedAt?: string | null, id: string, assignee?: { email?: string | null, firstName?: string | null, id: string, imageUrl?: string | null, lastName?: string | null } | null, risk?: { id: string } | null } | null> | null } | null> | null };

export type AddUserToOrganizationMutationVariables = Exact<{
  userParams: AddUserInput;
}>;


export type AddUserToOrganizationMutation = { addUserToOrganization?: { firstName?: string | null, lastName?: string | null, email?: string | null, id: string } | null };

export type CheckRiskRegistryAnswersQueryVariables = Exact<{
  organizationInputs: Array<InputMaybe<CheckRiskRegistryAnswerInput>> | InputMaybe<CheckRiskRegistryAnswerInput>;
}>;


export type CheckRiskRegistryAnswersQuery = { checkRiskRegistryAnswers?: Array<{ organizationId: string, hasNoAnswers: boolean, isSilenced: boolean, answers?: Array<{ answer?: string | null, expiresAt?: string | null, id: string, question: { questionShorthand: QuestionShorthand }, organization: { onboardingUntil?: string | null } } | null> | null } | null> | null };

export type CreateActionItemRisksMutationVariables = Exact<{
  createActionItemRisksId: Scalars['ID'];
}>;


export type CreateActionItemRisksMutation = { createActionItemRisks?: { id: string } | null };

export type CreateAllRegisteredRisksMutationVariables = Exact<{
  input?: InputMaybe<CreateAllRegisteredRisksInput>;
}>;


export type CreateAllRegisteredRisksMutation = { createAllRegisteredRisks: Array<{ id: string } | null> };

export type CreateDocumentByGuidMutationVariables = Exact<{
  guid: Scalars['String'];
  documentParams: CreateDocumentByGuidInput;
}>;


export type CreateDocumentByGuidMutation = { createDocumentByGuid?: { id: string } | null };

export type CreateDocumentMutationVariables = Exact<{
  documentParams?: InputMaybe<CreateDocumentInput>;
}>;


export type CreateDocumentMutation = { createDocument?: { id: string } | null };

export type CreateEditedPolicyDocumentMutationVariables = Exact<{
  editPolicyDocumentParams?: InputMaybe<CreateEditedPolicyDocumentInput>;
}>;


export type CreateEditedPolicyDocumentMutation = { createEditedPolicyDocument?: { id: string } | null };

export type CreateExecutiveReportMutationVariables = Exact<{
  executiveReportParams?: InputMaybe<CreateExecutiveReportInput>;
}>;


export type CreateExecutiveReportMutation = { createExecutiveReport?: { id: string } | null };

export type CreateNavigationEventMutationVariables = Exact<{
  input?: InputMaybe<CreateNavigationEventInput>;
}>;


export type CreateNavigationEventMutation = { createNavigationEvent?: { id: string } | null };

export type CreateOrganizationMutationVariables = Exact<{
  organization?: InputMaybe<OrganizationInput>;
}>;


export type CreateOrganizationMutation = { createOrganization?: { id: string } | null };

export type CreatePolicyDocumentMutationVariables = Exact<{
  policyDocumentParams?: InputMaybe<CreatePolicyDocumentInput>;
}>;


export type CreatePolicyDocumentMutation = { createPolicyDocument?: { colorHex: string, templateTitle?: string | null, title: string, footer?: string | null, subtitle?: string | null, id: string, organization: { id: string }, sections?: Array<{ title?: string | null, isAdvancedMode: boolean, htmlBody?: string | null } | null> | null } | null };

export type CreateRegisteredRiskMutationVariables = Exact<{
  input: CreateRegisteredRiskInput;
}>;


export type CreateRegisteredRiskMutation = { createRegisteredRisk: { id: string, isMuted?: boolean | null, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, resolvedAt?: string | null, acceptedAt?: string | null, createdAt: string, updatedAt: string, archivedAt?: string | null, organization: { id: string }, riskTemplate?: { id: string, groupName: RiskTemplateGroup, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, templateShorthand: TemplateShorthand, createdAt: string, updatedAt: string, archivedAt?: string | null, deletedAt?: string | null } | null } };

export type CreateRiskAssessmentDocumentMutationVariables = Exact<{
  riskAssessmentParams?: InputMaybe<CreateRiskAssessmentInput>;
}>;


export type CreateRiskAssessmentDocumentMutation = { createRiskAssessmentDocument?: { createdAt: string, id: string, updatedAt: string } | null };

export type CreateRiskCommentMutationVariables = Exact<{
  input?: InputMaybe<CreateRiskCommentInput>;
}>;


export type CreateRiskCommentMutation = { createRiskComment: { id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } };

export type CreateRiskMutationVariables = Exact<{
  input?: InputMaybe<RiskInput>;
}>;


export type CreateRiskMutation = { createRisk?: { id: string, createdAt: string, functionCategory: FunctionCategory, rating: string, title: string, updatedAt: string } | null };

export type CreateRiskRegistryAnswersMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  answers: Array<InputMaybe<RiskRegistryAnswerInput>> | InputMaybe<RiskRegistryAnswerInput>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateRiskRegistryAnswersMutation = { createRiskRegistryAnswers: Array<{ id: string, question: { questionShorthand: QuestionShorthand } } | null> };

export type CreateTaskCommentMutationVariables = Exact<{
  taskCommentParams?: InputMaybe<CreateTaskCommentInput>;
}>;


export type CreateTaskCommentMutation = { createTaskComment?: { id: string, text: string } | null };

export type CreateTaskMutationVariables = Exact<{
  task?: InputMaybe<TaskInput>;
}>;


export type CreateTaskMutation = { createTask: { id: string, title?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null } };

export type CreateVendorRequestMutationVariables = Exact<{
  vendorRequestParams?: InputMaybe<CreateVendorRequestInput>;
}>;


export type CreateVendorRequestMutation = { createVendorRequest?: { id: string } | null };

export type CreateVendorRiskByGuidMutationVariables = Exact<{
  vendorRisk?: InputMaybe<CreateVendorRiskByGuidInput>;
  guid: Scalars['String'];
}>;


export type CreateVendorRiskByGuidMutation = { createVendorRiskByGuid?: { id: string } | null };

export type DeleteTaskCommentMutationVariables = Exact<{
  taskCommentRemovalParams?: InputMaybe<RemoveTaskCommentInput>;
}>;


export type DeleteTaskCommentMutation = { deleteTaskComment?: { id: string } | null };

export type DeleteVendorOrganizationMutationVariables = Exact<{
  vendorOrganizationId: Scalars['ID'];
}>;


export type DeleteVendorOrganizationMutation = { deleteVendorOrganization?: { id: string } | null };

export type DocumentQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type DocumentQuery = { document?: { id: string, documentUrl?: string | null, description?: string | null, updatedAt?: string | null, expiresAt: string, category: DocumentCategory, createdAt?: string | null, title: string, organizations?: Array<{ name?: string | null } | null> | null, uploadedByUser?: { firstName?: string | null, lastName?: string | null } | null } | null };

export type DocumentsQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']>;
  documentFilters?: InputMaybe<DocumentFilters>;
  archived?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<DocumentFieldSortFieldEnum>;
}>;


export type DocumentsQuery = { documents?: { totalCount: number, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ archivedAt?: string | null, createdAt?: string | null, description?: string | null, documentUrl?: string | null, expiresAt: string, conductedAt?: string | null, id: string, title: string, updatedAt?: string | null, category: DocumentCategory, organizations?: Array<{ id: string, name?: string | null } | null> | null } | null> | null } | null };

export type DraftPolicyDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DraftPolicyDocumentQuery = { policyDocument?: { colorHex: string, description?: string | null, subtitle?: string | null, id: string, isDraft: boolean, title: string, templateType?: PolicyDocumentTemplateType | null, templateTitle?: string | null, footer?: string | null, sourcePolicyDocumentId?: string | null, createdByUser?: { imageUrl?: string | null, id: string, firstName?: string | null, lastName?: string | null } | null, organization: { name?: string | null, id: string, imageUrl?: string | null }, sections?: Array<{ title?: string | null, isAdvancedMode: boolean, id: string, htmlVars?: any | null, htmlBody?: string | null, hidden: boolean } | null> | null } | null };

export type DraftRiskAssessmentDocumentQueryVariables = Exact<{
  riskAssessmentDocumentId: Scalars['ID'];
}>;


export type DraftRiskAssessmentDocumentQuery = { riskAssessmentDocument?: { id: string, isDraft: boolean, status: RiskAssessmentStatus, organization: { id: string }, sections?: { OrganizationalOversight: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, AccessControl: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, SystemDeploymentAndMaintenance: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, DataProtection: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, NetworkSecurity: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, SecurityLoggingAndMonitoring: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, RiskManagementStrategy: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, IncidentResponse: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, BusinessContinuityAndDisasterRecovery: { code: string, id: string, title: string, questions: Array<{ code: string, coreFunction: string, description: string, functionCategory: FunctionCategory, note?: string | null, title: string, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> } } | null } | null };

export type EditPolicyDocumentMutationVariables = Exact<{
  policyDocumentParams?: InputMaybe<UpdatePolicyDocumentInput>;
}>;


export type EditPolicyDocumentMutation = { editPolicyDocument?: { id: string } | null };

export type ExecutiveReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExecutiveReportQuery = { executiveReport?: { id: string, pdfUrl?: string | null, isDraft: boolean, createdAt?: string | null, title: string, sections?: Array<{ data?: any | null, isComplete?: boolean | null } | null> | null, organization: { id: string, name?: string | null }, createdByUser?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type ExecutiveReportTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExecutiveReportTemplatesQuery = { executiveReportTemplates: Array<{ sections?: { introduction?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, ftcComplianceOverview?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, riskAssessmentResults?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, securityMetrics?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null, metricsSections?: Array<{ title: string, code: string, metrics?: Array<{ title: string, code: string, format?: MetricFormat | null, ratings: Array<{ range: `${`[${number | number}` | `(${number | number}` | '('},${`${number | number}]` | `${number | number})` | ')'}`, rating: MetricRating } | null> } | null> | null } | null> | null } | null, vendorOversightStatus?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, additionalIssues?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, keyRiskManagementActivities?: { id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null, customSections?: Array<{ id: string, title: string, helperHtml?: string | null, templateHtml?: string | null } | null> | null } | null } | null> };

export type ExecutiveReportsQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExecutiveReportsQuery = { executiveReports?: { totalCount: number, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ id: string, title: string, createdAt?: string | null, pdfUrl?: string | null, isDraft: boolean, organization: { id: string, name?: string | null } } | null> | null } | null };

export type GetCompletedSectionMapQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  isOnboarding?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCompletedSectionMapQuery = { getCompletedSectionMap?: { AccessManagement: boolean, BusinessAndCompliance: boolean, NetworkManagement: boolean, DeviceManagement: boolean, EndpointSecurity: boolean, EmailSecurity: boolean } | null };

export type GetFilteredAnswersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  questionSet: QuestionSet;
}>;


export type GetFilteredAnswersQuery = { getFilteredAnswers?: Array<{ id: string, answer?: string | null, question: { questionShorthand: QuestionShorthand } } | null> | null };

export type GetRiskHeartbeatRecordQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetRiskHeartbeatRecordQuery = { getRiskHeartbeatRecord?: { id: string, lastHeartbeat?: string | null, user: { firstName?: string | null, lastName?: string | null } } | null };

export type KeyPersonnelQueryVariables = Exact<{ [key: string]: never; }>;


export type KeyPersonnelQuery = { me?: { id: string, organizations?: Array<{ name?: string | null, id: string, cif?: string | null, keyPersonnel?: Array<{ name: string, title: string } | null> | null, userRoles?: Array<{ owner: boolean, user?: { id: string } | null } | null> | null } | null> | null } | null };

export type UpdateKeyPersonnelMutationVariables = Exact<{
  input: UpdateKeyPersonnelInput;
}>;


export type UpdateKeyPersonnelMutation = { updateKeyPersonnel?: { id: string, keyPersonnel?: Array<{ name: string, title: string } | null> | null } | null };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationQuery = { organization?: { accountType?: OrganizationAccountType | null, modalsMutedAt?: string | null, addressLine1?: string | null, state?: string | null, id: string, name?: string | null, country?: string | null, city?: string | null, phone?: string | null, cif?: string | null, owned?: boolean | null, zip?: string | null, imageUrl?: string | null, onboardingUntil?: string | null, usePolicyCreatorAutomation?: boolean | null, usePolicyReminderCadence?: AutomationReminderCadence | null, usePolicyLastReminded?: string | null, useIncidentResponsePlanAutomation?: boolean | null, useIncidentResponsePlanCadence?: AutomationReminderCadence | null, useIncidentResponseLastReminded?: string | null, notificationSettings?: { trainingAndPhishingReport?: { notificationType: NotificationType, frequency: NotificationFrequency, enabled: boolean, sendTo: Array<SendTo | null> } | null, pendingActionItemsReport?: { notificationType: NotificationType, frequency: NotificationFrequency, enabled: boolean, sendTo: Array<SendTo | null> } | null, deviceManagementReport?: { notificationType: NotificationType, frequency: NotificationFrequency, enabled: boolean, sendTo: Array<SendTo | null> } | null, securityResponseReport?: { notificationType: NotificationType, frequency: NotificationFrequency, enabled: boolean, sendTo: Array<SendTo | null> } | null, documentUpload?: { notificationType: NotificationType, frequency: NotificationFrequency, enabled: boolean, sendTo: Array<SendTo | null> } | null } | null, keyPersonnel?: Array<{ title: string, name: string } | null> | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  updateOrganizationId?: InputMaybe<Scalars['ID']>;
  organization?: InputMaybe<OrganizationInput>;
}>;


export type EditOrganizationMutation = { updateOrganization?: { id: string } | null };

export type MembersOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type MembersOrganizationQuery = { organization?: { userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
}>;


export type RemoveMemberMutation = { removeMember?: { id: string } | null };

export type PolicyDocumentQueryVariables = Exact<{
  policyDocumentId: Scalars['ID'];
}>;


export type PolicyDocumentQuery = { policyDocument?: { colorHex: string, createdAt: string, isDraft: boolean, description?: string | null, id: string, title: string, templateType?: PolicyDocumentTemplateType | null, sourcePolicyDocumentId?: string | null, createdByUser?: { imageUrl?: string | null, id: string, firstName?: string | null, lastName?: string | null } | null, sections?: Array<{ htmlVars?: any | null } | null> | null, organization: { name?: string | null } } | null };

export type PolicyDocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type PolicyDocumentTemplatesQuery = { policyDocumentTemplates?: Array<{ subtitle?: string | null, title: string, id: string, type?: PolicyDocumentTemplateType | null } | null> | null };

export type GetPolicyDocumentTemplateQueryVariables = Exact<{
  policyDocumentTemplateType: PolicyDocumentTemplateType;
}>;


export type GetPolicyDocumentTemplateQuery = { policyDocumentTemplate?: { title: string, type?: PolicyDocumentTemplateType | null, subtitle?: string | null, id: string, sections?: Array<{ title: string, templateHtml: string, helperHtml?: string | null, id: string, templateVars?: Array<{ value?: string | null, key: string, recommendedValue?: string | null, optional?: boolean | null } | null> | null } | null> | null } | null };

export type PolicyDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type PolicyDocumentsQuery = { policyDocuments?: { totalCount: number, pageInfo: { startCursor?: string | null }, nodes?: Array<{ id: string, documentId?: string | null, title: string, colorHex: string, iconImageUrl?: string | null, isDraft: boolean, sourcePolicyDocumentId?: string | null, createdAt: string, organization: { id: string, name?: string | null }, sections?: Array<{ htmlVars?: any | null } | null> | null } | null> | null } | null };

export type RegisteredRiskQueryVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type RegisteredRiskQuery = { registeredRisk?: { acceptedAt?: string | null, createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, id: string, isMuted?: boolean | null, rating: RiskRating, resolvedAt?: string | null, title: string, updatedAt: string, organization: { id: string }, riskComments?: Array<{ id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null, riskTemplate?: { templateShorthand: TemplateShorthand } | null } | null };

export type RegisteredRiskTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegisteredRiskTaskQuery = { registeredRiskTask: { id: string, title?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null } };

export type RegisteredRiskTasksQueryVariables = Exact<{
  registeredRiskId: Scalars['ID'];
}>;


export type RegisteredRiskTasksQuery = { registeredRiskTasks: Array<{ id: string, title?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null } | null> };

export type RegisteredRiskTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisteredRiskTemplatesQuery = { registeredRiskTemplates?: Array<{ id: string, groupName: RiskTemplateGroup, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string }> | null };

export type RegisteredRisksQueryVariables = Exact<{
  filters?: InputMaybe<RegisteredRiskFilters>;
  sortField?: InputMaybe<RegisteredRiskSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RegisteredRisksQuery = { registeredRisks?: Array<{ acceptedAt?: string | null, createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, id: string, isMuted?: boolean | null, rating: RiskRating, resolvedAt?: string | null, title: string, updatedAt: string, organization: { id: string, name?: string | null }, riskTemplate?: { createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, groupName: RiskTemplateGroup, id: string, rating: RiskRating, title: string, updatedAt: string, templateShorthand: TemplateShorthand, triggerConditions?: Array<{ condition: string, createdAt: string, id: string, updatedAt: string, question: { id: string, question: string, questionShorthand: QuestionShorthand, updatedAt: string, createdAt: string }, riskTemplate: { createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, groupName: RiskTemplateGroup, id: string, rating: RiskRating, title: string, updatedAt: string, templateShorthand: TemplateShorthand } } | null> | null } | null, riskComments?: Array<{ id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null, tasks?: Array<{ id: string, title?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null } | null> | null } | null> | null };

export type RemoveDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveDocumentMutation = { removeDocument?: { id: string } | null };

export type RemoveExecutiveReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveExecutiveReportMutation = { removeExecutiveReport?: { id: string } | null };

export type RemovePolicyDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePolicyDocumentMutation = { removePolicyDocument?: { id: string } | null };

export type RemoveRiskAssessmentDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveRiskAssessmentDocumentMutation = { removeRiskAssessmentDocument?: { id: string } | null };

export type RemoveRiskRegistryAnswersMutationVariables = Exact<{
  answerIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
}>;


export type RemoveRiskRegistryAnswersMutation = { removeRiskRegistryAnswers: Array<{ question: { questionShorthand: QuestionShorthand } } | null> };

export type RiskAssessmentDocumentQueryVariables = Exact<{
  riskAssessmentDocumentId: Scalars['ID'];
}>;


export type RiskAssessmentDocumentQuery = { riskAssessmentDocument?: { createdAt: string, updatedAt: string, completedAt?: string | null, status: RiskAssessmentStatus, organization: { name?: string | null }, risks?: Array<{ coreFunction: string, createdAt: string, updatedAt: string, functionCategory: FunctionCategory, id: string, rating: string, title: string, riskAssessmentDocument?: { organization: { id: string } } | null, tasks?: Array<{ createdAt?: string | null, description?: string | null, dueDate?: string | null, isComplete?: boolean | null, title?: string | null, updatedAt?: string | null, id: string, assignee?: { email?: string | null, firstName?: string | null, id: string, imageUrl?: string | null, lastName?: string | null } | null, risk?: { id: string } | null } | null> | null } | null> | null, sections?: { OrganizationalOversight: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, AccessControl: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, SystemDeploymentAndMaintenance: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, DataProtection: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, NetworkSecurity: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, SecurityLoggingAndMonitoring: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, RiskManagementStrategy: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, IncidentResponse: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> }, BusinessContinuityAndDisasterRecovery: { id: string, code: string, title: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, options: Array<{ code: string, title: string }>, answer?: { code: string, title: string } | null }> } } | null } | null };

export type GetRiskAssessmentDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  sortBy?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
}>;


export type GetRiskAssessmentDocumentsQuery = { riskAssessmentDocuments?: { totalCount: number, nodes?: Array<{ id: string, isDraft: boolean, status: RiskAssessmentStatus, createdAt: string, document?: { id: string } | null, organization: { id: string, name?: string | null }, risks?: Array<{ id: string, title: string, coreFunction: string, functionCategory: FunctionCategory, rating: string, tasks?: Array<{ id: string, title?: string | null, dueDate?: string | null, isComplete?: boolean | null, completedAt?: string | null, description?: string | null, assignee?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetRiskAssessmentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskAssessmentTemplatesQuery = { riskAssessmentTemplates: Array<{ sections: { OrganizationalOversight: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, AccessControl: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, SystemDeploymentAndMaintenance: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, DataProtection: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, NetworkSecurity: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, SecurityLoggingAndMonitoring: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, RiskManagementStrategy: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, IncidentResponse: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> }, BusinessContinuityAndDisasterRecovery: { code: string, id: string, helperHtml?: string | null, title: string, questions: Array<{ title: string, description: string, code: string, coreFunction: string, functionCategory: FunctionCategory, options: Array<{ title: string, code: string }> }> } } } | null> };

export type RiskRegistryAnswersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type RiskRegistryAnswersQuery = { riskRegistryAnswers?: Array<{ answer?: string | null, expiresAt?: string | null, question: { questionShorthand: QuestionShorthand } } | null> | null };

export type RoadmapQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type RoadmapQuery = { organization?: { id: string, name?: string | null, roadmap?: { WrittenInformationSecurityProgram?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, WrittenRiskAssessment?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, SecurityAwarenessProgram?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, OverseeServiceProviders?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, AccessControl?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, TechnicalRequirements?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, SecurityTesting?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, DevelopResponsePlan?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null, ExecutiveReporting?: { acknowledgementItems?: Array<{ title: string } | null> | null, actionItems?: Array<{ title: string, type?: ActionItemType | null } | null> | null } | null } | null } | null };

export type OrganizationRoadmapsQueryVariables = Exact<{
  organizationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OrganizationRoadmapsQuery = { organizations?: Array<{ id: string, name?: string | null, roadmap?: { WrittenInformationSecurityProgram?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string, data?: { templateType?: PolicyDocumentTemplateType | null, policyDocument?: { id: string, isDraft: boolean, sourcePolicyDocumentId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, WrittenRiskAssessment?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string, data?: { riskAssessment?: { id: string, isDraft: boolean } | null } | null } | null> | null } | null, SecurityAwarenessProgram?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, title: string, message: string } | null> | null } | null, OverseeServiceProviders?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string, data?: { vendorOrganization?: { id: string } | null, vendorRequest?: { id: string } | null } | null } | null> | null } | null, AccessControl?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string } | null> | null } | null, TechnicalRequirements?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string, data?: { riskAssessment?: { id: string, isDraft: boolean } | null } | null } | null> | null } | null, SecurityTesting?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string } | null> | null } | null, DevelopResponsePlan?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, title: string, message: string, data?: { templateType?: PolicyDocumentTemplateType | null, policyDocument?: { id: string, isDraft: boolean, sourcePolicyDocumentId?: string | null } | null } | null } | null> | null } | null, ExecutiveReporting?: { acknowledgementItems?: Array<{ completedAt?: string | null, createdAt: string, id: string, message: string, title: string } | null> | null, actionItems?: Array<{ type?: ActionItemType | null, message: string, title: string, data?: { executiveReport?: { id: string, isDraft: boolean } | null } | null } | null> | null } | null } | null } | null> | null };

export type SearchVendorsQueryVariables = Exact<{
  businessName?: InputMaybe<Scalars['String']>;
}>;


export type SearchVendorsQuery = { searchVendors?: Array<{ id: string, businessName: string, hasDefaultContact?: boolean | null } | null> | null };

export type SendVendorRequestReminderEmailMutationVariables = Exact<{
  vendorRequestId: Scalars['ID'];
}>;


export type SendVendorRequestReminderEmailMutation = { sendVendorRequestReminderEmail?: { id: string } | null };

export type SentinelOneResponseQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SentinelOneResponseQuery = { sentinelOneResponse?: { apiType: ApiType, response?: any | null, lastUpdatedAt?: string | null, organization: { id: string, name?: string | null } } | null, knowBe4Response?: { apiType: ApiType, response?: any | null, lastUpdatedAt?: string | null, organization: { id: string, name?: string | null } } | null };

export type SetAcknowledgementItemStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: AcknowledgementItemStatus;
}>;


export type SetAcknowledgementItemStatusMutation = { setAcknowledgementItemStatus?: { id: string } | null };

export type SetDocumentArchivedAtMutationVariables = Exact<{
  id: Scalars['ID'];
  archivedAt: Scalars['Date'];
}>;


export type SetDocumentArchivedAtMutation = { setDocumentArchivedAt?: { id: string } | null };

export type SetDocumentDescriptionMutationVariables = Exact<{
  id: Scalars['ID'];
  description: Scalars['String'];
}>;


export type SetDocumentDescriptionMutation = { setDocumentDescription?: { id: string } | null };

export type SetVendorRequestReviewStatusMutationVariables = Exact<{
  vendorRequestId: Scalars['ID'];
  isReviewed: Scalars['Boolean'];
}>;


export type SetVendorRequestReviewStatusMutation = { setVendorRequestReviewStatus?: { id: string } | null };

export type TaskCommentsQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type TaskCommentsQuery = { taskComments: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> };

export type UpdateAutomationSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  automationSettings: UpdateAutomationSettingsInput;
}>;


export type UpdateAutomationSettingsMutation = { updateAutomationSettings?: { id: string } | null };

export type UpdateOrganizationNotificationSettingsMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
}>;


export type UpdateOrganizationNotificationSettingsMutation = { updateOrganizationNotificationSettings?: { id: string } | null };

export type UpdateRegisteredRiskAcceptedAtMutationVariables = Exact<{
  registeredRiskId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateRegisteredRiskAcceptedAtMutation = { updateRegisteredRiskAcceptedAt: { acceptedAt?: string | null, archivedAt?: string | null, createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, id: string, isMuted?: boolean | null, rating: RiskRating, resolvedAt?: string | null, title: string, updatedAt: string, organization: { id: string }, riskComments?: Array<{ id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null } };

export type UpdateRegisteredRiskResolvedAtMutationVariables = Exact<{
  registeredRiskId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateRegisteredRiskResolvedAtMutation = { updateRegisteredRiskResolvedAt: { acceptedAt?: string | null, archivedAt?: string | null, createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, id: string, isMuted?: boolean | null, rating: RiskRating, resolvedAt?: string | null, title: string, updatedAt: string, organization: { id: string }, riskComments?: Array<{ id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null } };

export type DeleteRegisteredRiskMutationVariables = Exact<{
  registeredRiskId: Scalars['ID'];
}>;


export type DeleteRegisteredRiskMutation = { deleteRegisteredRisk: { id: string } };

export type UpdateRegisteredRiskMutationVariables = Exact<{
  input?: InputMaybe<UpdateRegisteredRiskInput>;
}>;


export type UpdateRegisteredRiskMutation = { updateRegisteredRisk: { acceptedAt?: string | null, archivedAt?: string | null, createdAt: string, description: string, functionCategory: RegisteredRiskFunctionCategory, id: string, isMuted?: boolean | null, rating: RiskRating, resolvedAt?: string | null, title: string, updatedAt: string, organization: { id: string }, riskComments?: Array<{ id: string, text: string, createdAt: string, updatedAt: string, registeredRisk: { id: string, title: string, description: string, rating: RiskRating, functionCategory: RegisteredRiskFunctionCategory, createdAt: string, updatedAt: string, organization: { id: string } }, user: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null } };

export type UpdateRiskHeartbeatRecordsMutationVariables = Exact<{
  organizationIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  sentAt: Scalars['Date'];
}>;


export type UpdateRiskHeartbeatRecordsMutation = { updateRiskHeartbeatRecords: boolean };

export type UpdateRiskRegistryAnswersMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  answers: Array<InputMaybe<UpdateRiskRegistryAnswerInput>> | InputMaybe<UpdateRiskRegistryAnswerInput>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRiskRegistryAnswersMutation = { updateRiskRegistryAnswers: Array<{ id: string } | null> };

export type SetTaskCompletionStatusMutationVariables = Exact<{
  taskId: Scalars['ID'];
  isComplete: Scalars['Boolean'];
}>;


export type SetTaskCompletionStatusMutation = { setTaskCompletionStatus: { id: string } };

export type SetTasksCompletionStatusMutationVariables = Exact<{
  riskId: Scalars['ID'];
  isComplete: Scalars['Boolean'];
}>;


export type SetTasksCompletionStatusMutation = { setTasksCompletionStatus?: { id: string } | null };

export type SetTaskDescriptionMutationVariables = Exact<{
  taskId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type SetTaskDescriptionMutation = { setDescriptionTask: { id: string } };

export type SetTaskAssigneeMutationVariables = Exact<{
  taskId: Scalars['ID'];
  assigneeId?: InputMaybe<Scalars['UserID']>;
}>;


export type SetTaskAssigneeMutation = { assignTask: { id: string, assignee?: { id: string } | null } };

export type UpdateTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  assigneeId?: InputMaybe<Scalars['UserID']>;
  title: Scalars['String'];
  dueDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateTaskMutation = { setTitleTask: { id: string }, setDescriptionTask: { id: string }, assignTask: { id: string }, setDueDateTask: { id: string } };

export type UpdateVendorOrganizationMutationVariables = Exact<{
  updateVendorOrganizationParams: UpdateVendorOrganizationInput;
}>;


export type UpdateVendorOrganizationMutation = { updateVendorOrganization?: { id: string } | null };

export type UpdateVendorRiskByGuidMutationVariables = Exact<{
  vendorRisk?: InputMaybe<UpdateVendorRiskByGuidInput>;
  guid: Scalars['String'];
}>;


export type UpdateVendorRiskByGuidMutation = { updateVendorRiskByGuid?: { id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null, organizations?: Array<{ id: string, accountType?: OrganizationAccountType | null, name?: string | null, legalName?: string | null, addressLine1?: string | null, addressLine2?: string | null, state?: string | null, zip?: string | null, country?: string | null, paidSubscription?: boolean | null, city?: string | null, cif?: string | null, imageUrl?: string | null, phone?: string | null, modalsMutedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, owned?: boolean | null, onboardingUntil?: string | null, keyPersonnel?: Array<{ title: string, name: string } | null> | null, userRoles?: Array<{ id: string, owner: boolean, createdAt?: string | null, updatedAt?: string | null } | null> | null } | null> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateMeMutation = { updateMe?: { firstName?: string | null, lastName?: string | null } | null };

export type VendorOrganizationQueryVariables = Exact<{
  vendorOrganizationId: Scalars['ID'];
}>;


export type VendorOrganizationQuery = { vendorOrganization?: { id: string, createdAt: string, contactEmail?: string | null, organization: { id: string, name?: string | null }, vendor: { businessName: string, businessAddress?: string | null }, lastVendorRequest?: { id: string, status?: VendorRequestStatus | null, linkExpiredAt?: string | null } | null, vendorRequests?: Array<{ id: string, createdAt: string, completedAt?: string | null, deniedAt?: string | null, reviewedAt?: string | null, organization: { id: string } } | null> | null, sharedData?: { consumerIdentityData: { name: boolean, homeAddress: boolean, phone: boolean, emailAddress: boolean }, sensitiveConsumerData: { ssn: boolean, dateOfBirth: boolean, driverLicenseNumber: boolean }, consumerFinancialData: { income: boolean, financialAccountNumbers: boolean, creditData: boolean, paymentData: boolean, employeeHistory: boolean }, otherConsumerData: { familialData: boolean, insuranceData: boolean, assets: boolean, education: boolean } } | null } | null };

export type VendorOrganizationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  vendorOrganizationFilters?: InputMaybe<VendorOrganizationFilters>;
  sortFields?: InputMaybe<VendorOrganizationSortFields>;
}>;


export type VendorOrganizationsQuery = { vendorOrganizations?: { totalCount: number, nodes?: Array<{ id: string, organization: { id: string, name?: string | null }, vendor: { businessName: string }, vendorRequests?: Array<{ id: string, createdAt: string, updatedAt: string, sentAt?: string | null, openedAt?: string | null, startedAt?: string | null, completedAt?: string | null, deniedAt?: string | null, archivedAt?: string | null, reviewedAt?: string | null, linkExpiredAt?: string | null, deletedAt?: string | null, status?: VendorRequestStatus | null, vendorRisk?: { id: string, status?: VendorRiskStatus | null, assessmentUrl?: string | null, expiredAt?: string | null, document?: { id: string } | null } | null } | null> | null } | null> | null, pageInfo: { startCursor?: string | null, hasNextPage: boolean } } | null };

export type VendorRequestQueryVariables = Exact<{
  vendorRequestId: Scalars['ID'];
}>;


export type VendorRequestQuery = { vendorRequest?: { id: string, reviewedAt?: string | null, deniedAt?: string | null, completedAt?: string | null, createdAt: string, openedAt?: string | null, sentAt?: string | null, startedAt?: string | null, vendorRisk?: { id: string, assessmentUrl?: string | null, completedAt?: string | null, expiredAt?: string | null, vendor?: { businessName: string } | null, document?: { id: string, documentUrl?: string | null, title: string } | null, data?: { stepState?: { vendorAgreementAnswers: { maintainsSafeguardsForCustInfo?: boolean | null, hasNecessaryPrivacyDisclosure?: boolean | null, responsesCompleteAndTruthful?: boolean | null, isPersonAuthorizedToAnswer?: boolean | null } } | null, sections?: Array<{ title: string, code: string, questions: Array<{ title: string, code: string, description: string, options: Array<{ title: string, code: string }>, answer?: { title: string, code: string, otherText?: string | null } | null }> }> | null } | null } | null } | null };

export type VendorRiskQueryVariables = Exact<{
  vendorRiskId: Scalars['ID'];
}>;


export type VendorRiskQuery = { vendorRisk?: { assessmentUrl?: string | null, vendor?: { businessAddress?: string | null, businessName: string } | null, organizations?: Array<{ name?: string | null } | null> | null } | null };

export type VendorRiskTemplatesQueryVariables = Exact<{
  guid: Scalars['String'];
}>;


export type VendorRiskTemplatesQuery = { vendorRiskTemplates: Array<{ sections: Array<{ id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, options: Array<{ title: string, code: string }> }> }> } | null> };

export type VendorRisksQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
  vendorFilters?: InputMaybe<VendorFilters>;
}>;


export type VendorRisksQuery = { vendorRisks?: { totalCount: number, nodes?: Array<{ id: string, createdAt: string, document?: { id: string } | null, organizations?: Array<{ id: string, name?: string | null } | null> | null, vendor?: { id: string, businessName: string } | null } | null> | null, pageInfo: { startCursor?: string | null, hasNextPage: boolean } } | null };

export type VendorsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  vendorFilters?: InputMaybe<VendorFilters>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type VendorsQuery = { vendors?: { nodes?: Array<{ businessName: string, id: string } | null> | null } | null };


export const LastVendorRequestsDocument = gql`
    query LastVendorRequests($organizationId: ID!, $vendorIds: [ID]) {
  lastVendorRequests(organizationId: $organizationId, vendorIds: $vendorIds) {
    vendorId
    request {
      id
      lastVendorRequest {
        status
        vendorRisk {
          status
        }
      }
      contactEmail
      sharedData {
        consumerFinancialData {
          creditData
          employeeHistory
          financialAccountNumbers
          income
          paymentData
        }
        consumerIdentityData {
          emailAddress
          homeAddress
          name
          phone
        }
        otherConsumerData {
          assets
          education
          familialData
          insuranceData
        }
        sensitiveConsumerData {
          dateOfBirth
          driverLicenseNumber
          ssn
        }
      }
    }
  }
}
    `;

/**
 * __useLastVendorRequestsQuery__
 *
 * To run a query within a React component, call `useLastVendorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastVendorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastVendorRequestsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      vendorIds: // value for 'vendorIds'
 *   },
 * });
 */
export function useLastVendorRequestsQuery(baseOptions: Apollo.QueryHookOptions<LastVendorRequestsQuery, LastVendorRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastVendorRequestsQuery, LastVendorRequestsQueryVariables>(LastVendorRequestsDocument, options);
      }
export function useLastVendorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastVendorRequestsQuery, LastVendorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastVendorRequestsQuery, LastVendorRequestsQueryVariables>(LastVendorRequestsDocument, options);
        }
export type LastVendorRequestsQueryHookResult = ReturnType<typeof useLastVendorRequestsQuery>;
export type LastVendorRequestsLazyQueryHookResult = ReturnType<typeof useLastVendorRequestsLazyQuery>;
export type LastVendorRequestsQueryResult = Apollo.QueryResult<LastVendorRequestsQuery, LastVendorRequestsQueryVariables>;
export const RisksDocument = gql`
    query Risks($riskFilters: RiskFilters, $taskFilters: TaskFilters, $riskAssessmentDocumentId: ID!) {
  risks(
    riskFilters: $riskFilters
    taskFilters: $taskFilters
    riskAssessmentDocumentId: $riskAssessmentDocumentId
  ) {
    coreFunction
    createdAt
    updatedAt
    functionCategory
    id
    riskAssessmentDocument {
      organization {
        id
      }
    }
    rating
    title
    tasks(taskFilters: $taskFilters) {
      assignee {
        email
        firstName
        id
        imageUrl
        lastName
      }
      risk {
        id
      }
      createdAt
      description
      dueDate
      isComplete
      title
      updatedAt
      id
    }
  }
}
    `;

/**
 * __useRisksQuery__
 *
 * To run a query within a React component, call `useRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRisksQuery({
 *   variables: {
 *      riskFilters: // value for 'riskFilters'
 *      taskFilters: // value for 'taskFilters'
 *      riskAssessmentDocumentId: // value for 'riskAssessmentDocumentId'
 *   },
 * });
 */
export function useRisksQuery(baseOptions: Apollo.QueryHookOptions<RisksQuery, RisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RisksQuery, RisksQueryVariables>(RisksDocument, options);
      }
export function useRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RisksQuery, RisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RisksQuery, RisksQueryVariables>(RisksDocument, options);
        }
export type RisksQueryHookResult = ReturnType<typeof useRisksQuery>;
export type RisksLazyQueryHookResult = ReturnType<typeof useRisksLazyQuery>;
export type RisksQueryResult = Apollo.QueryResult<RisksQuery, RisksQueryVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation AddUserToOrganization($userParams: AddUserInput!) {
  addUserToOrganization(userParams: $userParams) {
    firstName
    lastName
    email
    id
  }
}
    `;
export type AddUserToOrganizationMutationFn = Apollo.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = Apollo.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const CheckRiskRegistryAnswersDocument = gql`
    query CheckRiskRegistryAnswers($organizationInputs: [CheckRiskRegistryAnswerInput]!) {
  checkRiskRegistryAnswers(organizationInputs: $organizationInputs) {
    answers {
      answer
      expiresAt
      question {
        questionShorthand
      }
      id
      organization {
        onboardingUntil
      }
    }
    organizationId
    hasNoAnswers
    isSilenced
  }
}
    `;

/**
 * __useCheckRiskRegistryAnswersQuery__
 *
 * To run a query within a React component, call `useCheckRiskRegistryAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRiskRegistryAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRiskRegistryAnswersQuery({
 *   variables: {
 *      organizationInputs: // value for 'organizationInputs'
 *   },
 * });
 */
export function useCheckRiskRegistryAnswersQuery(baseOptions: Apollo.QueryHookOptions<CheckRiskRegistryAnswersQuery, CheckRiskRegistryAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckRiskRegistryAnswersQuery, CheckRiskRegistryAnswersQueryVariables>(CheckRiskRegistryAnswersDocument, options);
      }
export function useCheckRiskRegistryAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRiskRegistryAnswersQuery, CheckRiskRegistryAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckRiskRegistryAnswersQuery, CheckRiskRegistryAnswersQueryVariables>(CheckRiskRegistryAnswersDocument, options);
        }
export type CheckRiskRegistryAnswersQueryHookResult = ReturnType<typeof useCheckRiskRegistryAnswersQuery>;
export type CheckRiskRegistryAnswersLazyQueryHookResult = ReturnType<typeof useCheckRiskRegistryAnswersLazyQuery>;
export type CheckRiskRegistryAnswersQueryResult = Apollo.QueryResult<CheckRiskRegistryAnswersQuery, CheckRiskRegistryAnswersQueryVariables>;
export const CreateActionItemRisksDocument = gql`
    mutation createActionItemRisks($createActionItemRisksId: ID!) {
  createActionItemRisks(id: $createActionItemRisksId) {
    id
  }
}
    `;
export type CreateActionItemRisksMutationFn = Apollo.MutationFunction<CreateActionItemRisksMutation, CreateActionItemRisksMutationVariables>;

/**
 * __useCreateActionItemRisksMutation__
 *
 * To run a mutation, you first call `useCreateActionItemRisksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionItemRisksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionItemRisksMutation, { data, loading, error }] = useCreateActionItemRisksMutation({
 *   variables: {
 *      createActionItemRisksId: // value for 'createActionItemRisksId'
 *   },
 * });
 */
export function useCreateActionItemRisksMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionItemRisksMutation, CreateActionItemRisksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionItemRisksMutation, CreateActionItemRisksMutationVariables>(CreateActionItemRisksDocument, options);
      }
export type CreateActionItemRisksMutationHookResult = ReturnType<typeof useCreateActionItemRisksMutation>;
export type CreateActionItemRisksMutationResult = Apollo.MutationResult<CreateActionItemRisksMutation>;
export type CreateActionItemRisksMutationOptions = Apollo.BaseMutationOptions<CreateActionItemRisksMutation, CreateActionItemRisksMutationVariables>;
export const CreateAllRegisteredRisksDocument = gql`
    mutation CreateAllRegisteredRisks($input: CreateAllRegisteredRisksInput) {
  createAllRegisteredRisks(input: $input) {
    id
  }
}
    `;
export type CreateAllRegisteredRisksMutationFn = Apollo.MutationFunction<CreateAllRegisteredRisksMutation, CreateAllRegisteredRisksMutationVariables>;

/**
 * __useCreateAllRegisteredRisksMutation__
 *
 * To run a mutation, you first call `useCreateAllRegisteredRisksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllRegisteredRisksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllRegisteredRisksMutation, { data, loading, error }] = useCreateAllRegisteredRisksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllRegisteredRisksMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllRegisteredRisksMutation, CreateAllRegisteredRisksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllRegisteredRisksMutation, CreateAllRegisteredRisksMutationVariables>(CreateAllRegisteredRisksDocument, options);
      }
export type CreateAllRegisteredRisksMutationHookResult = ReturnType<typeof useCreateAllRegisteredRisksMutation>;
export type CreateAllRegisteredRisksMutationResult = Apollo.MutationResult<CreateAllRegisteredRisksMutation>;
export type CreateAllRegisteredRisksMutationOptions = Apollo.BaseMutationOptions<CreateAllRegisteredRisksMutation, CreateAllRegisteredRisksMutationVariables>;
export const CreateDocumentByGuidDocument = gql`
    mutation CreateDocumentByGuid($guid: String!, $documentParams: CreateDocumentByGuidInput!) {
  createDocumentByGuid(guid: $guid, documentParams: $documentParams) {
    id
  }
}
    `;
export type CreateDocumentByGuidMutationFn = Apollo.MutationFunction<CreateDocumentByGuidMutation, CreateDocumentByGuidMutationVariables>;

/**
 * __useCreateDocumentByGuidMutation__
 *
 * To run a mutation, you first call `useCreateDocumentByGuidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentByGuidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentByGuidMutation, { data, loading, error }] = useCreateDocumentByGuidMutation({
 *   variables: {
 *      guid: // value for 'guid'
 *      documentParams: // value for 'documentParams'
 *   },
 * });
 */
export function useCreateDocumentByGuidMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentByGuidMutation, CreateDocumentByGuidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentByGuidMutation, CreateDocumentByGuidMutationVariables>(CreateDocumentByGuidDocument, options);
      }
export type CreateDocumentByGuidMutationHookResult = ReturnType<typeof useCreateDocumentByGuidMutation>;
export type CreateDocumentByGuidMutationResult = Apollo.MutationResult<CreateDocumentByGuidMutation>;
export type CreateDocumentByGuidMutationOptions = Apollo.BaseMutationOptions<CreateDocumentByGuidMutation, CreateDocumentByGuidMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($documentParams: CreateDocumentInput) {
  createDocument(documentParams: $documentParams) {
    id
  }
}
    `;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      documentParams: // value for 'documentParams'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateEditedPolicyDocumentDocument = gql`
    mutation CreateEditedPolicyDocument($editPolicyDocumentParams: CreateEditedPolicyDocumentInput) {
  createEditedPolicyDocument(editPolicyDocumentParams: $editPolicyDocumentParams) {
    id
  }
}
    `;
export type CreateEditedPolicyDocumentMutationFn = Apollo.MutationFunction<CreateEditedPolicyDocumentMutation, CreateEditedPolicyDocumentMutationVariables>;

/**
 * __useCreateEditedPolicyDocumentMutation__
 *
 * To run a mutation, you first call `useCreateEditedPolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEditedPolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEditedPolicyDocumentMutation, { data, loading, error }] = useCreateEditedPolicyDocumentMutation({
 *   variables: {
 *      editPolicyDocumentParams: // value for 'editPolicyDocumentParams'
 *   },
 * });
 */
export function useCreateEditedPolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEditedPolicyDocumentMutation, CreateEditedPolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEditedPolicyDocumentMutation, CreateEditedPolicyDocumentMutationVariables>(CreateEditedPolicyDocumentDocument, options);
      }
export type CreateEditedPolicyDocumentMutationHookResult = ReturnType<typeof useCreateEditedPolicyDocumentMutation>;
export type CreateEditedPolicyDocumentMutationResult = Apollo.MutationResult<CreateEditedPolicyDocumentMutation>;
export type CreateEditedPolicyDocumentMutationOptions = Apollo.BaseMutationOptions<CreateEditedPolicyDocumentMutation, CreateEditedPolicyDocumentMutationVariables>;
export const CreateExecutiveReportDocument = gql`
    mutation CreateExecutiveReport($executiveReportParams: CreateExecutiveReportInput) {
  createExecutiveReport(executiveReportParams: $executiveReportParams) {
    id
  }
}
    `;
export type CreateExecutiveReportMutationFn = Apollo.MutationFunction<CreateExecutiveReportMutation, CreateExecutiveReportMutationVariables>;

/**
 * __useCreateExecutiveReportMutation__
 *
 * To run a mutation, you first call `useCreateExecutiveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExecutiveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExecutiveReportMutation, { data, loading, error }] = useCreateExecutiveReportMutation({
 *   variables: {
 *      executiveReportParams: // value for 'executiveReportParams'
 *   },
 * });
 */
export function useCreateExecutiveReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateExecutiveReportMutation, CreateExecutiveReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExecutiveReportMutation, CreateExecutiveReportMutationVariables>(CreateExecutiveReportDocument, options);
      }
export type CreateExecutiveReportMutationHookResult = ReturnType<typeof useCreateExecutiveReportMutation>;
export type CreateExecutiveReportMutationResult = Apollo.MutationResult<CreateExecutiveReportMutation>;
export type CreateExecutiveReportMutationOptions = Apollo.BaseMutationOptions<CreateExecutiveReportMutation, CreateExecutiveReportMutationVariables>;
export const CreateNavigationEventDocument = gql`
    mutation CreateNavigationEvent($input: CreateNavigationEventInput) {
  createNavigationEvent(input: $input) {
    id
  }
}
    `;
export type CreateNavigationEventMutationFn = Apollo.MutationFunction<CreateNavigationEventMutation, CreateNavigationEventMutationVariables>;

/**
 * __useCreateNavigationEventMutation__
 *
 * To run a mutation, you first call `useCreateNavigationEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNavigationEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNavigationEventMutation, { data, loading, error }] = useCreateNavigationEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNavigationEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateNavigationEventMutation, CreateNavigationEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNavigationEventMutation, CreateNavigationEventMutationVariables>(CreateNavigationEventDocument, options);
      }
export type CreateNavigationEventMutationHookResult = ReturnType<typeof useCreateNavigationEventMutation>;
export type CreateNavigationEventMutationResult = Apollo.MutationResult<CreateNavigationEventMutation>;
export type CreateNavigationEventMutationOptions = Apollo.BaseMutationOptions<CreateNavigationEventMutation, CreateNavigationEventMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($organization: OrganizationInput) {
  createOrganization(organization: $organization) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreatePolicyDocumentDocument = gql`
    mutation CreatePolicyDocument($policyDocumentParams: CreatePolicyDocumentInput) {
  createPolicyDocument(policyDocumentParams: $policyDocumentParams) {
    colorHex
    templateTitle
    title
    organization {
      id
    }
    sections {
      title
      isAdvancedMode
      htmlBody
    }
    footer
    subtitle
    id
  }
}
    `;
export type CreatePolicyDocumentMutationFn = Apollo.MutationFunction<CreatePolicyDocumentMutation, CreatePolicyDocumentMutationVariables>;

/**
 * __useCreatePolicyDocumentMutation__
 *
 * To run a mutation, you first call `useCreatePolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyDocumentMutation, { data, loading, error }] = useCreatePolicyDocumentMutation({
 *   variables: {
 *      policyDocumentParams: // value for 'policyDocumentParams'
 *   },
 * });
 */
export function useCreatePolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePolicyDocumentMutation, CreatePolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePolicyDocumentMutation, CreatePolicyDocumentMutationVariables>(CreatePolicyDocumentDocument, options);
      }
export type CreatePolicyDocumentMutationHookResult = ReturnType<typeof useCreatePolicyDocumentMutation>;
export type CreatePolicyDocumentMutationResult = Apollo.MutationResult<CreatePolicyDocumentMutation>;
export type CreatePolicyDocumentMutationOptions = Apollo.BaseMutationOptions<CreatePolicyDocumentMutation, CreatePolicyDocumentMutationVariables>;
export const CreateRegisteredRiskDocument = gql`
    mutation CreateRegisteredRisk($input: CreateRegisteredRiskInput!) {
  createRegisteredRisk(input: $input) {
    id
    organization {
      id
    }
    riskTemplate {
      id
      groupName
      title
      description
      rating
      functionCategory
      templateShorthand
      createdAt
      updatedAt
      archivedAt
      deletedAt
    }
    isMuted
    title
    description
    rating
    functionCategory
    resolvedAt
    acceptedAt
    createdAt
    updatedAt
    archivedAt
  }
}
    `;
export type CreateRegisteredRiskMutationFn = Apollo.MutationFunction<CreateRegisteredRiskMutation, CreateRegisteredRiskMutationVariables>;

/**
 * __useCreateRegisteredRiskMutation__
 *
 * To run a mutation, you first call `useCreateRegisteredRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegisteredRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegisteredRiskMutation, { data, loading, error }] = useCreateRegisteredRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegisteredRiskMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegisteredRiskMutation, CreateRegisteredRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegisteredRiskMutation, CreateRegisteredRiskMutationVariables>(CreateRegisteredRiskDocument, options);
      }
export type CreateRegisteredRiskMutationHookResult = ReturnType<typeof useCreateRegisteredRiskMutation>;
export type CreateRegisteredRiskMutationResult = Apollo.MutationResult<CreateRegisteredRiskMutation>;
export type CreateRegisteredRiskMutationOptions = Apollo.BaseMutationOptions<CreateRegisteredRiskMutation, CreateRegisteredRiskMutationVariables>;
export const CreateRiskAssessmentDocumentDocument = gql`
    mutation CreateRiskAssessmentDocument($riskAssessmentParams: CreateRiskAssessmentInput) {
  createRiskAssessmentDocument(riskAssessmentParams: $riskAssessmentParams) {
    createdAt
    id
    updatedAt
  }
}
    `;
export type CreateRiskAssessmentDocumentMutationFn = Apollo.MutationFunction<CreateRiskAssessmentDocumentMutation, CreateRiskAssessmentDocumentMutationVariables>;

/**
 * __useCreateRiskAssessmentDocumentMutation__
 *
 * To run a mutation, you first call `useCreateRiskAssessmentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskAssessmentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskAssessmentDocumentMutation, { data, loading, error }] = useCreateRiskAssessmentDocumentMutation({
 *   variables: {
 *      riskAssessmentParams: // value for 'riskAssessmentParams'
 *   },
 * });
 */
export function useCreateRiskAssessmentDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskAssessmentDocumentMutation, CreateRiskAssessmentDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskAssessmentDocumentMutation, CreateRiskAssessmentDocumentMutationVariables>(CreateRiskAssessmentDocumentDocument, options);
      }
export type CreateRiskAssessmentDocumentMutationHookResult = ReturnType<typeof useCreateRiskAssessmentDocumentMutation>;
export type CreateRiskAssessmentDocumentMutationResult = Apollo.MutationResult<CreateRiskAssessmentDocumentMutation>;
export type CreateRiskAssessmentDocumentMutationOptions = Apollo.BaseMutationOptions<CreateRiskAssessmentDocumentMutation, CreateRiskAssessmentDocumentMutationVariables>;
export const CreateRiskCommentDocument = gql`
    mutation CreateRiskComment($input: CreateRiskCommentInput) {
  createRiskComment(input: $input) {
    id
    text
    createdAt
    updatedAt
    registeredRisk {
      id
      title
      description
      rating
      functionCategory
      createdAt
      updatedAt
      organization {
        id
      }
    }
    user {
      id
      firstName
      lastName
      imageUrl
    }
  }
}
    `;
export type CreateRiskCommentMutationFn = Apollo.MutationFunction<CreateRiskCommentMutation, CreateRiskCommentMutationVariables>;

/**
 * __useCreateRiskCommentMutation__
 *
 * To run a mutation, you first call `useCreateRiskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskCommentMutation, { data, loading, error }] = useCreateRiskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRiskCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskCommentMutation, CreateRiskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskCommentMutation, CreateRiskCommentMutationVariables>(CreateRiskCommentDocument, options);
      }
export type CreateRiskCommentMutationHookResult = ReturnType<typeof useCreateRiskCommentMutation>;
export type CreateRiskCommentMutationResult = Apollo.MutationResult<CreateRiskCommentMutation>;
export type CreateRiskCommentMutationOptions = Apollo.BaseMutationOptions<CreateRiskCommentMutation, CreateRiskCommentMutationVariables>;
export const CreateRiskDocument = gql`
    mutation CreateRisk($input: RiskInput) {
  createRisk(input: $input) {
    id
    createdAt
    functionCategory
    rating
    title
    updatedAt
  }
}
    `;
export type CreateRiskMutationFn = Apollo.MutationFunction<CreateRiskMutation, CreateRiskMutationVariables>;

/**
 * __useCreateRiskMutation__
 *
 * To run a mutation, you first call `useCreateRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskMutation, { data, loading, error }] = useCreateRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRiskMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskMutation, CreateRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskMutation, CreateRiskMutationVariables>(CreateRiskDocument, options);
      }
export type CreateRiskMutationHookResult = ReturnType<typeof useCreateRiskMutation>;
export type CreateRiskMutationResult = Apollo.MutationResult<CreateRiskMutation>;
export type CreateRiskMutationOptions = Apollo.BaseMutationOptions<CreateRiskMutation, CreateRiskMutationVariables>;
export const CreateRiskRegistryAnswersDocument = gql`
    mutation CreateRiskRegistryAnswers($organizationId: ID!, $answers: [RiskRegistryAnswerInput]!, $notFromModals: Boolean) {
  createRiskRegistryAnswers(
    organizationId: $organizationId
    answers: $answers
    notFromModals: $notFromModals
  ) {
    id
    question {
      questionShorthand
    }
  }
}
    `;
export type CreateRiskRegistryAnswersMutationFn = Apollo.MutationFunction<CreateRiskRegistryAnswersMutation, CreateRiskRegistryAnswersMutationVariables>;

/**
 * __useCreateRiskRegistryAnswersMutation__
 *
 * To run a mutation, you first call `useCreateRiskRegistryAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskRegistryAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskRegistryAnswersMutation, { data, loading, error }] = useCreateRiskRegistryAnswersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      answers: // value for 'answers'
 *      notFromModals: // value for 'notFromModals'
 *   },
 * });
 */
export function useCreateRiskRegistryAnswersMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskRegistryAnswersMutation, CreateRiskRegistryAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskRegistryAnswersMutation, CreateRiskRegistryAnswersMutationVariables>(CreateRiskRegistryAnswersDocument, options);
      }
export type CreateRiskRegistryAnswersMutationHookResult = ReturnType<typeof useCreateRiskRegistryAnswersMutation>;
export type CreateRiskRegistryAnswersMutationResult = Apollo.MutationResult<CreateRiskRegistryAnswersMutation>;
export type CreateRiskRegistryAnswersMutationOptions = Apollo.BaseMutationOptions<CreateRiskRegistryAnswersMutation, CreateRiskRegistryAnswersMutationVariables>;
export const CreateTaskCommentDocument = gql`
    mutation CreateTaskComment($taskCommentParams: CreateTaskCommentInput) {
  createTaskComment(taskCommentParams: $taskCommentParams) {
    id
    text
  }
}
    `;
export type CreateTaskCommentMutationFn = Apollo.MutationFunction<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;

/**
 * __useCreateTaskCommentMutation__
 *
 * To run a mutation, you first call `useCreateTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskCommentMutation, { data, loading, error }] = useCreateTaskCommentMutation({
 *   variables: {
 *      taskCommentParams: // value for 'taskCommentParams'
 *   },
 * });
 */
export function useCreateTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>(CreateTaskCommentDocument, options);
      }
export type CreateTaskCommentMutationHookResult = ReturnType<typeof useCreateTaskCommentMutation>;
export type CreateTaskCommentMutationResult = Apollo.MutationResult<CreateTaskCommentMutation>;
export type CreateTaskCommentMutationOptions = Apollo.BaseMutationOptions<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($task: TaskInput) {
  createTask(task: $task) {
    id
    title
    description
    createdAt
    updatedAt
    comments {
      id
      text
      createdAt
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateVendorRequestDocument = gql`
    mutation CreateVendorRequest($vendorRequestParams: CreateVendorRequestInput) {
  createVendorRequest(vendorRequestParams: $vendorRequestParams) {
    id
  }
}
    `;
export type CreateVendorRequestMutationFn = Apollo.MutationFunction<CreateVendorRequestMutation, CreateVendorRequestMutationVariables>;

/**
 * __useCreateVendorRequestMutation__
 *
 * To run a mutation, you first call `useCreateVendorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorRequestMutation, { data, loading, error }] = useCreateVendorRequestMutation({
 *   variables: {
 *      vendorRequestParams: // value for 'vendorRequestParams'
 *   },
 * });
 */
export function useCreateVendorRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorRequestMutation, CreateVendorRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorRequestMutation, CreateVendorRequestMutationVariables>(CreateVendorRequestDocument, options);
      }
export type CreateVendorRequestMutationHookResult = ReturnType<typeof useCreateVendorRequestMutation>;
export type CreateVendorRequestMutationResult = Apollo.MutationResult<CreateVendorRequestMutation>;
export type CreateVendorRequestMutationOptions = Apollo.BaseMutationOptions<CreateVendorRequestMutation, CreateVendorRequestMutationVariables>;
export const CreateVendorRiskByGuidDocument = gql`
    mutation CreateVendorRiskByGuid($vendorRisk: CreateVendorRiskByGuidInput, $guid: String!) {
  createVendorRiskByGuid(vendorRisk: $vendorRisk, guid: $guid) {
    id
  }
}
    `;
export type CreateVendorRiskByGuidMutationFn = Apollo.MutationFunction<CreateVendorRiskByGuidMutation, CreateVendorRiskByGuidMutationVariables>;

/**
 * __useCreateVendorRiskByGuidMutation__
 *
 * To run a mutation, you first call `useCreateVendorRiskByGuidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorRiskByGuidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorRiskByGuidMutation, { data, loading, error }] = useCreateVendorRiskByGuidMutation({
 *   variables: {
 *      vendorRisk: // value for 'vendorRisk'
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useCreateVendorRiskByGuidMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorRiskByGuidMutation, CreateVendorRiskByGuidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorRiskByGuidMutation, CreateVendorRiskByGuidMutationVariables>(CreateVendorRiskByGuidDocument, options);
      }
export type CreateVendorRiskByGuidMutationHookResult = ReturnType<typeof useCreateVendorRiskByGuidMutation>;
export type CreateVendorRiskByGuidMutationResult = Apollo.MutationResult<CreateVendorRiskByGuidMutation>;
export type CreateVendorRiskByGuidMutationOptions = Apollo.BaseMutationOptions<CreateVendorRiskByGuidMutation, CreateVendorRiskByGuidMutationVariables>;
export const DeleteTaskCommentDocument = gql`
    mutation DeleteTaskComment($taskCommentRemovalParams: RemoveTaskCommentInput) {
  deleteTaskComment(taskCommentRemovalParams: $taskCommentRemovalParams) {
    id
  }
}
    `;
export type DeleteTaskCommentMutationFn = Apollo.MutationFunction<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>;

/**
 * __useDeleteTaskCommentMutation__
 *
 * To run a mutation, you first call `useDeleteTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskCommentMutation, { data, loading, error }] = useDeleteTaskCommentMutation({
 *   variables: {
 *      taskCommentRemovalParams: // value for 'taskCommentRemovalParams'
 *   },
 * });
 */
export function useDeleteTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>(DeleteTaskCommentDocument, options);
      }
export type DeleteTaskCommentMutationHookResult = ReturnType<typeof useDeleteTaskCommentMutation>;
export type DeleteTaskCommentMutationResult = Apollo.MutationResult<DeleteTaskCommentMutation>;
export type DeleteTaskCommentMutationOptions = Apollo.BaseMutationOptions<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>;
export const DeleteVendorOrganizationDocument = gql`
    mutation DeleteVendorOrganization($vendorOrganizationId: ID!) {
  deleteVendorOrganization(vendorOrganizationId: $vendorOrganizationId) {
    id
  }
}
    `;
export type DeleteVendorOrganizationMutationFn = Apollo.MutationFunction<DeleteVendorOrganizationMutation, DeleteVendorOrganizationMutationVariables>;

/**
 * __useDeleteVendorOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteVendorOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVendorOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVendorOrganizationMutation, { data, loading, error }] = useDeleteVendorOrganizationMutation({
 *   variables: {
 *      vendorOrganizationId: // value for 'vendorOrganizationId'
 *   },
 * });
 */
export function useDeleteVendorOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVendorOrganizationMutation, DeleteVendorOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVendorOrganizationMutation, DeleteVendorOrganizationMutationVariables>(DeleteVendorOrganizationDocument, options);
      }
export type DeleteVendorOrganizationMutationHookResult = ReturnType<typeof useDeleteVendorOrganizationMutation>;
export type DeleteVendorOrganizationMutationResult = Apollo.MutationResult<DeleteVendorOrganizationMutation>;
export type DeleteVendorOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteVendorOrganizationMutation, DeleteVendorOrganizationMutationVariables>;
export const DocumentDocument = gql`
    query Document($documentId: ID!) {
  document(documentId: $documentId) {
    id
    documentUrl
    description
    updatedAt
    organizations {
      name
    }
    expiresAt
    category
    createdAt
    uploadedByUser {
      firstName
      lastName
    }
    title
  }
}
    `;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($last: Int, $documentFilters: DocumentFilters, $archived: Boolean, $first: Int, $before: String, $sortBy: DocumentFieldSortFieldEnum) {
  documents(
    last: $last
    documentFilters: $documentFilters
    archived: $archived
    first: $first
    before: $before
    sortField: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    nodes {
      archivedAt
      createdAt
      description
      documentUrl
      expiresAt
      conductedAt
      id
      organizations {
        id
        name
      }
      title
      updatedAt
      category
    }
  }
}
    `;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      last: // value for 'last'
 *      documentFilters: // value for 'documentFilters'
 *      archived: // value for 'archived'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const DraftPolicyDocumentDocument = gql`
    query DraftPolicyDocument($id: ID!) {
  policyDocument(id: $id) {
    colorHex
    createdByUser {
      imageUrl
      id
      firstName
      lastName
    }
    description
    subtitle
    id
    isDraft
    title
    templateType
    templateTitle
    organization {
      name
      id
      imageUrl
    }
    footer
    sourcePolicyDocumentId
    sections {
      title
      isAdvancedMode
      id
      htmlVars
      htmlBody
      hidden
    }
  }
}
    `;

/**
 * __useDraftPolicyDocumentQuery__
 *
 * To run a query within a React component, call `useDraftPolicyDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPolicyDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPolicyDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDraftPolicyDocumentQuery(baseOptions: Apollo.QueryHookOptions<DraftPolicyDocumentQuery, DraftPolicyDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftPolicyDocumentQuery, DraftPolicyDocumentQueryVariables>(DraftPolicyDocumentDocument, options);
      }
export function useDraftPolicyDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftPolicyDocumentQuery, DraftPolicyDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftPolicyDocumentQuery, DraftPolicyDocumentQueryVariables>(DraftPolicyDocumentDocument, options);
        }
export type DraftPolicyDocumentQueryHookResult = ReturnType<typeof useDraftPolicyDocumentQuery>;
export type DraftPolicyDocumentLazyQueryHookResult = ReturnType<typeof useDraftPolicyDocumentLazyQuery>;
export type DraftPolicyDocumentQueryResult = Apollo.QueryResult<DraftPolicyDocumentQuery, DraftPolicyDocumentQueryVariables>;
export const DraftRiskAssessmentDocumentDocument = gql`
    query DraftRiskAssessmentDocument($riskAssessmentDocumentId: ID!) {
  riskAssessmentDocument(id: $riskAssessmentDocumentId) {
    id
    isDraft
    organization {
      id
    }
    sections {
      OrganizationalOversight {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      AccessControl {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      SystemDeploymentAndMaintenance {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      DataProtection {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      NetworkSecurity {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      SecurityLoggingAndMonitoring {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      RiskManagementStrategy {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      IncidentResponse {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
      BusinessContinuityAndDisasterRecovery {
        code
        id
        questions {
          code
          coreFunction
          description
          functionCategory
          note
          options {
            code
            title
          }
          title
          answer {
            code
            title
          }
        }
        title
      }
    }
    status
  }
}
    `;

/**
 * __useDraftRiskAssessmentDocumentQuery__
 *
 * To run a query within a React component, call `useDraftRiskAssessmentDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftRiskAssessmentDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftRiskAssessmentDocumentQuery({
 *   variables: {
 *      riskAssessmentDocumentId: // value for 'riskAssessmentDocumentId'
 *   },
 * });
 */
export function useDraftRiskAssessmentDocumentQuery(baseOptions: Apollo.QueryHookOptions<DraftRiskAssessmentDocumentQuery, DraftRiskAssessmentDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftRiskAssessmentDocumentQuery, DraftRiskAssessmentDocumentQueryVariables>(DraftRiskAssessmentDocumentDocument, options);
      }
export function useDraftRiskAssessmentDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftRiskAssessmentDocumentQuery, DraftRiskAssessmentDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftRiskAssessmentDocumentQuery, DraftRiskAssessmentDocumentQueryVariables>(DraftRiskAssessmentDocumentDocument, options);
        }
export type DraftRiskAssessmentDocumentQueryHookResult = ReturnType<typeof useDraftRiskAssessmentDocumentQuery>;
export type DraftRiskAssessmentDocumentLazyQueryHookResult = ReturnType<typeof useDraftRiskAssessmentDocumentLazyQuery>;
export type DraftRiskAssessmentDocumentQueryResult = Apollo.QueryResult<DraftRiskAssessmentDocumentQuery, DraftRiskAssessmentDocumentQueryVariables>;
export const EditPolicyDocumentDocument = gql`
    mutation EditPolicyDocument($policyDocumentParams: UpdatePolicyDocumentInput) {
  editPolicyDocument(policyDocumentParams: $policyDocumentParams) {
    id
  }
}
    `;
export type EditPolicyDocumentMutationFn = Apollo.MutationFunction<EditPolicyDocumentMutation, EditPolicyDocumentMutationVariables>;

/**
 * __useEditPolicyDocumentMutation__
 *
 * To run a mutation, you first call `useEditPolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPolicyDocumentMutation, { data, loading, error }] = useEditPolicyDocumentMutation({
 *   variables: {
 *      policyDocumentParams: // value for 'policyDocumentParams'
 *   },
 * });
 */
export function useEditPolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<EditPolicyDocumentMutation, EditPolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPolicyDocumentMutation, EditPolicyDocumentMutationVariables>(EditPolicyDocumentDocument, options);
      }
export type EditPolicyDocumentMutationHookResult = ReturnType<typeof useEditPolicyDocumentMutation>;
export type EditPolicyDocumentMutationResult = Apollo.MutationResult<EditPolicyDocumentMutation>;
export type EditPolicyDocumentMutationOptions = Apollo.BaseMutationOptions<EditPolicyDocumentMutation, EditPolicyDocumentMutationVariables>;
export const ExecutiveReportDocument = gql`
    query ExecutiveReport($id: ID!) {
  executiveReport(id: $id) {
    id
    pdfUrl
    isDraft
    sections {
      data
      isComplete
    }
    organization {
      id
      name
    }
    createdAt
    createdByUser {
      firstName
      lastName
      email
    }
    title
  }
}
    `;

/**
 * __useExecutiveReportQuery__
 *
 * To run a query within a React component, call `useExecutiveReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutiveReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutiveReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExecutiveReportQuery(baseOptions: Apollo.QueryHookOptions<ExecutiveReportQuery, ExecutiveReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecutiveReportQuery, ExecutiveReportQueryVariables>(ExecutiveReportDocument, options);
      }
export function useExecutiveReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecutiveReportQuery, ExecutiveReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecutiveReportQuery, ExecutiveReportQueryVariables>(ExecutiveReportDocument, options);
        }
export type ExecutiveReportQueryHookResult = ReturnType<typeof useExecutiveReportQuery>;
export type ExecutiveReportLazyQueryHookResult = ReturnType<typeof useExecutiveReportLazyQuery>;
export type ExecutiveReportQueryResult = Apollo.QueryResult<ExecutiveReportQuery, ExecutiveReportQueryVariables>;
export const ExecutiveReportTemplatesDocument = gql`
    query ExecutiveReportTemplates {
  executiveReportTemplates {
    sections {
      introduction {
        id
        title
        helperHtml
        templateHtml
      }
      ftcComplianceOverview {
        id
        title
        helperHtml
        templateHtml
      }
      riskAssessmentResults {
        id
        title
        helperHtml
        templateHtml
      }
      securityMetrics {
        id
        title
        helperHtml
        templateHtml
        metricsSections {
          title
          code
          metrics {
            title
            code
            format
            ratings {
              range
              rating
            }
          }
        }
      }
      vendorOversightStatus {
        id
        title
        helperHtml
        templateHtml
      }
      additionalIssues {
        id
        title
        helperHtml
        templateHtml
      }
      keyRiskManagementActivities {
        id
        title
        helperHtml
        templateHtml
      }
      customSections {
        id
        title
        helperHtml
        templateHtml
      }
    }
  }
}
    `;

/**
 * __useExecutiveReportTemplatesQuery__
 *
 * To run a query within a React component, call `useExecutiveReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutiveReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutiveReportTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExecutiveReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ExecutiveReportTemplatesQuery, ExecutiveReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecutiveReportTemplatesQuery, ExecutiveReportTemplatesQueryVariables>(ExecutiveReportTemplatesDocument, options);
      }
export function useExecutiveReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecutiveReportTemplatesQuery, ExecutiveReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecutiveReportTemplatesQuery, ExecutiveReportTemplatesQueryVariables>(ExecutiveReportTemplatesDocument, options);
        }
export type ExecutiveReportTemplatesQueryHookResult = ReturnType<typeof useExecutiveReportTemplatesQuery>;
export type ExecutiveReportTemplatesLazyQueryHookResult = ReturnType<typeof useExecutiveReportTemplatesLazyQuery>;
export type ExecutiveReportTemplatesQueryResult = Apollo.QueryResult<ExecutiveReportTemplatesQuery, ExecutiveReportTemplatesQueryVariables>;
export const ExecutiveReportsDocument = gql`
    query ExecutiveReports($last: Int, $before: String, $archived: Boolean) {
  executiveReports(last: $last, before: $before, archived: $archived) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    nodes {
      id
      title
      createdAt
      pdfUrl
      organization {
        id
        name
      }
      isDraft
    }
  }
}
    `;

/**
 * __useExecutiveReportsQuery__
 *
 * To run a query within a React component, call `useExecutiveReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutiveReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutiveReportsQuery({
 *   variables: {
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useExecutiveReportsQuery(baseOptions?: Apollo.QueryHookOptions<ExecutiveReportsQuery, ExecutiveReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecutiveReportsQuery, ExecutiveReportsQueryVariables>(ExecutiveReportsDocument, options);
      }
export function useExecutiveReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecutiveReportsQuery, ExecutiveReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecutiveReportsQuery, ExecutiveReportsQueryVariables>(ExecutiveReportsDocument, options);
        }
export type ExecutiveReportsQueryHookResult = ReturnType<typeof useExecutiveReportsQuery>;
export type ExecutiveReportsLazyQueryHookResult = ReturnType<typeof useExecutiveReportsLazyQuery>;
export type ExecutiveReportsQueryResult = Apollo.QueryResult<ExecutiveReportsQuery, ExecutiveReportsQueryVariables>;
export const GetCompletedSectionMapDocument = gql`
    query GetCompletedSectionMap($organizationId: ID!, $isOnboarding: Boolean) {
  getCompletedSectionMap(
    organizationId: $organizationId
    isOnboarding: $isOnboarding
  ) {
    AccessManagement
    BusinessAndCompliance
    NetworkManagement
    DeviceManagement
    EndpointSecurity
    EmailSecurity
  }
}
    `;

/**
 * __useGetCompletedSectionMapQuery__
 *
 * To run a query within a React component, call `useGetCompletedSectionMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedSectionMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedSectionMapQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      isOnboarding: // value for 'isOnboarding'
 *   },
 * });
 */
export function useGetCompletedSectionMapQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedSectionMapQuery, GetCompletedSectionMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedSectionMapQuery, GetCompletedSectionMapQueryVariables>(GetCompletedSectionMapDocument, options);
      }
export function useGetCompletedSectionMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedSectionMapQuery, GetCompletedSectionMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedSectionMapQuery, GetCompletedSectionMapQueryVariables>(GetCompletedSectionMapDocument, options);
        }
export type GetCompletedSectionMapQueryHookResult = ReturnType<typeof useGetCompletedSectionMapQuery>;
export type GetCompletedSectionMapLazyQueryHookResult = ReturnType<typeof useGetCompletedSectionMapLazyQuery>;
export type GetCompletedSectionMapQueryResult = Apollo.QueryResult<GetCompletedSectionMapQuery, GetCompletedSectionMapQueryVariables>;
export const GetFilteredAnswersDocument = gql`
    query GetFilteredAnswers($organizationId: ID!, $questionSet: QuestionSet!) {
  getFilteredAnswers(organizationId: $organizationId, questionSet: $questionSet) {
    id
    answer
    question {
      questionShorthand
    }
  }
}
    `;

/**
 * __useGetFilteredAnswersQuery__
 *
 * To run a query within a React component, call `useGetFilteredAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredAnswersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      questionSet: // value for 'questionSet'
 *   },
 * });
 */
export function useGetFilteredAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredAnswersQuery, GetFilteredAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredAnswersQuery, GetFilteredAnswersQueryVariables>(GetFilteredAnswersDocument, options);
      }
export function useGetFilteredAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredAnswersQuery, GetFilteredAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredAnswersQuery, GetFilteredAnswersQueryVariables>(GetFilteredAnswersDocument, options);
        }
export type GetFilteredAnswersQueryHookResult = ReturnType<typeof useGetFilteredAnswersQuery>;
export type GetFilteredAnswersLazyQueryHookResult = ReturnType<typeof useGetFilteredAnswersLazyQuery>;
export type GetFilteredAnswersQueryResult = Apollo.QueryResult<GetFilteredAnswersQuery, GetFilteredAnswersQueryVariables>;
export const GetRiskHeartbeatRecordDocument = gql`
    query GetRiskHeartbeatRecord($organizationId: ID!) {
  getRiskHeartbeatRecord(organizationId: $organizationId) {
    id
    lastHeartbeat
    user {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetRiskHeartbeatRecordQuery__
 *
 * To run a query within a React component, call `useGetRiskHeartbeatRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskHeartbeatRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskHeartbeatRecordQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRiskHeartbeatRecordQuery(baseOptions: Apollo.QueryHookOptions<GetRiskHeartbeatRecordQuery, GetRiskHeartbeatRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskHeartbeatRecordQuery, GetRiskHeartbeatRecordQueryVariables>(GetRiskHeartbeatRecordDocument, options);
      }
export function useGetRiskHeartbeatRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskHeartbeatRecordQuery, GetRiskHeartbeatRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskHeartbeatRecordQuery, GetRiskHeartbeatRecordQueryVariables>(GetRiskHeartbeatRecordDocument, options);
        }
export type GetRiskHeartbeatRecordQueryHookResult = ReturnType<typeof useGetRiskHeartbeatRecordQuery>;
export type GetRiskHeartbeatRecordLazyQueryHookResult = ReturnType<typeof useGetRiskHeartbeatRecordLazyQuery>;
export type GetRiskHeartbeatRecordQueryResult = Apollo.QueryResult<GetRiskHeartbeatRecordQuery, GetRiskHeartbeatRecordQueryVariables>;
export const KeyPersonnelDocument = gql`
    query KeyPersonnel {
  me {
    id
    organizations {
      name
      id
      cif
      keyPersonnel {
        name
        title
      }
      userRoles {
        owner
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useKeyPersonnelQuery__
 *
 * To run a query within a React component, call `useKeyPersonnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyPersonnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyPersonnelQuery({
 *   variables: {
 *   },
 * });
 */
export function useKeyPersonnelQuery(baseOptions?: Apollo.QueryHookOptions<KeyPersonnelQuery, KeyPersonnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyPersonnelQuery, KeyPersonnelQueryVariables>(KeyPersonnelDocument, options);
      }
export function useKeyPersonnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyPersonnelQuery, KeyPersonnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyPersonnelQuery, KeyPersonnelQueryVariables>(KeyPersonnelDocument, options);
        }
export type KeyPersonnelQueryHookResult = ReturnType<typeof useKeyPersonnelQuery>;
export type KeyPersonnelLazyQueryHookResult = ReturnType<typeof useKeyPersonnelLazyQuery>;
export type KeyPersonnelQueryResult = Apollo.QueryResult<KeyPersonnelQuery, KeyPersonnelQueryVariables>;
export const UpdateKeyPersonnelDocument = gql`
    mutation UpdateKeyPersonnel($input: UpdateKeyPersonnelInput!) {
  updateKeyPersonnel(input: $input) {
    id
    keyPersonnel {
      name
      title
    }
  }
}
    `;
export type UpdateKeyPersonnelMutationFn = Apollo.MutationFunction<UpdateKeyPersonnelMutation, UpdateKeyPersonnelMutationVariables>;

/**
 * __useUpdateKeyPersonnelMutation__
 *
 * To run a mutation, you first call `useUpdateKeyPersonnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyPersonnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyPersonnelMutation, { data, loading, error }] = useUpdateKeyPersonnelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyPersonnelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyPersonnelMutation, UpdateKeyPersonnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyPersonnelMutation, UpdateKeyPersonnelMutationVariables>(UpdateKeyPersonnelDocument, options);
      }
export type UpdateKeyPersonnelMutationHookResult = ReturnType<typeof useUpdateKeyPersonnelMutation>;
export type UpdateKeyPersonnelMutationResult = Apollo.MutationResult<UpdateKeyPersonnelMutation>;
export type UpdateKeyPersonnelMutationOptions = Apollo.BaseMutationOptions<UpdateKeyPersonnelMutation, UpdateKeyPersonnelMutationVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    notificationSettings {
      trainingAndPhishingReport {
        notificationType
        frequency
        enabled
        sendTo
      }
      pendingActionItemsReport {
        notificationType
        frequency
        enabled
        sendTo
      }
      deviceManagementReport {
        notificationType
        frequency
        enabled
        sendTo
      }
      securityResponseReport {
        notificationType
        frequency
        enabled
        sendTo
      }
      documentUpload {
        notificationType
        frequency
        enabled
        sendTo
      }
    }
    accountType
    modalsMutedAt
    addressLine1
    state
    id
    name
    country
    city
    phone
    cif
    owned
    zip
    keyPersonnel {
      title
      name
    }
    userRoles {
      id
      owner
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
    imageUrl
    onboardingUntil
    usePolicyCreatorAutomation
    usePolicyReminderCadence
    usePolicyLastReminded
    useIncidentResponsePlanAutomation
    useIncidentResponsePlanCadence
    useIncidentResponseLastReminded
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($updateOrganizationId: ID, $organization: OrganizationInput) {
  updateOrganization(id: $updateOrganizationId, organization: $organization) {
    id
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      updateOrganizationId: // value for 'updateOrganizationId'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const MembersOrganizationDocument = gql`
    query MembersOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    userRoles {
      id
      owner
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembersOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
      }
export function useMembersOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
export type MembersOrganizationQueryHookResult = ReturnType<typeof useMembersOrganizationQuery>;
export type MembersOrganizationLazyQueryHookResult = ReturnType<typeof useMembersOrganizationLazyQuery>;
export type MembersOrganizationQueryResult = Apollo.QueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: UserID!) {
  removeMember(organizationId: $organizationId, userId: $userId) {
    id
  }
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const PolicyDocumentDocument = gql`
    query PolicyDocument($policyDocumentId: ID!) {
  policyDocument(id: $policyDocumentId) {
    colorHex
    createdAt
    isDraft
    createdByUser {
      imageUrl
      id
      firstName
      lastName
    }
    description
    id
    title
    templateType
    sourcePolicyDocumentId
    sections {
      htmlVars
    }
    organization {
      name
    }
  }
}
    `;

/**
 * __usePolicyDocumentQuery__
 *
 * To run a query within a React component, call `usePolicyDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyDocumentQuery({
 *   variables: {
 *      policyDocumentId: // value for 'policyDocumentId'
 *   },
 * });
 */
export function usePolicyDocumentQuery(baseOptions: Apollo.QueryHookOptions<PolicyDocumentQuery, PolicyDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyDocumentQuery, PolicyDocumentQueryVariables>(PolicyDocumentDocument, options);
      }
export function usePolicyDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyDocumentQuery, PolicyDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyDocumentQuery, PolicyDocumentQueryVariables>(PolicyDocumentDocument, options);
        }
export type PolicyDocumentQueryHookResult = ReturnType<typeof usePolicyDocumentQuery>;
export type PolicyDocumentLazyQueryHookResult = ReturnType<typeof usePolicyDocumentLazyQuery>;
export type PolicyDocumentQueryResult = Apollo.QueryResult<PolicyDocumentQuery, PolicyDocumentQueryVariables>;
export const PolicyDocumentTemplatesDocument = gql`
    query policyDocumentTemplates {
  policyDocumentTemplates {
    subtitle
    title
    id
    type
  }
}
    `;

/**
 * __usePolicyDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `usePolicyDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePolicyDocumentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<PolicyDocumentTemplatesQuery, PolicyDocumentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyDocumentTemplatesQuery, PolicyDocumentTemplatesQueryVariables>(PolicyDocumentTemplatesDocument, options);
      }
export function usePolicyDocumentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyDocumentTemplatesQuery, PolicyDocumentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyDocumentTemplatesQuery, PolicyDocumentTemplatesQueryVariables>(PolicyDocumentTemplatesDocument, options);
        }
export type PolicyDocumentTemplatesQueryHookResult = ReturnType<typeof usePolicyDocumentTemplatesQuery>;
export type PolicyDocumentTemplatesLazyQueryHookResult = ReturnType<typeof usePolicyDocumentTemplatesLazyQuery>;
export type PolicyDocumentTemplatesQueryResult = Apollo.QueryResult<PolicyDocumentTemplatesQuery, PolicyDocumentTemplatesQueryVariables>;
export const GetPolicyDocumentTemplateDocument = gql`
    query getPolicyDocumentTemplate($policyDocumentTemplateType: PolicyDocumentTemplateType!) {
  policyDocumentTemplate(type: $policyDocumentTemplateType) {
    title
    type
    subtitle
    sections {
      title
      templateHtml
      helperHtml
      id
      templateVars {
        value
        key
        recommendedValue
        optional
      }
    }
    id
  }
}
    `;

/**
 * __useGetPolicyDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetPolicyDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyDocumentTemplateQuery({
 *   variables: {
 *      policyDocumentTemplateType: // value for 'policyDocumentTemplateType'
 *   },
 * });
 */
export function useGetPolicyDocumentTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetPolicyDocumentTemplateQuery, GetPolicyDocumentTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPolicyDocumentTemplateQuery, GetPolicyDocumentTemplateQueryVariables>(GetPolicyDocumentTemplateDocument, options);
      }
export function useGetPolicyDocumentTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyDocumentTemplateQuery, GetPolicyDocumentTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPolicyDocumentTemplateQuery, GetPolicyDocumentTemplateQueryVariables>(GetPolicyDocumentTemplateDocument, options);
        }
export type GetPolicyDocumentTemplateQueryHookResult = ReturnType<typeof useGetPolicyDocumentTemplateQuery>;
export type GetPolicyDocumentTemplateLazyQueryHookResult = ReturnType<typeof useGetPolicyDocumentTemplateLazyQuery>;
export type GetPolicyDocumentTemplateQueryResult = Apollo.QueryResult<GetPolicyDocumentTemplateQuery, GetPolicyDocumentTemplateQueryVariables>;
export const PolicyDocumentsDocument = gql`
    query PolicyDocuments($first: Int, $last: Int) {
  policyDocuments(first: $first, last: $last) {
    totalCount
    pageInfo {
      startCursor
    }
    nodes {
      id
      documentId
      title
      colorHex
      iconImageUrl
      isDraft
      sourcePolicyDocumentId
      organization {
        id
        name
      }
      createdAt
      sections {
        htmlVars
      }
    }
  }
}
    `;

/**
 * __usePolicyDocumentsQuery__
 *
 * To run a query within a React component, call `usePolicyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePolicyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<PolicyDocumentsQuery, PolicyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyDocumentsQuery, PolicyDocumentsQueryVariables>(PolicyDocumentsDocument, options);
      }
export function usePolicyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyDocumentsQuery, PolicyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyDocumentsQuery, PolicyDocumentsQueryVariables>(PolicyDocumentsDocument, options);
        }
export type PolicyDocumentsQueryHookResult = ReturnType<typeof usePolicyDocumentsQuery>;
export type PolicyDocumentsLazyQueryHookResult = ReturnType<typeof usePolicyDocumentsLazyQuery>;
export type PolicyDocumentsQueryResult = Apollo.QueryResult<PolicyDocumentsQuery, PolicyDocumentsQueryVariables>;
export const RegisteredRiskDocument = gql`
    query RegisteredRisk($id: ID!, $organizationId: ID!) {
  registeredRisk(id: $id, organizationId: $organizationId) {
    acceptedAt
    createdAt
    description
    functionCategory
    id
    isMuted
    organization {
      id
    }
    rating
    resolvedAt
    riskComments {
      id
      text
      createdAt
      updatedAt
      registeredRisk {
        id
        title
        description
        rating
        functionCategory
        createdAt
        updatedAt
        organization {
          id
        }
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
    title
    updatedAt
    riskTemplate {
      templateShorthand
    }
  }
}
    `;

/**
 * __useRegisteredRiskQuery__
 *
 * To run a query within a React component, call `useRegisteredRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredRiskQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRegisteredRiskQuery(baseOptions: Apollo.QueryHookOptions<RegisteredRiskQuery, RegisteredRiskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredRiskQuery, RegisteredRiskQueryVariables>(RegisteredRiskDocument, options);
      }
export function useRegisteredRiskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredRiskQuery, RegisteredRiskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredRiskQuery, RegisteredRiskQueryVariables>(RegisteredRiskDocument, options);
        }
export type RegisteredRiskQueryHookResult = ReturnType<typeof useRegisteredRiskQuery>;
export type RegisteredRiskLazyQueryHookResult = ReturnType<typeof useRegisteredRiskLazyQuery>;
export type RegisteredRiskQueryResult = Apollo.QueryResult<RegisteredRiskQuery, RegisteredRiskQueryVariables>;
export const RegisteredRiskTaskDocument = gql`
    query RegisteredRiskTask($id: ID!) {
  registeredRiskTask(id: $id) {
    id
    title
    description
    createdAt
    updatedAt
    comments {
      id
      text
      createdAt
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useRegisteredRiskTaskQuery__
 *
 * To run a query within a React component, call `useRegisteredRiskTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredRiskTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredRiskTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisteredRiskTaskQuery(baseOptions: Apollo.QueryHookOptions<RegisteredRiskTaskQuery, RegisteredRiskTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredRiskTaskQuery, RegisteredRiskTaskQueryVariables>(RegisteredRiskTaskDocument, options);
      }
export function useRegisteredRiskTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredRiskTaskQuery, RegisteredRiskTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredRiskTaskQuery, RegisteredRiskTaskQueryVariables>(RegisteredRiskTaskDocument, options);
        }
export type RegisteredRiskTaskQueryHookResult = ReturnType<typeof useRegisteredRiskTaskQuery>;
export type RegisteredRiskTaskLazyQueryHookResult = ReturnType<typeof useRegisteredRiskTaskLazyQuery>;
export type RegisteredRiskTaskQueryResult = Apollo.QueryResult<RegisteredRiskTaskQuery, RegisteredRiskTaskQueryVariables>;
export const RegisteredRiskTasksDocument = gql`
    query RegisteredRiskTasks($registeredRiskId: ID!) {
  registeredRiskTasks(registeredRiskId: $registeredRiskId) {
    id
    title
    description
    createdAt
    updatedAt
    comments {
      id
      text
      createdAt
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useRegisteredRiskTasksQuery__
 *
 * To run a query within a React component, call `useRegisteredRiskTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredRiskTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredRiskTasksQuery({
 *   variables: {
 *      registeredRiskId: // value for 'registeredRiskId'
 *   },
 * });
 */
export function useRegisteredRiskTasksQuery(baseOptions: Apollo.QueryHookOptions<RegisteredRiskTasksQuery, RegisteredRiskTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredRiskTasksQuery, RegisteredRiskTasksQueryVariables>(RegisteredRiskTasksDocument, options);
      }
export function useRegisteredRiskTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredRiskTasksQuery, RegisteredRiskTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredRiskTasksQuery, RegisteredRiskTasksQueryVariables>(RegisteredRiskTasksDocument, options);
        }
export type RegisteredRiskTasksQueryHookResult = ReturnType<typeof useRegisteredRiskTasksQuery>;
export type RegisteredRiskTasksLazyQueryHookResult = ReturnType<typeof useRegisteredRiskTasksLazyQuery>;
export type RegisteredRiskTasksQueryResult = Apollo.QueryResult<RegisteredRiskTasksQuery, RegisteredRiskTasksQueryVariables>;
export const RegisteredRiskTemplatesDocument = gql`
    query RegisteredRiskTemplates {
  registeredRiskTemplates {
    id
    groupName
    title
    description
    rating
    functionCategory
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useRegisteredRiskTemplatesQuery__
 *
 * To run a query within a React component, call `useRegisteredRiskTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredRiskTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredRiskTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegisteredRiskTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<RegisteredRiskTemplatesQuery, RegisteredRiskTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredRiskTemplatesQuery, RegisteredRiskTemplatesQueryVariables>(RegisteredRiskTemplatesDocument, options);
      }
export function useRegisteredRiskTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredRiskTemplatesQuery, RegisteredRiskTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredRiskTemplatesQuery, RegisteredRiskTemplatesQueryVariables>(RegisteredRiskTemplatesDocument, options);
        }
export type RegisteredRiskTemplatesQueryHookResult = ReturnType<typeof useRegisteredRiskTemplatesQuery>;
export type RegisteredRiskTemplatesLazyQueryHookResult = ReturnType<typeof useRegisteredRiskTemplatesLazyQuery>;
export type RegisteredRiskTemplatesQueryResult = Apollo.QueryResult<RegisteredRiskTemplatesQuery, RegisteredRiskTemplatesQueryVariables>;
export const RegisteredRisksDocument = gql`
    query RegisteredRisks($filters: RegisteredRiskFilters, $sortField: RegisteredRiskSortField, $sortOrder: SortOrder, $limit: Int) {
  registeredRisks(
    filters: $filters
    sortField: $sortField
    sortOrder: $sortOrder
    limit: $limit
  ) {
    acceptedAt
    createdAt
    description
    functionCategory
    id
    organization {
      id
      name
    }
    riskTemplate {
      createdAt
      description
      functionCategory
      groupName
      id
      rating
      title
      updatedAt
      templateShorthand
      triggerConditions {
        condition
        createdAt
        id
        question {
          id
          question
          questionShorthand
          updatedAt
          createdAt
        }
        updatedAt
        riskTemplate {
          createdAt
          description
          functionCategory
          groupName
          id
          rating
          title
          updatedAt
          templateShorthand
        }
      }
      templateShorthand
    }
    isMuted
    organization {
      id
    }
    rating
    resolvedAt
    riskComments {
      id
      text
      createdAt
      updatedAt
      registeredRisk {
        id
        title
        description
        rating
        functionCategory
        createdAt
        updatedAt
        organization {
          id
        }
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
    tasks {
      id
      title
      description
      createdAt
      updatedAt
      comments {
        id
        text
        createdAt
        user {
          id
          firstName
          lastName
          imageUrl
        }
      }
    }
    title
    updatedAt
  }
}
    `;

/**
 * __useRegisteredRisksQuery__
 *
 * To run a query within a React component, call `useRegisteredRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredRisksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRegisteredRisksQuery(baseOptions?: Apollo.QueryHookOptions<RegisteredRisksQuery, RegisteredRisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredRisksQuery, RegisteredRisksQueryVariables>(RegisteredRisksDocument, options);
      }
export function useRegisteredRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredRisksQuery, RegisteredRisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredRisksQuery, RegisteredRisksQueryVariables>(RegisteredRisksDocument, options);
        }
export type RegisteredRisksQueryHookResult = ReturnType<typeof useRegisteredRisksQuery>;
export type RegisteredRisksLazyQueryHookResult = ReturnType<typeof useRegisteredRisksLazyQuery>;
export type RegisteredRisksQueryResult = Apollo.QueryResult<RegisteredRisksQuery, RegisteredRisksQueryVariables>;
export const RemoveDocumentDocument = gql`
    mutation RemoveDocument($id: ID!) {
  removeDocument(id: $id) {
    id
  }
}
    `;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<RemoveDocumentMutation, RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const RemoveExecutiveReportDocument = gql`
    mutation RemoveExecutiveReport($id: ID!) {
  removeExecutiveReport(id: $id) {
    id
  }
}
    `;
export type RemoveExecutiveReportMutationFn = Apollo.MutationFunction<RemoveExecutiveReportMutation, RemoveExecutiveReportMutationVariables>;

/**
 * __useRemoveExecutiveReportMutation__
 *
 * To run a mutation, you first call `useRemoveExecutiveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExecutiveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExecutiveReportMutation, { data, loading, error }] = useRemoveExecutiveReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExecutiveReportMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExecutiveReportMutation, RemoveExecutiveReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExecutiveReportMutation, RemoveExecutiveReportMutationVariables>(RemoveExecutiveReportDocument, options);
      }
export type RemoveExecutiveReportMutationHookResult = ReturnType<typeof useRemoveExecutiveReportMutation>;
export type RemoveExecutiveReportMutationResult = Apollo.MutationResult<RemoveExecutiveReportMutation>;
export type RemoveExecutiveReportMutationOptions = Apollo.BaseMutationOptions<RemoveExecutiveReportMutation, RemoveExecutiveReportMutationVariables>;
export const RemovePolicyDocumentDocument = gql`
    mutation RemovePolicyDocument($id: ID!) {
  removePolicyDocument(id: $id) {
    id
  }
}
    `;
export type RemovePolicyDocumentMutationFn = Apollo.MutationFunction<RemovePolicyDocumentMutation, RemovePolicyDocumentMutationVariables>;

/**
 * __useRemovePolicyDocumentMutation__
 *
 * To run a mutation, you first call `useRemovePolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePolicyDocumentMutation, { data, loading, error }] = useRemovePolicyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemovePolicyDocumentMutation, RemovePolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePolicyDocumentMutation, RemovePolicyDocumentMutationVariables>(RemovePolicyDocumentDocument, options);
      }
export type RemovePolicyDocumentMutationHookResult = ReturnType<typeof useRemovePolicyDocumentMutation>;
export type RemovePolicyDocumentMutationResult = Apollo.MutationResult<RemovePolicyDocumentMutation>;
export type RemovePolicyDocumentMutationOptions = Apollo.BaseMutationOptions<RemovePolicyDocumentMutation, RemovePolicyDocumentMutationVariables>;
export const RemoveRiskAssessmentDocumentDocument = gql`
    mutation RemoveRiskAssessmentDocument($id: ID!) {
  removeRiskAssessmentDocument(id: $id) {
    id
  }
}
    `;
export type RemoveRiskAssessmentDocumentMutationFn = Apollo.MutationFunction<RemoveRiskAssessmentDocumentMutation, RemoveRiskAssessmentDocumentMutationVariables>;

/**
 * __useRemoveRiskAssessmentDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveRiskAssessmentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRiskAssessmentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRiskAssessmentDocumentMutation, { data, loading, error }] = useRemoveRiskAssessmentDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRiskAssessmentDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRiskAssessmentDocumentMutation, RemoveRiskAssessmentDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRiskAssessmentDocumentMutation, RemoveRiskAssessmentDocumentMutationVariables>(RemoveRiskAssessmentDocumentDocument, options);
      }
export type RemoveRiskAssessmentDocumentMutationHookResult = ReturnType<typeof useRemoveRiskAssessmentDocumentMutation>;
export type RemoveRiskAssessmentDocumentMutationResult = Apollo.MutationResult<RemoveRiskAssessmentDocumentMutation>;
export type RemoveRiskAssessmentDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveRiskAssessmentDocumentMutation, RemoveRiskAssessmentDocumentMutationVariables>;
export const RemoveRiskRegistryAnswersDocument = gql`
    mutation RemoveRiskRegistryAnswers($answerIds: [ID]!, $notFromModals: Boolean) {
  removeRiskRegistryAnswers(answerIds: $answerIds, notFromModals: $notFromModals) {
    question {
      questionShorthand
    }
  }
}
    `;
export type RemoveRiskRegistryAnswersMutationFn = Apollo.MutationFunction<RemoveRiskRegistryAnswersMutation, RemoveRiskRegistryAnswersMutationVariables>;

/**
 * __useRemoveRiskRegistryAnswersMutation__
 *
 * To run a mutation, you first call `useRemoveRiskRegistryAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRiskRegistryAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRiskRegistryAnswersMutation, { data, loading, error }] = useRemoveRiskRegistryAnswersMutation({
 *   variables: {
 *      answerIds: // value for 'answerIds'
 *      notFromModals: // value for 'notFromModals'
 *   },
 * });
 */
export function useRemoveRiskRegistryAnswersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRiskRegistryAnswersMutation, RemoveRiskRegistryAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRiskRegistryAnswersMutation, RemoveRiskRegistryAnswersMutationVariables>(RemoveRiskRegistryAnswersDocument, options);
      }
export type RemoveRiskRegistryAnswersMutationHookResult = ReturnType<typeof useRemoveRiskRegistryAnswersMutation>;
export type RemoveRiskRegistryAnswersMutationResult = Apollo.MutationResult<RemoveRiskRegistryAnswersMutation>;
export type RemoveRiskRegistryAnswersMutationOptions = Apollo.BaseMutationOptions<RemoveRiskRegistryAnswersMutation, RemoveRiskRegistryAnswersMutationVariables>;
export const RiskAssessmentDocumentDocument = gql`
    query RiskAssessmentDocument($riskAssessmentDocumentId: ID!) {
  riskAssessmentDocument(id: $riskAssessmentDocumentId) {
    createdAt
    updatedAt
    completedAt
    status
    organization {
      name
    }
    risks {
      coreFunction
      createdAt
      updatedAt
      functionCategory
      id
      riskAssessmentDocument {
        organization {
          id
        }
      }
      rating
      title
      tasks {
        assignee {
          email
          firstName
          id
          imageUrl
          lastName
        }
        risk {
          id
        }
        createdAt
        description
        dueDate
        isComplete
        title
        updatedAt
        id
      }
    }
    sections {
      OrganizationalOversight {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      AccessControl {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      SystemDeploymentAndMaintenance {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      DataProtection {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      NetworkSecurity {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      SecurityLoggingAndMonitoring {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      RiskManagementStrategy {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      IncidentResponse {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
      BusinessContinuityAndDisasterRecovery {
        id
        code
        title
        questions {
          title
          code
          description
          options {
            code
            title
          }
          answer {
            code
            title
          }
          note
        }
      }
    }
  }
}
    `;

/**
 * __useRiskAssessmentDocumentQuery__
 *
 * To run a query within a React component, call `useRiskAssessmentDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskAssessmentDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskAssessmentDocumentQuery({
 *   variables: {
 *      riskAssessmentDocumentId: // value for 'riskAssessmentDocumentId'
 *   },
 * });
 */
export function useRiskAssessmentDocumentQuery(baseOptions: Apollo.QueryHookOptions<RiskAssessmentDocumentQuery, RiskAssessmentDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskAssessmentDocumentQuery, RiskAssessmentDocumentQueryVariables>(RiskAssessmentDocumentDocument, options);
      }
export function useRiskAssessmentDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskAssessmentDocumentQuery, RiskAssessmentDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskAssessmentDocumentQuery, RiskAssessmentDocumentQueryVariables>(RiskAssessmentDocumentDocument, options);
        }
export type RiskAssessmentDocumentQueryHookResult = ReturnType<typeof useRiskAssessmentDocumentQuery>;
export type RiskAssessmentDocumentLazyQueryHookResult = ReturnType<typeof useRiskAssessmentDocumentLazyQuery>;
export type RiskAssessmentDocumentQueryResult = Apollo.QueryResult<RiskAssessmentDocumentQuery, RiskAssessmentDocumentQueryVariables>;
export const GetRiskAssessmentDocumentsDocument = gql`
    query getRiskAssessmentDocuments($first: Int, $last: Int, $filter: RiskAssessmentDocumentFilter, $sortBy: RiskAssessmentDocumentFieldSortFieldEnum) {
  riskAssessmentDocuments(
    first: $first
    last: $last
    filter: $filter
    sortField: $sortBy
  ) {
    totalCount
    nodes {
      id
      isDraft
      status
      createdAt
      document {
        id
      }
      organization {
        id
        name
      }
      risks {
        id
        title
        coreFunction
        functionCategory
        rating
        tasks {
          id
          title
          dueDate
          isComplete
          completedAt
          description
          assignee {
            id
            firstName
            lastName
            imageUrl
          }
          comments {
            id
            text
            createdAt
            user {
              id
              firstName
              lastName
              imageUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRiskAssessmentDocumentsQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetRiskAssessmentDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentDocumentsQuery, GetRiskAssessmentDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentDocumentsQuery, GetRiskAssessmentDocumentsQueryVariables>(GetRiskAssessmentDocumentsDocument, options);
      }
export function useGetRiskAssessmentDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentDocumentsQuery, GetRiskAssessmentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentDocumentsQuery, GetRiskAssessmentDocumentsQueryVariables>(GetRiskAssessmentDocumentsDocument, options);
        }
export type GetRiskAssessmentDocumentsQueryHookResult = ReturnType<typeof useGetRiskAssessmentDocumentsQuery>;
export type GetRiskAssessmentDocumentsLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentDocumentsLazyQuery>;
export type GetRiskAssessmentDocumentsQueryResult = Apollo.QueryResult<GetRiskAssessmentDocumentsQuery, GetRiskAssessmentDocumentsQueryVariables>;
export const GetRiskAssessmentTemplatesDocument = gql`
    query getRiskAssessmentTemplates {
  riskAssessmentTemplates {
    sections {
      OrganizationalOversight {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      AccessControl {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      SystemDeploymentAndMaintenance {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      DataProtection {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      NetworkSecurity {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      SecurityLoggingAndMonitoring {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      RiskManagementStrategy {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      IncidentResponse {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
      BusinessContinuityAndDisasterRecovery {
        code
        id
        helperHtml
        questions {
          title
          options {
            title
            code
          }
          description
          code
          coreFunction
          functionCategory
        }
        title
      }
    }
  }
}
    `;

/**
 * __useGetRiskAssessmentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRiskAssessmentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentTemplatesQuery, GetRiskAssessmentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentTemplatesQuery, GetRiskAssessmentTemplatesQueryVariables>(GetRiskAssessmentTemplatesDocument, options);
      }
export function useGetRiskAssessmentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentTemplatesQuery, GetRiskAssessmentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentTemplatesQuery, GetRiskAssessmentTemplatesQueryVariables>(GetRiskAssessmentTemplatesDocument, options);
        }
export type GetRiskAssessmentTemplatesQueryHookResult = ReturnType<typeof useGetRiskAssessmentTemplatesQuery>;
export type GetRiskAssessmentTemplatesLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentTemplatesLazyQuery>;
export type GetRiskAssessmentTemplatesQueryResult = Apollo.QueryResult<GetRiskAssessmentTemplatesQuery, GetRiskAssessmentTemplatesQueryVariables>;
export const RiskRegistryAnswersDocument = gql`
    query RiskRegistryAnswers($organizationId: ID!) {
  riskRegistryAnswers(organizationId: $organizationId) {
    answer
    question {
      questionShorthand
    }
    expiresAt
  }
}
    `;

/**
 * __useRiskRegistryAnswersQuery__
 *
 * To run a query within a React component, call `useRiskRegistryAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskRegistryAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskRegistryAnswersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRiskRegistryAnswersQuery(baseOptions: Apollo.QueryHookOptions<RiskRegistryAnswersQuery, RiskRegistryAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskRegistryAnswersQuery, RiskRegistryAnswersQueryVariables>(RiskRegistryAnswersDocument, options);
      }
export function useRiskRegistryAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskRegistryAnswersQuery, RiskRegistryAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskRegistryAnswersQuery, RiskRegistryAnswersQueryVariables>(RiskRegistryAnswersDocument, options);
        }
export type RiskRegistryAnswersQueryHookResult = ReturnType<typeof useRiskRegistryAnswersQuery>;
export type RiskRegistryAnswersLazyQueryHookResult = ReturnType<typeof useRiskRegistryAnswersLazyQuery>;
export type RiskRegistryAnswersQueryResult = Apollo.QueryResult<RiskRegistryAnswersQuery, RiskRegistryAnswersQueryVariables>;
export const RoadmapDocument = gql`
    query Roadmap($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    roadmap {
      WrittenInformationSecurityProgram {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      WrittenRiskAssessment {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      SecurityAwarenessProgram {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      OverseeServiceProviders {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      AccessControl {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      TechnicalRequirements {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      SecurityTesting {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      DevelopResponsePlan {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
      ExecutiveReporting {
        acknowledgementItems {
          title
        }
        actionItems {
          title
          type
        }
      }
    }
  }
}
    `;

/**
 * __useRoadmapQuery__
 *
 * To run a query within a React component, call `useRoadmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRoadmapQuery(baseOptions: Apollo.QueryHookOptions<RoadmapQuery, RoadmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoadmapQuery, RoadmapQueryVariables>(RoadmapDocument, options);
      }
export function useRoadmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoadmapQuery, RoadmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoadmapQuery, RoadmapQueryVariables>(RoadmapDocument, options);
        }
export type RoadmapQueryHookResult = ReturnType<typeof useRoadmapQuery>;
export type RoadmapLazyQueryHookResult = ReturnType<typeof useRoadmapLazyQuery>;
export type RoadmapQueryResult = Apollo.QueryResult<RoadmapQuery, RoadmapQueryVariables>;
export const OrganizationRoadmapsDocument = gql`
    query OrganizationRoadmaps($organizationIds: [ID!]!) {
  organizations(organizationIds: $organizationIds) {
    id
    name
    roadmap {
      WrittenInformationSecurityProgram {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          data {
            policyDocument {
              id
              isDraft
              sourcePolicyDocumentId
              documentId
            }
            templateType
          }
          message
          title
        }
      }
      WrittenRiskAssessment {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          data {
            riskAssessment {
              id
              isDraft
            }
          }
          message
          title
        }
      }
      SecurityAwarenessProgram {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          title
          message
        }
      }
      OverseeServiceProviders {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          data {
            vendorOrganization {
              id
            }
            vendorRequest {
              id
            }
          }
          message
          title
        }
      }
      AccessControl {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          message
          title
        }
      }
      TechnicalRequirements {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          data {
            riskAssessment {
              id
              isDraft
            }
          }
          message
          title
        }
      }
      SecurityTesting {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          message
          title
        }
      }
      DevelopResponsePlan {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          title
          message
          data {
            policyDocument {
              id
              isDraft
              sourcePolicyDocumentId
            }
            templateType
          }
        }
      }
      ExecutiveReporting {
        acknowledgementItems {
          completedAt
          createdAt
          id
          message
          title
        }
        actionItems {
          type
          data {
            executiveReport {
              id
              isDraft
            }
          }
          message
          title
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationRoadmapsQuery__
 *
 * To run a query within a React component, call `useOrganizationRoadmapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRoadmapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRoadmapsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useOrganizationRoadmapsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationRoadmapsQuery, OrganizationRoadmapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationRoadmapsQuery, OrganizationRoadmapsQueryVariables>(OrganizationRoadmapsDocument, options);
      }
export function useOrganizationRoadmapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRoadmapsQuery, OrganizationRoadmapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationRoadmapsQuery, OrganizationRoadmapsQueryVariables>(OrganizationRoadmapsDocument, options);
        }
export type OrganizationRoadmapsQueryHookResult = ReturnType<typeof useOrganizationRoadmapsQuery>;
export type OrganizationRoadmapsLazyQueryHookResult = ReturnType<typeof useOrganizationRoadmapsLazyQuery>;
export type OrganizationRoadmapsQueryResult = Apollo.QueryResult<OrganizationRoadmapsQuery, OrganizationRoadmapsQueryVariables>;
export const SearchVendorsDocument = gql`
    query SearchVendors($businessName: String) {
  searchVendors(businessName: $businessName) {
    id
    businessName
    hasDefaultContact
  }
}
    `;

/**
 * __useSearchVendorsQuery__
 *
 * To run a query within a React component, call `useSearchVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVendorsQuery({
 *   variables: {
 *      businessName: // value for 'businessName'
 *   },
 * });
 */
export function useSearchVendorsQuery(baseOptions?: Apollo.QueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVendorsQuery, SearchVendorsQueryVariables>(SearchVendorsDocument, options);
      }
export function useSearchVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVendorsQuery, SearchVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVendorsQuery, SearchVendorsQueryVariables>(SearchVendorsDocument, options);
        }
export type SearchVendorsQueryHookResult = ReturnType<typeof useSearchVendorsQuery>;
export type SearchVendorsLazyQueryHookResult = ReturnType<typeof useSearchVendorsLazyQuery>;
export type SearchVendorsQueryResult = Apollo.QueryResult<SearchVendorsQuery, SearchVendorsQueryVariables>;
export const SendVendorRequestReminderEmailDocument = gql`
    mutation SendVendorRequestReminderEmail($vendorRequestId: ID!) {
  sendVendorRequestReminderEmail(vendorRequestId: $vendorRequestId) {
    id
  }
}
    `;
export type SendVendorRequestReminderEmailMutationFn = Apollo.MutationFunction<SendVendorRequestReminderEmailMutation, SendVendorRequestReminderEmailMutationVariables>;

/**
 * __useSendVendorRequestReminderEmailMutation__
 *
 * To run a mutation, you first call `useSendVendorRequestReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVendorRequestReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVendorRequestReminderEmailMutation, { data, loading, error }] = useSendVendorRequestReminderEmailMutation({
 *   variables: {
 *      vendorRequestId: // value for 'vendorRequestId'
 *   },
 * });
 */
export function useSendVendorRequestReminderEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVendorRequestReminderEmailMutation, SendVendorRequestReminderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVendorRequestReminderEmailMutation, SendVendorRequestReminderEmailMutationVariables>(SendVendorRequestReminderEmailDocument, options);
      }
export type SendVendorRequestReminderEmailMutationHookResult = ReturnType<typeof useSendVendorRequestReminderEmailMutation>;
export type SendVendorRequestReminderEmailMutationResult = Apollo.MutationResult<SendVendorRequestReminderEmailMutation>;
export type SendVendorRequestReminderEmailMutationOptions = Apollo.BaseMutationOptions<SendVendorRequestReminderEmailMutation, SendVendorRequestReminderEmailMutationVariables>;
export const SentinelOneResponseDocument = gql`
    query SentinelOneResponse($organizationId: ID!) {
  sentinelOneResponse(organizationId: $organizationId) {
    apiType
    response
    organization {
      id
      name
    }
    lastUpdatedAt
  }
  knowBe4Response(organizationId: $organizationId) {
    apiType
    response
    organization {
      id
      name
    }
    lastUpdatedAt
  }
}
    `;

/**
 * __useSentinelOneResponseQuery__
 *
 * To run a query within a React component, call `useSentinelOneResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentinelOneResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentinelOneResponseQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSentinelOneResponseQuery(baseOptions: Apollo.QueryHookOptions<SentinelOneResponseQuery, SentinelOneResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentinelOneResponseQuery, SentinelOneResponseQueryVariables>(SentinelOneResponseDocument, options);
      }
export function useSentinelOneResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentinelOneResponseQuery, SentinelOneResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentinelOneResponseQuery, SentinelOneResponseQueryVariables>(SentinelOneResponseDocument, options);
        }
export type SentinelOneResponseQueryHookResult = ReturnType<typeof useSentinelOneResponseQuery>;
export type SentinelOneResponseLazyQueryHookResult = ReturnType<typeof useSentinelOneResponseLazyQuery>;
export type SentinelOneResponseQueryResult = Apollo.QueryResult<SentinelOneResponseQuery, SentinelOneResponseQueryVariables>;
export const SetAcknowledgementItemStatusDocument = gql`
    mutation SetAcknowledgementItemStatus($id: ID!, $status: AcknowledgementItemStatus!) {
  setAcknowledgementItemStatus(id: $id, status: $status) {
    id
  }
}
    `;
export type SetAcknowledgementItemStatusMutationFn = Apollo.MutationFunction<SetAcknowledgementItemStatusMutation, SetAcknowledgementItemStatusMutationVariables>;

/**
 * __useSetAcknowledgementItemStatusMutation__
 *
 * To run a mutation, you first call `useSetAcknowledgementItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAcknowledgementItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAcknowledgementItemStatusMutation, { data, loading, error }] = useSetAcknowledgementItemStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetAcknowledgementItemStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetAcknowledgementItemStatusMutation, SetAcknowledgementItemStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAcknowledgementItemStatusMutation, SetAcknowledgementItemStatusMutationVariables>(SetAcknowledgementItemStatusDocument, options);
      }
export type SetAcknowledgementItemStatusMutationHookResult = ReturnType<typeof useSetAcknowledgementItemStatusMutation>;
export type SetAcknowledgementItemStatusMutationResult = Apollo.MutationResult<SetAcknowledgementItemStatusMutation>;
export type SetAcknowledgementItemStatusMutationOptions = Apollo.BaseMutationOptions<SetAcknowledgementItemStatusMutation, SetAcknowledgementItemStatusMutationVariables>;
export const SetDocumentArchivedAtDocument = gql`
    mutation SetDocumentArchivedAt($id: ID!, $archivedAt: Date!) {
  setDocumentArchivedAt(id: $id, archivedAt: $archivedAt) {
    id
  }
}
    `;
export type SetDocumentArchivedAtMutationFn = Apollo.MutationFunction<SetDocumentArchivedAtMutation, SetDocumentArchivedAtMutationVariables>;

/**
 * __useSetDocumentArchivedAtMutation__
 *
 * To run a mutation, you first call `useSetDocumentArchivedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentArchivedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentArchivedAtMutation, { data, loading, error }] = useSetDocumentArchivedAtMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useSetDocumentArchivedAtMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentArchivedAtMutation, SetDocumentArchivedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentArchivedAtMutation, SetDocumentArchivedAtMutationVariables>(SetDocumentArchivedAtDocument, options);
      }
export type SetDocumentArchivedAtMutationHookResult = ReturnType<typeof useSetDocumentArchivedAtMutation>;
export type SetDocumentArchivedAtMutationResult = Apollo.MutationResult<SetDocumentArchivedAtMutation>;
export type SetDocumentArchivedAtMutationOptions = Apollo.BaseMutationOptions<SetDocumentArchivedAtMutation, SetDocumentArchivedAtMutationVariables>;
export const SetDocumentDescriptionDocument = gql`
    mutation setDocumentDescription($id: ID!, $description: String!) {
  setDocumentDescription(id: $id, description: $description) {
    id
  }
}
    `;
export type SetDocumentDescriptionMutationFn = Apollo.MutationFunction<SetDocumentDescriptionMutation, SetDocumentDescriptionMutationVariables>;

/**
 * __useSetDocumentDescriptionMutation__
 *
 * To run a mutation, you first call `useSetDocumentDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentDescriptionMutation, { data, loading, error }] = useSetDocumentDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetDocumentDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentDescriptionMutation, SetDocumentDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentDescriptionMutation, SetDocumentDescriptionMutationVariables>(SetDocumentDescriptionDocument, options);
      }
export type SetDocumentDescriptionMutationHookResult = ReturnType<typeof useSetDocumentDescriptionMutation>;
export type SetDocumentDescriptionMutationResult = Apollo.MutationResult<SetDocumentDescriptionMutation>;
export type SetDocumentDescriptionMutationOptions = Apollo.BaseMutationOptions<SetDocumentDescriptionMutation, SetDocumentDescriptionMutationVariables>;
export const SetVendorRequestReviewStatusDocument = gql`
    mutation SetVendorRequestReviewStatus($vendorRequestId: ID!, $isReviewed: Boolean!) {
  setVendorRequestReviewStatus(
    vendorRequestId: $vendorRequestId
    isReviewed: $isReviewed
  ) {
    id
  }
}
    `;
export type SetVendorRequestReviewStatusMutationFn = Apollo.MutationFunction<SetVendorRequestReviewStatusMutation, SetVendorRequestReviewStatusMutationVariables>;

/**
 * __useSetVendorRequestReviewStatusMutation__
 *
 * To run a mutation, you first call `useSetVendorRequestReviewStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVendorRequestReviewStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVendorRequestReviewStatusMutation, { data, loading, error }] = useSetVendorRequestReviewStatusMutation({
 *   variables: {
 *      vendorRequestId: // value for 'vendorRequestId'
 *      isReviewed: // value for 'isReviewed'
 *   },
 * });
 */
export function useSetVendorRequestReviewStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetVendorRequestReviewStatusMutation, SetVendorRequestReviewStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVendorRequestReviewStatusMutation, SetVendorRequestReviewStatusMutationVariables>(SetVendorRequestReviewStatusDocument, options);
      }
export type SetVendorRequestReviewStatusMutationHookResult = ReturnType<typeof useSetVendorRequestReviewStatusMutation>;
export type SetVendorRequestReviewStatusMutationResult = Apollo.MutationResult<SetVendorRequestReviewStatusMutation>;
export type SetVendorRequestReviewStatusMutationOptions = Apollo.BaseMutationOptions<SetVendorRequestReviewStatusMutation, SetVendorRequestReviewStatusMutationVariables>;
export const TaskCommentsDocument = gql`
    query TaskComments($taskId: ID!) {
  taskComments(taskId: $taskId) {
    id
    text
    createdAt
    user {
      id
      firstName
      lastName
      imageUrl
    }
  }
}
    `;

/**
 * __useTaskCommentsQuery__
 *
 * To run a query within a React component, call `useTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCommentsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskCommentsQuery(baseOptions: Apollo.QueryHookOptions<TaskCommentsQuery, TaskCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCommentsQuery, TaskCommentsQueryVariables>(TaskCommentsDocument, options);
      }
export function useTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCommentsQuery, TaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCommentsQuery, TaskCommentsQueryVariables>(TaskCommentsDocument, options);
        }
export type TaskCommentsQueryHookResult = ReturnType<typeof useTaskCommentsQuery>;
export type TaskCommentsLazyQueryHookResult = ReturnType<typeof useTaskCommentsLazyQuery>;
export type TaskCommentsQueryResult = Apollo.QueryResult<TaskCommentsQuery, TaskCommentsQueryVariables>;
export const UpdateAutomationSettingsDocument = gql`
    mutation UpdateAutomationSettings($id: ID!, $automationSettings: UpdateAutomationSettingsInput!) {
  updateAutomationSettings(id: $id, automationSettings: $automationSettings) {
    id
  }
}
    `;
export type UpdateAutomationSettingsMutationFn = Apollo.MutationFunction<UpdateAutomationSettingsMutation, UpdateAutomationSettingsMutationVariables>;

/**
 * __useUpdateAutomationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationSettingsMutation, { data, loading, error }] = useUpdateAutomationSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      automationSettings: // value for 'automationSettings'
 *   },
 * });
 */
export function useUpdateAutomationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationSettingsMutation, UpdateAutomationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationSettingsMutation, UpdateAutomationSettingsMutationVariables>(UpdateAutomationSettingsDocument, options);
      }
export type UpdateAutomationSettingsMutationHookResult = ReturnType<typeof useUpdateAutomationSettingsMutation>;
export type UpdateAutomationSettingsMutationResult = Apollo.MutationResult<UpdateAutomationSettingsMutation>;
export type UpdateAutomationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationSettingsMutation, UpdateAutomationSettingsMutationVariables>;
export const UpdateOrganizationNotificationSettingsDocument = gql`
    mutation UpdateOrganizationNotificationSettings($organizationId: ID!, $updatedNotificationSettings: NotificationSettingsInput!) {
  updateOrganizationNotificationSettings(
    organizationId: $organizationId
    updatedNotificationSettings: $updatedNotificationSettings
  ) {
    id
  }
}
    `;
export type UpdateOrganizationNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationNotificationSettingsMutation, UpdateOrganizationNotificationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationNotificationSettingsMutation, { data, loading, error }] = useUpdateOrganizationNotificationSettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      updatedNotificationSettings: // value for 'updatedNotificationSettings'
 *   },
 * });
 */
export function useUpdateOrganizationNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationNotificationSettingsMutation, UpdateOrganizationNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationNotificationSettingsMutation, UpdateOrganizationNotificationSettingsMutationVariables>(UpdateOrganizationNotificationSettingsDocument, options);
      }
export type UpdateOrganizationNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationNotificationSettingsMutation>;
export type UpdateOrganizationNotificationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationNotificationSettingsMutation>;
export type UpdateOrganizationNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationNotificationSettingsMutation, UpdateOrganizationNotificationSettingsMutationVariables>;
export const UpdateRegisteredRiskAcceptedAtDocument = gql`
    mutation UpdateRegisteredRiskAcceptedAt($registeredRiskId: ID!, $date: Date) {
  updateRegisteredRiskAcceptedAt(registeredRiskId: $registeredRiskId, date: $date) {
    acceptedAt
    archivedAt
    createdAt
    description
    functionCategory
    id
    isMuted
    organization {
      id
    }
    rating
    resolvedAt
    title
    updatedAt
    riskComments {
      id
      text
      createdAt
      updatedAt
      registeredRisk {
        id
        title
        description
        rating
        functionCategory
        createdAt
        updatedAt
        organization {
          id
        }
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;
export type UpdateRegisteredRiskAcceptedAtMutationFn = Apollo.MutationFunction<UpdateRegisteredRiskAcceptedAtMutation, UpdateRegisteredRiskAcceptedAtMutationVariables>;

/**
 * __useUpdateRegisteredRiskAcceptedAtMutation__
 *
 * To run a mutation, you first call `useUpdateRegisteredRiskAcceptedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisteredRiskAcceptedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisteredRiskAcceptedAtMutation, { data, loading, error }] = useUpdateRegisteredRiskAcceptedAtMutation({
 *   variables: {
 *      registeredRiskId: // value for 'registeredRiskId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateRegisteredRiskAcceptedAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisteredRiskAcceptedAtMutation, UpdateRegisteredRiskAcceptedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegisteredRiskAcceptedAtMutation, UpdateRegisteredRiskAcceptedAtMutationVariables>(UpdateRegisteredRiskAcceptedAtDocument, options);
      }
export type UpdateRegisteredRiskAcceptedAtMutationHookResult = ReturnType<typeof useUpdateRegisteredRiskAcceptedAtMutation>;
export type UpdateRegisteredRiskAcceptedAtMutationResult = Apollo.MutationResult<UpdateRegisteredRiskAcceptedAtMutation>;
export type UpdateRegisteredRiskAcceptedAtMutationOptions = Apollo.BaseMutationOptions<UpdateRegisteredRiskAcceptedAtMutation, UpdateRegisteredRiskAcceptedAtMutationVariables>;
export const UpdateRegisteredRiskResolvedAtDocument = gql`
    mutation UpdateRegisteredRiskResolvedAt($registeredRiskId: ID!, $date: Date) {
  updateRegisteredRiskResolvedAt(registeredRiskId: $registeredRiskId, date: $date) {
    acceptedAt
    archivedAt
    createdAt
    description
    functionCategory
    id
    isMuted
    organization {
      id
    }
    rating
    resolvedAt
    title
    updatedAt
    riskComments {
      id
      text
      createdAt
      updatedAt
      registeredRisk {
        id
        title
        description
        rating
        functionCategory
        createdAt
        updatedAt
        organization {
          id
        }
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;
export type UpdateRegisteredRiskResolvedAtMutationFn = Apollo.MutationFunction<UpdateRegisteredRiskResolvedAtMutation, UpdateRegisteredRiskResolvedAtMutationVariables>;

/**
 * __useUpdateRegisteredRiskResolvedAtMutation__
 *
 * To run a mutation, you first call `useUpdateRegisteredRiskResolvedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisteredRiskResolvedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisteredRiskResolvedAtMutation, { data, loading, error }] = useUpdateRegisteredRiskResolvedAtMutation({
 *   variables: {
 *      registeredRiskId: // value for 'registeredRiskId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateRegisteredRiskResolvedAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisteredRiskResolvedAtMutation, UpdateRegisteredRiskResolvedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegisteredRiskResolvedAtMutation, UpdateRegisteredRiskResolvedAtMutationVariables>(UpdateRegisteredRiskResolvedAtDocument, options);
      }
export type UpdateRegisteredRiskResolvedAtMutationHookResult = ReturnType<typeof useUpdateRegisteredRiskResolvedAtMutation>;
export type UpdateRegisteredRiskResolvedAtMutationResult = Apollo.MutationResult<UpdateRegisteredRiskResolvedAtMutation>;
export type UpdateRegisteredRiskResolvedAtMutationOptions = Apollo.BaseMutationOptions<UpdateRegisteredRiskResolvedAtMutation, UpdateRegisteredRiskResolvedAtMutationVariables>;
export const DeleteRegisteredRiskDocument = gql`
    mutation DeleteRegisteredRisk($registeredRiskId: ID!) {
  deleteRegisteredRisk(registeredRiskId: $registeredRiskId) {
    id
  }
}
    `;
export type DeleteRegisteredRiskMutationFn = Apollo.MutationFunction<DeleteRegisteredRiskMutation, DeleteRegisteredRiskMutationVariables>;

/**
 * __useDeleteRegisteredRiskMutation__
 *
 * To run a mutation, you first call `useDeleteRegisteredRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegisteredRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegisteredRiskMutation, { data, loading, error }] = useDeleteRegisteredRiskMutation({
 *   variables: {
 *      registeredRiskId: // value for 'registeredRiskId'
 *   },
 * });
 */
export function useDeleteRegisteredRiskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegisteredRiskMutation, DeleteRegisteredRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegisteredRiskMutation, DeleteRegisteredRiskMutationVariables>(DeleteRegisteredRiskDocument, options);
      }
export type DeleteRegisteredRiskMutationHookResult = ReturnType<typeof useDeleteRegisteredRiskMutation>;
export type DeleteRegisteredRiskMutationResult = Apollo.MutationResult<DeleteRegisteredRiskMutation>;
export type DeleteRegisteredRiskMutationOptions = Apollo.BaseMutationOptions<DeleteRegisteredRiskMutation, DeleteRegisteredRiskMutationVariables>;
export const UpdateRegisteredRiskDocument = gql`
    mutation UpdateRegisteredRisk($input: UpdateRegisteredRiskInput) {
  updateRegisteredRisk(input: $input) {
    acceptedAt
    archivedAt
    createdAt
    description
    functionCategory
    id
    isMuted
    organization {
      id
    }
    rating
    resolvedAt
    title
    updatedAt
    riskComments {
      id
      text
      createdAt
      updatedAt
      registeredRisk {
        id
        title
        description
        rating
        functionCategory
        createdAt
        updatedAt
        organization {
          id
        }
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;
export type UpdateRegisteredRiskMutationFn = Apollo.MutationFunction<UpdateRegisteredRiskMutation, UpdateRegisteredRiskMutationVariables>;

/**
 * __useUpdateRegisteredRiskMutation__
 *
 * To run a mutation, you first call `useUpdateRegisteredRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisteredRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisteredRiskMutation, { data, loading, error }] = useUpdateRegisteredRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegisteredRiskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisteredRiskMutation, UpdateRegisteredRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegisteredRiskMutation, UpdateRegisteredRiskMutationVariables>(UpdateRegisteredRiskDocument, options);
      }
export type UpdateRegisteredRiskMutationHookResult = ReturnType<typeof useUpdateRegisteredRiskMutation>;
export type UpdateRegisteredRiskMutationResult = Apollo.MutationResult<UpdateRegisteredRiskMutation>;
export type UpdateRegisteredRiskMutationOptions = Apollo.BaseMutationOptions<UpdateRegisteredRiskMutation, UpdateRegisteredRiskMutationVariables>;
export const UpdateRiskHeartbeatRecordsDocument = gql`
    mutation UpdateRiskHeartbeatRecords($organizationIds: [ID]!, $sentAt: Date!) {
  updateRiskHeartbeatRecords(organizationIds: $organizationIds, sentAt: $sentAt)
}
    `;
export type UpdateRiskHeartbeatRecordsMutationFn = Apollo.MutationFunction<UpdateRiskHeartbeatRecordsMutation, UpdateRiskHeartbeatRecordsMutationVariables>;

/**
 * __useUpdateRiskHeartbeatRecordsMutation__
 *
 * To run a mutation, you first call `useUpdateRiskHeartbeatRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskHeartbeatRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskHeartbeatRecordsMutation, { data, loading, error }] = useUpdateRiskHeartbeatRecordsMutation({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      sentAt: // value for 'sentAt'
 *   },
 * });
 */
export function useUpdateRiskHeartbeatRecordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskHeartbeatRecordsMutation, UpdateRiskHeartbeatRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskHeartbeatRecordsMutation, UpdateRiskHeartbeatRecordsMutationVariables>(UpdateRiskHeartbeatRecordsDocument, options);
      }
export type UpdateRiskHeartbeatRecordsMutationHookResult = ReturnType<typeof useUpdateRiskHeartbeatRecordsMutation>;
export type UpdateRiskHeartbeatRecordsMutationResult = Apollo.MutationResult<UpdateRiskHeartbeatRecordsMutation>;
export type UpdateRiskHeartbeatRecordsMutationOptions = Apollo.BaseMutationOptions<UpdateRiskHeartbeatRecordsMutation, UpdateRiskHeartbeatRecordsMutationVariables>;
export const UpdateRiskRegistryAnswersDocument = gql`
    mutation UpdateRiskRegistryAnswers($organizationId: ID!, $answers: [UpdateRiskRegistryAnswerInput]!, $notFromModals: Boolean) {
  updateRiskRegistryAnswers(
    organizationId: $organizationId
    answers: $answers
    notFromModals: $notFromModals
  ) {
    id
  }
}
    `;
export type UpdateRiskRegistryAnswersMutationFn = Apollo.MutationFunction<UpdateRiskRegistryAnswersMutation, UpdateRiskRegistryAnswersMutationVariables>;

/**
 * __useUpdateRiskRegistryAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateRiskRegistryAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskRegistryAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskRegistryAnswersMutation, { data, loading, error }] = useUpdateRiskRegistryAnswersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      answers: // value for 'answers'
 *      notFromModals: // value for 'notFromModals'
 *   },
 * });
 */
export function useUpdateRiskRegistryAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskRegistryAnswersMutation, UpdateRiskRegistryAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskRegistryAnswersMutation, UpdateRiskRegistryAnswersMutationVariables>(UpdateRiskRegistryAnswersDocument, options);
      }
export type UpdateRiskRegistryAnswersMutationHookResult = ReturnType<typeof useUpdateRiskRegistryAnswersMutation>;
export type UpdateRiskRegistryAnswersMutationResult = Apollo.MutationResult<UpdateRiskRegistryAnswersMutation>;
export type UpdateRiskRegistryAnswersMutationOptions = Apollo.BaseMutationOptions<UpdateRiskRegistryAnswersMutation, UpdateRiskRegistryAnswersMutationVariables>;
export const SetTaskCompletionStatusDocument = gql`
    mutation SetTaskCompletionStatus($taskId: ID!, $isComplete: Boolean!) {
  setTaskCompletionStatus(taskId: $taskId, isComplete: $isComplete) {
    id
  }
}
    `;
export type SetTaskCompletionStatusMutationFn = Apollo.MutationFunction<SetTaskCompletionStatusMutation, SetTaskCompletionStatusMutationVariables>;

/**
 * __useSetTaskCompletionStatusMutation__
 *
 * To run a mutation, you first call `useSetTaskCompletionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskCompletionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskCompletionStatusMutation, { data, loading, error }] = useSetTaskCompletionStatusMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useSetTaskCompletionStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskCompletionStatusMutation, SetTaskCompletionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskCompletionStatusMutation, SetTaskCompletionStatusMutationVariables>(SetTaskCompletionStatusDocument, options);
      }
export type SetTaskCompletionStatusMutationHookResult = ReturnType<typeof useSetTaskCompletionStatusMutation>;
export type SetTaskCompletionStatusMutationResult = Apollo.MutationResult<SetTaskCompletionStatusMutation>;
export type SetTaskCompletionStatusMutationOptions = Apollo.BaseMutationOptions<SetTaskCompletionStatusMutation, SetTaskCompletionStatusMutationVariables>;
export const SetTasksCompletionStatusDocument = gql`
    mutation SetTasksCompletionStatus($riskId: ID!, $isComplete: Boolean!) {
  setTasksCompletionStatus(riskId: $riskId, isComplete: $isComplete) {
    id
  }
}
    `;
export type SetTasksCompletionStatusMutationFn = Apollo.MutationFunction<SetTasksCompletionStatusMutation, SetTasksCompletionStatusMutationVariables>;

/**
 * __useSetTasksCompletionStatusMutation__
 *
 * To run a mutation, you first call `useSetTasksCompletionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTasksCompletionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTasksCompletionStatusMutation, { data, loading, error }] = useSetTasksCompletionStatusMutation({
 *   variables: {
 *      riskId: // value for 'riskId'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useSetTasksCompletionStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTasksCompletionStatusMutation, SetTasksCompletionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTasksCompletionStatusMutation, SetTasksCompletionStatusMutationVariables>(SetTasksCompletionStatusDocument, options);
      }
export type SetTasksCompletionStatusMutationHookResult = ReturnType<typeof useSetTasksCompletionStatusMutation>;
export type SetTasksCompletionStatusMutationResult = Apollo.MutationResult<SetTasksCompletionStatusMutation>;
export type SetTasksCompletionStatusMutationOptions = Apollo.BaseMutationOptions<SetTasksCompletionStatusMutation, SetTasksCompletionStatusMutationVariables>;
export const SetTaskDescriptionDocument = gql`
    mutation SetTaskDescription($taskId: ID!, $description: String) {
  setDescriptionTask(taskId: $taskId, description: $description) {
    id
  }
}
    `;
export type SetTaskDescriptionMutationFn = Apollo.MutationFunction<SetTaskDescriptionMutation, SetTaskDescriptionMutationVariables>;

/**
 * __useSetTaskDescriptionMutation__
 *
 * To run a mutation, you first call `useSetTaskDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskDescriptionMutation, { data, loading, error }] = useSetTaskDescriptionMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetTaskDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskDescriptionMutation, SetTaskDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskDescriptionMutation, SetTaskDescriptionMutationVariables>(SetTaskDescriptionDocument, options);
      }
export type SetTaskDescriptionMutationHookResult = ReturnType<typeof useSetTaskDescriptionMutation>;
export type SetTaskDescriptionMutationResult = Apollo.MutationResult<SetTaskDescriptionMutation>;
export type SetTaskDescriptionMutationOptions = Apollo.BaseMutationOptions<SetTaskDescriptionMutation, SetTaskDescriptionMutationVariables>;
export const SetTaskAssigneeDocument = gql`
    mutation SetTaskAssignee($taskId: ID!, $assigneeId: UserID) {
  assignTask(taskId: $taskId, assigneeId: $assigneeId) {
    id
    assignee {
      id
    }
  }
}
    `;
export type SetTaskAssigneeMutationFn = Apollo.MutationFunction<SetTaskAssigneeMutation, SetTaskAssigneeMutationVariables>;

/**
 * __useSetTaskAssigneeMutation__
 *
 * To run a mutation, you first call `useSetTaskAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskAssigneeMutation, { data, loading, error }] = useSetTaskAssigneeMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useSetTaskAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskAssigneeMutation, SetTaskAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskAssigneeMutation, SetTaskAssigneeMutationVariables>(SetTaskAssigneeDocument, options);
      }
export type SetTaskAssigneeMutationHookResult = ReturnType<typeof useSetTaskAssigneeMutation>;
export type SetTaskAssigneeMutationResult = Apollo.MutationResult<SetTaskAssigneeMutation>;
export type SetTaskAssigneeMutationOptions = Apollo.BaseMutationOptions<SetTaskAssigneeMutation, SetTaskAssigneeMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($taskId: ID!, $description: String, $assigneeId: UserID, $title: String!, $dueDate: Date) {
  setTitleTask(taskId: $taskId, title: $title) {
    id
  }
  setDescriptionTask(taskId: $taskId, description: $description) {
    id
  }
  assignTask(taskId: $taskId, assigneeId: $assigneeId) {
    id
  }
  setDueDateTask(taskId: $taskId, date: $dueDate) {
    id
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      description: // value for 'description'
 *      assigneeId: // value for 'assigneeId'
 *      title: // value for 'title'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateVendorOrganizationDocument = gql`
    mutation UpdateVendorOrganization($updateVendorOrganizationParams: updateVendorOrganizationInput!) {
  updateVendorOrganization(
    updateVendorOrganizationParams: $updateVendorOrganizationParams
  ) {
    id
  }
}
    `;
export type UpdateVendorOrganizationMutationFn = Apollo.MutationFunction<UpdateVendorOrganizationMutation, UpdateVendorOrganizationMutationVariables>;

/**
 * __useUpdateVendorOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateVendorOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorOrganizationMutation, { data, loading, error }] = useUpdateVendorOrganizationMutation({
 *   variables: {
 *      updateVendorOrganizationParams: // value for 'updateVendorOrganizationParams'
 *   },
 * });
 */
export function useUpdateVendorOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorOrganizationMutation, UpdateVendorOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorOrganizationMutation, UpdateVendorOrganizationMutationVariables>(UpdateVendorOrganizationDocument, options);
      }
export type UpdateVendorOrganizationMutationHookResult = ReturnType<typeof useUpdateVendorOrganizationMutation>;
export type UpdateVendorOrganizationMutationResult = Apollo.MutationResult<UpdateVendorOrganizationMutation>;
export type UpdateVendorOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateVendorOrganizationMutation, UpdateVendorOrganizationMutationVariables>;
export const UpdateVendorRiskByGuidDocument = gql`
    mutation UpdateVendorRiskByGuid($vendorRisk: UpdateVendorRiskByGuidInput, $guid: String!) {
  updateVendorRiskByGuid(vendorRisk: $vendorRisk, guid: $guid) {
    id
  }
}
    `;
export type UpdateVendorRiskByGuidMutationFn = Apollo.MutationFunction<UpdateVendorRiskByGuidMutation, UpdateVendorRiskByGuidMutationVariables>;

/**
 * __useUpdateVendorRiskByGuidMutation__
 *
 * To run a mutation, you first call `useUpdateVendorRiskByGuidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorRiskByGuidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorRiskByGuidMutation, { data, loading, error }] = useUpdateVendorRiskByGuidMutation({
 *   variables: {
 *      vendorRisk: // value for 'vendorRisk'
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useUpdateVendorRiskByGuidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorRiskByGuidMutation, UpdateVendorRiskByGuidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorRiskByGuidMutation, UpdateVendorRiskByGuidMutationVariables>(UpdateVendorRiskByGuidDocument, options);
      }
export type UpdateVendorRiskByGuidMutationHookResult = ReturnType<typeof useUpdateVendorRiskByGuidMutation>;
export type UpdateVendorRiskByGuidMutationResult = Apollo.MutationResult<UpdateVendorRiskByGuidMutation>;
export type UpdateVendorRiskByGuidMutationOptions = Apollo.BaseMutationOptions<UpdateVendorRiskByGuidMutation, UpdateVendorRiskByGuidMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    disableOrgs
    organizations {
      id
      accountType
      name
      legalName
      addressLine1
      addressLine2
      state
      zip
      country
      paidSubscription
      city
      cif
      imageUrl
      phone
      modalsMutedAt
      createdAt
      updatedAt
      keyPersonnel {
        title
        name
      }
      userRoles {
        id
        owner
        createdAt
        updatedAt
      }
      owned
      onboardingUntil
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($user: UpdateUserInput) {
  updateMe(user: $user) {
    firstName
    lastName
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const VendorOrganizationDocument = gql`
    query VendorOrganization($vendorOrganizationId: ID!) {
  vendorOrganization(vendorOrganizationId: $vendorOrganizationId) {
    id
    createdAt
    contactEmail
    organization {
      id
      name
    }
    vendor {
      businessName
      businessAddress
    }
    lastVendorRequest {
      id
      status
      linkExpiredAt
    }
    vendorRequests {
      id
      createdAt
      completedAt
      deniedAt
      reviewedAt
      organization {
        id
      }
    }
    sharedData {
      consumerIdentityData {
        name
        homeAddress
        phone
        emailAddress
      }
      sensitiveConsumerData {
        ssn
        dateOfBirth
        driverLicenseNumber
      }
      consumerFinancialData {
        income
        financialAccountNumbers
        creditData
        paymentData
        employeeHistory
      }
      otherConsumerData {
        familialData
        insuranceData
        assets
        education
      }
    }
  }
}
    `;

/**
 * __useVendorOrganizationQuery__
 *
 * To run a query within a React component, call `useVendorOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrganizationQuery({
 *   variables: {
 *      vendorOrganizationId: // value for 'vendorOrganizationId'
 *   },
 * });
 */
export function useVendorOrganizationQuery(baseOptions: Apollo.QueryHookOptions<VendorOrganizationQuery, VendorOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorOrganizationQuery, VendorOrganizationQueryVariables>(VendorOrganizationDocument, options);
      }
export function useVendorOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorOrganizationQuery, VendorOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorOrganizationQuery, VendorOrganizationQueryVariables>(VendorOrganizationDocument, options);
        }
export type VendorOrganizationQueryHookResult = ReturnType<typeof useVendorOrganizationQuery>;
export type VendorOrganizationLazyQueryHookResult = ReturnType<typeof useVendorOrganizationLazyQuery>;
export type VendorOrganizationQueryResult = Apollo.QueryResult<VendorOrganizationQuery, VendorOrganizationQueryVariables>;
export const VendorOrganizationsDocument = gql`
    query VendorOrganizations($pageNumber: Int, $pageItemsCount: Int, $vendorOrganizationFilters: VendorOrganizationFilters, $sortFields: VendorOrganizationSortFields) {
  vendorOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    vendorOrganizationFilters: $vendorOrganizationFilters
    sortFields: $sortFields
  ) {
    nodes {
      id
      organization {
        id
        name
      }
      vendor {
        businessName
      }
      vendorRequests {
        id
        createdAt
        updatedAt
        sentAt
        openedAt
        startedAt
        completedAt
        deniedAt
        archivedAt
        reviewedAt
        linkExpiredAt
        deletedAt
        status
        vendorRisk {
          id
          status
          document {
            id
          }
          assessmentUrl
          expiredAt
        }
      }
    }
    pageInfo {
      startCursor
      hasNextPage
    }
    totalCount
  }
}
    `;

/**
 * __useVendorOrganizationsQuery__
 *
 * To run a query within a React component, call `useVendorOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrganizationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      vendorOrganizationFilters: // value for 'vendorOrganizationFilters'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useVendorOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<VendorOrganizationsQuery, VendorOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorOrganizationsQuery, VendorOrganizationsQueryVariables>(VendorOrganizationsDocument, options);
      }
export function useVendorOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorOrganizationsQuery, VendorOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorOrganizationsQuery, VendorOrganizationsQueryVariables>(VendorOrganizationsDocument, options);
        }
export type VendorOrganizationsQueryHookResult = ReturnType<typeof useVendorOrganizationsQuery>;
export type VendorOrganizationsLazyQueryHookResult = ReturnType<typeof useVendorOrganizationsLazyQuery>;
export type VendorOrganizationsQueryResult = Apollo.QueryResult<VendorOrganizationsQuery, VendorOrganizationsQueryVariables>;
export const VendorRequestDocument = gql`
    query VendorRequest($vendorRequestId: ID!) {
  vendorRequest(id: $vendorRequestId) {
    id
    reviewedAt
    deniedAt
    completedAt
    createdAt
    openedAt
    sentAt
    startedAt
    completedAt
    deniedAt
    reviewedAt
    vendorRisk {
      id
      assessmentUrl
      completedAt
      expiredAt
      vendor {
        businessName
      }
      document {
        id
        documentUrl
        title
      }
      data {
        stepState {
          vendorAgreementAnswers {
            maintainsSafeguardsForCustInfo
            hasNecessaryPrivacyDisclosure
            responsesCompleteAndTruthful
            isPersonAuthorizedToAnswer
          }
        }
        sections {
          title
          code
          questions {
            title
            code
            description
            options {
              title
              code
            }
            answer {
              title
              code
              otherText
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVendorRequestQuery__
 *
 * To run a query within a React component, call `useVendorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorRequestQuery({
 *   variables: {
 *      vendorRequestId: // value for 'vendorRequestId'
 *   },
 * });
 */
export function useVendorRequestQuery(baseOptions: Apollo.QueryHookOptions<VendorRequestQuery, VendorRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorRequestQuery, VendorRequestQueryVariables>(VendorRequestDocument, options);
      }
export function useVendorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorRequestQuery, VendorRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorRequestQuery, VendorRequestQueryVariables>(VendorRequestDocument, options);
        }
export type VendorRequestQueryHookResult = ReturnType<typeof useVendorRequestQuery>;
export type VendorRequestLazyQueryHookResult = ReturnType<typeof useVendorRequestLazyQuery>;
export type VendorRequestQueryResult = Apollo.QueryResult<VendorRequestQuery, VendorRequestQueryVariables>;
export const VendorRiskDocument = gql`
    query VendorRisk($vendorRiskId: ID!) {
  vendorRisk(id: $vendorRiskId) {
    assessmentUrl
    vendor {
      businessAddress
      businessName
    }
    organizations {
      name
    }
  }
}
    `;

/**
 * __useVendorRiskQuery__
 *
 * To run a query within a React component, call `useVendorRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorRiskQuery({
 *   variables: {
 *      vendorRiskId: // value for 'vendorRiskId'
 *   },
 * });
 */
export function useVendorRiskQuery(baseOptions: Apollo.QueryHookOptions<VendorRiskQuery, VendorRiskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorRiskQuery, VendorRiskQueryVariables>(VendorRiskDocument, options);
      }
export function useVendorRiskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorRiskQuery, VendorRiskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorRiskQuery, VendorRiskQueryVariables>(VendorRiskDocument, options);
        }
export type VendorRiskQueryHookResult = ReturnType<typeof useVendorRiskQuery>;
export type VendorRiskLazyQueryHookResult = ReturnType<typeof useVendorRiskLazyQuery>;
export type VendorRiskQueryResult = Apollo.QueryResult<VendorRiskQuery, VendorRiskQueryVariables>;
export const VendorRiskTemplatesDocument = gql`
    query VendorRiskTemplates($guid: String!) {
  vendorRiskTemplates(guid: $guid) {
    sections {
      id
      title
      code
      questions {
        title
        code
        description
        options {
          title
          code
        }
      }
    }
  }
}
    `;

/**
 * __useVendorRiskTemplatesQuery__
 *
 * To run a query within a React component, call `useVendorRiskTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorRiskTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorRiskTemplatesQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useVendorRiskTemplatesQuery(baseOptions: Apollo.QueryHookOptions<VendorRiskTemplatesQuery, VendorRiskTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorRiskTemplatesQuery, VendorRiskTemplatesQueryVariables>(VendorRiskTemplatesDocument, options);
      }
export function useVendorRiskTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorRiskTemplatesQuery, VendorRiskTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorRiskTemplatesQuery, VendorRiskTemplatesQueryVariables>(VendorRiskTemplatesDocument, options);
        }
export type VendorRiskTemplatesQueryHookResult = ReturnType<typeof useVendorRiskTemplatesQuery>;
export type VendorRiskTemplatesLazyQueryHookResult = ReturnType<typeof useVendorRiskTemplatesLazyQuery>;
export type VendorRiskTemplatesQueryResult = Apollo.QueryResult<VendorRiskTemplatesQuery, VendorRiskTemplatesQueryVariables>;
export const VendorRisksDocument = gql`
    query VendorRisks($before: String, $last: Int, $vendorRiskFilters: VendorRiskFilters, $vendorFilters: VendorFilters) {
  vendorRisks(
    before: $before
    last: $last
    vendorRiskFilters: $vendorRiskFilters
    vendorFilters: $vendorFilters
  ) {
    nodes {
      id
      document {
        id
      }
      organizations {
        id
        name
      }
      vendor {
        id
        businessName
      }
      createdAt
    }
    pageInfo {
      startCursor
      hasNextPage
    }
    totalCount
  }
}
    `;

/**
 * __useVendorRisksQuery__
 *
 * To run a query within a React component, call `useVendorRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorRisksQuery({
 *   variables: {
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      vendorRiskFilters: // value for 'vendorRiskFilters'
 *      vendorFilters: // value for 'vendorFilters'
 *   },
 * });
 */
export function useVendorRisksQuery(baseOptions?: Apollo.QueryHookOptions<VendorRisksQuery, VendorRisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorRisksQuery, VendorRisksQueryVariables>(VendorRisksDocument, options);
      }
export function useVendorRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorRisksQuery, VendorRisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorRisksQuery, VendorRisksQueryVariables>(VendorRisksDocument, options);
        }
export type VendorRisksQueryHookResult = ReturnType<typeof useVendorRisksQuery>;
export type VendorRisksLazyQueryHookResult = ReturnType<typeof useVendorRisksLazyQuery>;
export type VendorRisksQueryResult = Apollo.QueryResult<VendorRisksQuery, VendorRisksQueryVariables>;
export const VendorsDocument = gql`
    query Vendors($pageNumber: Int, $pageItemsCount: Int, $vendorFilters: VendorFilters, $sortField: VendorSortFieldEnum, $sortOrder: SortOrder) {
  vendors(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    vendorFilters: $vendorFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      businessName
      id
    }
  }
}
    `;

/**
 * __useVendorsQuery__
 *
 * To run a query within a React component, call `useVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      vendorFilters: // value for 'vendorFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useVendorsQuery(baseOptions?: Apollo.QueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
      }
export function useVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
        }
export type VendorsQueryHookResult = ReturnType<typeof useVendorsQuery>;
export type VendorsLazyQueryHookResult = ReturnType<typeof useVendorsLazyQuery>;
export type VendorsQueryResult = Apollo.QueryResult<VendorsQuery, VendorsQueryVariables>;